/* eslint-disable no-undef */
/*global google*/
import React from "react";
import {
  Button,
  Grid,
  Item,
  Image,
  // Icon,
} from "semantic-ui-react";
import PropTypes from "prop-types";
// import Router from "next/router";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { GoogleMapExample } from "../../pagecomponents/PresentationalComponent/GoogleMapWrapper";
// import SelectedNeighbourhood from "../../components/SelectedNeighbourhood";
// import cookie from "react-cookies";
import { gethomefilter } from "../../modules/Graphql/homefiltergraphql";
import {
  // addneighborboundries,
  // updateneighborboundries,
  // deleteneighborboundries,
  // getAllneighborboundrieslist,
  // getNeighborhoodcount,
  getSchoolinNh,
  getnhmapneighborboundrieslist,
  getDetailsNhboundrieslist,
} from "../../modules/Graphql/neighborhoodboundriesgraphql";
// import {
//   addgeocoordinate,
//   updategeocoordinate,
//   getAllgeocoordinate,
// } from "../../modules/Graphql/geocoordinategraphql";
// import {
//   addHome,
//   updateHome,
//   deleteHome,
//   getAllHomeList,
// } from "../../modules/Graphql/homegraphql";
// import {
//   addHomeImage,
//   updateHomeImage,
//   getAllHomeImageList,
// } from "../../modules/Graphql/homeimagegraphql";
import {
  // addSavedhomes,
  getAllSavedHomelist,
  // deleteSavedhomes,
} from "../../modules/Graphql/Savehomegraphql";
import { getSearchNeighbors } from "../../modules/Graphql/neighboraddressserachgraphql";
import axios from "axios";
import Link from "next/link";
import {
  getNHmaphomelist,
  getMlslistings,
  getListingsByIds,
  getMLSListingByAddress,
  getSlipstreamListings,
  getSlipStreamListngsByIds,
} from "../../modules/Graphql/Nhmaphomegraphql";
import { getAllSchoolList } from "../../modules/Graphql/schoolgraphql";
import { getAllUserList } from "../../modules/Graphql/usergraphql";
import { getAllsavedneighborhoodbyuserList } from "../../modules/Graphql/savedneighborhoodbyusergraphql";
import { getAllsavedncitybyuserList } from "../../modules/Graphql/savedcitybyusergraphql";
// import { getRecommendedNeighborhood } from "../../modules/Graphql/recommendedneighborhoodgraphql";
import { VscChromeClose } from "react-icons/vsc";
// import millify from "millify";
import { getCurrentUser } from "aws-amplify/auth";
// Amplify is configured in _app.js

import {
  get_converted_value,
  customdecodeURIComponent,
  get_npi_color,
  get_nvi_color,
  get_price_color,
  get_school_color,
  get_crime_color,
  get_walk_color,
  get_appreciation_color,
  get_all_amenties_color,
  formattedCityName,
  getOrderofCity,
} from "../../common/Utils";

var humanFormat = require("human-format");
// CognitoConfig is now configured in _app.js
import debounce from "lodash/debounce";
import {
  MarkerClusterer,
  SuperClusterAlgorithm,
  // GridAlgorithm,
} from "@googlemaps/markerclusterer";
// import UAParser from "ua-parser-js";
import PlatformService from "../../common/PlatformService";
import defaultData from "../../components/NhMap/defaultData.json";
import MapResultData from "../../components/NhMap/mapDataDasktop.json";

class Map extends React.PureComponent {
  centerPt;
  schoolgrades = {
    primaryarr: [
      "K-8",
      "K-12",
      "K-1",
      "K-5",
      "1-12",
      "K",
      "1",
      "K-6",
      "K-2",
      "3-6",
      "1-8",
      "1-6",
      "2-12",
      "K-7",
      "K-3",
      "K-4",
      "1-5",
      "3-5",
      "2-8",
      "3-12",
      "3-8",
      "4-5",
      "K-10",
      "1-10",
      "4",
    ],
    middlearr: [
      "6-12",
      "K-8",
      "6-8",
      "8-12",
      "7-12",
      "K-12",
      "6-7",
      "1-12",
      "7-8",
      "1-8",
      "2-12",
      "K-7",
      "6-9",
      "5-12",
      "5-8",
      "7-10",
      "7",
      "4-12",
      "2-8",
      "8-11",
      "3-12",
      "4-8",
      "3-8",
      "8",
      "K-10",
      "1-10",
      "7-9",
      "5-6",
      "7-11",
      "4-6",
      "6",
    ],
    higharr: [
      "6-12",
      "8-12",
      "7-12",
      "K-12",
      "10-12",
      "1-12",
      "9-12",
      "11-12",
      "12",
      "2-12",
      "5-12",
      "9-10",
      "7-10",
      "4-12",
      "8-11",
      "3-12",
      "9-11",
      "9",
      "K-10",
      "1-10",
      "7-11",
      "10",
    ],
  };

  constructor(props) {
    super(props);
    this.map = null;
    this.polygon_points = [];
    this.primary_polygon_points = [];
    this.boundarydatas = [];
    this.n_id = "";
    this.s_id = "";
    this.fetchid = [];
    this.sfetchid = [];
    this.default_zoom = 10;
    this.home_points = [];
    this.home_cords = [];
    this.schoolpoints = [];
    this.pschoolpoints = [];
    this.schoolmarkers = [];
    this.pschoolmarkers = [];
    this.schoolmarkerCluster;
    this.nbermudaTriangle = [];
    this.ppbermudaTriangle = [];
    this.nbermudaTrianglesingle = [];
    this.nbermudaTrianglehoverd = [];
    this.citybermudaTrianglesingle = [];
    this.citybermudaTrianglehover = [];
    this.schoolsinglepoly = [];
    this.sbermudaTriangle = [];
    this.npiscore = [];
    this.personalscore = [];
    this.valuescore = [];
    this.schoolscore = [];
    this.primaryschool = [];
    this.crimescore = [];
    this.walkabilityscore = [];
    this.communityscore = [];
    this.curbscore = [];
    this.othersscore = [];
    this.school_points = [];
    this.homemarkerCluster;
    this.homegmarkers = [];
    this.singlegmarkers = [];
    this.clickedmarkers = [];
    this.hoveredmarkers = [];
    this.arr = [];
    this.schoolarr = [];
    this.pschoolarr = [];
    this.getfilterdata = {};
    this.primaryscore = [];
    this.middlescore = [];
    this.highscore = [];
    this.gmarkers = [];
    this.externalmarkers = [];
    this.selecteddatas = [];
    this.infwindows = [];
    this.firstneighborhoodsetpsdata = [];
    this.neighborhoodsetpsdata = [];
    this.savedcitypolygon = [];
    this.selectedhomearr = [];
    this.singleschoolmarker = [];
    this.selecedtabs = "";
    this.finalsavedhomedata = [];
    this.polygonCleared = true;
    this.previousZoomLevel = null;
    this.isInitialLoad = true; // Flag to track initial load
    this.hasUserInteracted = false; // Flag to track user interaction
    this.isInitialMobile = false; // Flag to track intial load for mobile size
    // set default boundary
    this.bounds = {
      north: 38.080193,
      south: 37.230643,
      east: -121.667788,
      west: -122.561655,
    };

    this.state = {
      showingInfoWindow: false, //Hides or the shows the infoWindow
      activeMarker: {}, //Shows the active marker upon click
      selectedPlace: {},
      neighborcoordinatedata: [],
      fetchhome: [],
      fetchhomedb: [],
      loaderdispaly: "none",
      singlehome: [],
      the_message: "",
      fetchschool: [],
      fetchneighbor: [],
      fetchneighborright: [],
      mapsData: [],
      shelters: [],
      markers: [],
      selectedMarker: null,
      polyGon: [],
      boolWindow: null,
      schoolImage: false,
      selectedtab: "Overall Score",
      singleneighbor: [],
      tabselect: 0,
      getfilterdata: [],
      userdetails: "",
      loggedin: false,
      zooms: 14,
      selectedNeighborhood: [],
      selectednhid: "",
      userId: "",
      drag_change: false,
      in_zoom: false,
      popupdisplay: "none",
      schoolpopupname: "",
      schoolpopuprating: "",
      schoolpopupgrade: "",
      schoolpopuptype: "",
      schoolstudent: "",
      schoolwebsite: "",
      schoolgreatschoolurl: "",
      schoolstudentratio: "",
      total_nh_count: 0,
      is_first: true,
      is_nh_count_first: true,
      limit: 0,
      isMobile: false,
      // deviceType: 'desktop',
      isClickable: false,
      selected_id: "",
      selected_lat: 0,
      selected_lang: 0,
      selected_id_single: "",
      gethomefilterdatares: [],
      selected_listingkey: "",
      singlecityname: "",
      neighborhood_names: [],
      isFirsttimeload: false,
      isFromsavenh: false,
      selectedlisting: [],
      searchednh: [],
      selectedschoolid: "",
      selectedschoollat: "",
      selectedschoollng: "",
      orderfields: "",
      is_display_zoom_msg: false,
      single_display: true,
      summarydisplay: false,
    };
    this.refreshMap = this.refreshMap.bind(this);
    this.bound_changed = this.bound_changed.bind(this);
    this.get_recommed_neighborhood = this.get_recommed_neighborhood.bind(this);
    this.bounds_in_view_port = this.bounds_in_view_port.bind(this);
  }
  handlesingleiconClick = () => {
    this.setState({ single_display: !this.state.single_display });
  };

  handlesinglesummaryClick = (e, index) => {
    this.setState({ summarydisplay: !this.state.summarydisplay });
  };

  hasTouch() {
    return (
      !!("ontouchstart" in globalThis) ||
      (!!("onmsgesturechange" in globalThis) &&
        !!globalThis?.navigator?.maxTouchPoints)
    );
  }

  // detectDeviceType() {
  //   const screenWidth = globalThis?.screen?.width;

  //   if (this.hasTouch && screenWidth >= 600) {
  //     alert("tab");
  //   }
  //   if (this.hasTouch && screenWidth < 600) {
  //     alert("phobe");
  //   }

  //   alert("desktop");
  // }

  handleWindowSizeChange = () => {
    // this.detectDeviceType();
    const { os, device, deviceName, deviceType, devicecategory } =
      PlatformService.getPlatformInfo();

    // Get current window width for screen-size based detection
    const windowWidth = typeof window !== 'undefined' ? window.innerWidth : 1920;

    // Determine if current screen size is mobile (<=768px is commonly considered mobile breakpoint)
    const isCurrentlyMobileSize = windowWidth <= 768;

    // Determine if current screen size is tablet (769-1024px)
    const isCurrentlyTabletSize = windowWidth > 768 && windowWidth <= 1024;

    // Priority: Screen size overrides device detection
    // This ensures proper behavior when resizing browser window
    if (isCurrentlyMobileSize || deviceType === "mobile" || devicecategory === "phone") {
      // Only set isInitialMobile to true on the very first detection
      // After that, rely on screen size
      if (!this.hasUserInteracted && this.isInitialLoad) {
        this.isInitialMobile = true;
        this.isInitialLoad = false;
      }
      this.setState({ isClickable: true });
      this.setState({ isMobile: true });
    } else if (isCurrentlyTabletSize || deviceType === "tablet" || devicecategory === "tablet") {
      this.isInitialMobile = false;
      this.hasUserInteracted = true;
      this.isInitialLoad = false;
      this.setState({ isClickable: true });
      this.setState({ isMobile: false });
    } else {
      // Desktop size (>1024px)
      this.isInitialMobile = false;
      this.hasUserInteracted = true;
      this.isInitialLoad = false;
      this.setState({ isClickable: false });
      this.setState({ isMobile: false });
    }

    // this.setState({ isClickable: window.innerWidth <= 1024 });
  };

  resize = () => this.forceUpdate();
  saved_nh_boundary = (id) => {
    if (this.state.fetchneighbor && this.state.fetchneighbor.length > 0) {
      var result = this.state.fetchneighbor.filter((item) => item.id === id);

      let boundries = "";
      if (result[0].geometry_cords.length > 1) {
        boundries = result[0].geometry_cords;
      } else {
        boundries = result[0].geometry_cords;
      }

      let reservdedata = JSON.parse("[" + boundries + "]");

      this.bermudaTriangle2 = new google.maps.Polygon({
        paths: reservdedata,
        strokeWeight: 3.5,
        strokeColor: "#c02e26",
        fillOpacity: 0,
        zIndex: 3,
      });
      this.setState({ isFromsavenh: true });
      this.bermudaTriangle2.setMap(this.map.state.map);
      this.nbermudaTrianglehoverd.push(this.bermudaTriangle2);
      this.loadNhdata();
    }
  };

  check_save_home_click = (item) => {
    let id = item.ListingKeyNumeric;
    let price;
    if (item.ClosePrice != null && item.MlsStatus === "Sold") {
      if (Number.isInteger(item.ClosePrice)) {
        price = humanFormat(item.ClosePrice, {
          decimals: item.ClosePrice.toString().length < 7 ? 0 : 2,
        });
      } else {
        price = item.ClosePrice;
      }
    } else {
      if (Number.isInteger(item.ListPrice)) {
        price = humanFormat(item.ListPrice, {
          decimals: item.ListPrice.toString().length < 7 ? 0 : 2,
        });
      } else {
        price = item.ListPrice;
      }
    }
    let anchorpoints;
    for (var i = 0; i < this.homegmarkers.length; i++) {
      if (id === this.homegmarkers[i].id) {
        anchorpoints = new google.maps.Point(
          this.homegmarkers[i].icon.anchor.x,
          this.homegmarkers[i].icon.anchor.y,
        );
        //break;
      }
    }
    let icons = {
      url: process.env.NEXT_PUBLIC_CDN_ID + "static/images/Price2-red.png",
      scaledSize: new google.maps.Size(35, 25),
      strokeColor: "#c02e26",
      origin: new google.maps.Point(0, 0),
      anchor: anchorpoints,
      labelOrigin: new google.maps.Point(18, 8),
      //fontSize: "8px"
    };
    let newloc = {
      lat: parseFloat(item.Latitude),
      lng: parseFloat(item.Longitude),
    };
    let marker = new google.maps.Marker({
      position: newloc,
      id: item.ListingKeyNumeric,
      label: {
        text: `${price}`,
        color: "#fff",
        fontSize: "12px",
      },
      icon: icons,
      //animation: google.maps.Animation.DROP
    });
    marker.setMap(this.map.state.map);
    this.clickedmarkers.push(marker);
  };

  check_unsave_home_click = (item) => {
    let id = item.ListingKeyNumeric;

    for (var i = 0; i < this.clickedmarkers.length; i++) {
      if (id === this.clickedmarkers[i].id) {
        this.clickedmarkers[i].setMap(null);
        break;
      }
    }
  };

  sethoveredmarker = (lat, lng, nhname) => {
    if (lat !== null && lng !== null) {
      const newloc = {
        lat: parseFloat(lat),
        lng: parseFloat(lng),
      };
      const icons = {
        url: process.env.NEXT_PUBLIC_CDN_ID + "static/images/nh_info.png",
        scaledSize: new google.maps.Size(35, 35),
        strokeColor: "#c02e26",
        origin: new google.maps.Point(0, 0),
        title: "Click for Neighborhood Info",

        //anchor: anchorpoints,
        //labelOrigin: new google.maps.Point(18, 8),
        //fontSize: "8px"
      };
      const marker = new google.maps.Marker({
        position: newloc,
        icon: icons,
      });
      var infowindow = new google.maps.InfoWindow({
        //content: "Click for Neighborhood Info",
        // map: map,
      });

      // new google.maps.event.addListener(infowindow, "domready", function () {
      //   // Find the close button and remove its click event
      //   var closeBtn = document.querySelector(".gm-ui-hover-effect");
      //   var infobg = document.querySelector(".gm-style-iw-c");
      //   if (closeBtn) {
      //     closeBtn.style.display = "none"; // Hide the close button
      //     closeBtn.onclick = function (event) {
      //       event.preventDefault();
      //       event.stopPropagation();
      //     };
      //   }
      //   if (infobg) {
      //     infobg.style.opacity = 0.8;
      //   }
      // });

      marker.addListener("click", () => {
        window.open(`/Neighborhood/${nhname}`, "_blank");
      });

      marker.setMap(this.map.state.map);
      var infowaycontent =
        "<div class='icon_hover_content'> <p>Click for Neighborhood Info</p> </div>";
      infowindow.addListener("domready", function () {
        // Find the close button and remove its click event
        var closeBtn = document.querySelector(".gm-ui-hover-effect");
        var infobg = document.querySelector(".gm-style-iw-c");
        if (closeBtn) {
          closeBtn.style.display = "none"; // Hide the close button
          closeBtn.addEventListener("click", function (event) {
            event.preventDefault();
            event.stopPropagation();
          });
        }
        if (infobg) {
          infobg.style.opacity = 0.8;
        }
      });
      marker.addListener("mouseover", () => {
        infowindow.setContent(infowaycontent);
        infowindow.open(this.map.state.map, marker);
      });
      marker.addListener("mouseout", () => {
        infowindow.close(this.map.state.map, marker);
      });
      this.hoveredmarkers.push(marker);
    }
  };

  clearhoveredmarkers = () => {
    for (var i = 0; i < this.hoveredmarkers.length; i++) {
      this.hoveredmarkers[i].setMap(null);
      //break;
    }
    this.hoveredmarkers = [];
  };

  check_home_hover = (item) => {
    let id = item.ListingKeyNumeric;
    let price;
    if (item.ClosePrice != null && item.MlsStatus === "Sold") {
      if (Number.isInteger(item.ClosePrice)) {
        price = humanFormat(item.ClosePrice, {
          decimals: item.ClosePrice.toString().length < 7 ? 0 : 2,
        });
      } else {
        price = item.ClosePrice;
      }
    } else {
      if (Number.isInteger(item.ListPrice)) {
        price = humanFormat(item.ListPrice, {
          decimals: item.ListPrice.toString().length < 7 ? 0 : 2,
        });
      } else {
        price = item.ListPrice;
      }
    }
    let anchorpoints;
    for (var i = 0; i < this.homegmarkers.length; i++) {
      if (id === this.homegmarkers[i].id) {
        anchorpoints = new google.maps.Point(
          this.homegmarkers[i].icon.anchor.x,
          this.homegmarkers[i].icon.anchor.y,
        );
        //break;
      }
    }
    let icons = {
      url: process.env.NEXT_PUBLIC_CDN_ID + "static/images/Price2-red.png",
      scaledSize: new google.maps.Size(35, 25),
      strokeColor: "#c02e26",
      origin: new google.maps.Point(0, 0),
      anchor: anchorpoints,
      labelOrigin: new google.maps.Point(18, 8),
      //fontSize: "8px"
    };
    let newloc = {
      lat: parseFloat(item.Latitude),
      lng: parseFloat(item.Longitude),
    };
    let marker = new google.maps.Marker({
      position: newloc,
      id: item.ListingKeyNumeric,
      label: {
        text: `${price}`,
        color: "#fff",
        fontSize: "12px",
      },
      icon: icons,
      //animation: google.maps.Animation.DROP
    });
    marker.setMap(this.map.state.map);
    this.singlegmarkers.push(marker);
    // for (var i = 0; i < this.homegmarkers.length; i++) {
    //   if (id === this.homegmarkers[i].id) {
    //     this.homegmarkers[i].setIcon(icons);
    //     break;
    //   }
    // }
  };

  check_home_unhover = (item) => {
    let id = item.ListingKeyNumeric;

    for (var i = 0; i < this.singlegmarkers.length; i++) {
      // if (id === this.homegmarkers[i].id) {
      this.singlegmarkers[i].setMap(null);
      //break;
      // }
    }
  };

  check_city_hover = (cityname, statename) => {
    let address = cityname + ", " + statename;
    axios
      .get(
        `https://nominatim.openstreetmap.org/search?q=${address}&polygon_geojson=1&format=geojson`,
      )
      .then((res) => {
        let that = this;
        window.city = res;
        let cityname = address.split(",");
        if (res.data && res.data.features.length > 0) {
          that.clearpolysingle();
          that.clearhoveredmarkers();
          that.clearcitypolyhover();
          that.clearcitypolysingle();

          //that.props.singleCity(cityname[0]);
          var id = 0;
          var citydata = [];
          let searchaddress = address.replace(/,[^,]+$/, "%");
          if (
            searchaddress === "Hillsborough, CA%" ||
            searchaddress === "Hillsborough CA%" ||
            searchaddress === "Hillsborough, California%" ||
            searchaddress === "San Mateo%" ||
            searchaddress === "San Mateo" ||
            searchaddress === "Alameda, CA%" ||
            searchaddress === "San Mateo CA%" ||
            searchaddress === "San Mateo, CA%" ||
            searchaddress === "San Mateo, California%" ||
            searchaddress === "Hillsborough" ||
            searchaddress === "Hillsborough CA"
          ) {
            id = 1;
          } else {
            if (
              res.data.features[id].geometry !== undefined &&
              res.data.features[id].geometry.type === "Point"
            ) {
              if (res.data.features.length > 1) {
                id = 1;
              } else {
                id = 0;
              }
            }
          }

          if (
            res.data.features[id].geometry !== undefined &&
            res.data.features[id].geometry.type === "Polygon"
          ) {
            citydata = res.data.features[id].geometry.coordinates[0];
          } else if (res.data.features[id].geometry.type === "MultiPolygon") {
            var c_length = res.data.features[id].geometry.coordinates.length;
            citydata = res.data.features[id].geometry.coordinates[0][0];
          }
          window.y = res.data;

          if (res.data.features[id].geometry.type === "MultiPolygon") {
            var cities_length =
              res.data.features[id].geometry.coordinates.length;
            var multi_city = [];
            for (var i = 0; i < cities_length; i++) {
              multi_city.push(
                res.data.features[id].geometry.coordinates[i][0].map(
                  (item, index) => {
                    return {
                      lat: parseFloat(item[1]),
                      lng: parseFloat(item[0]),
                    };
                  },
                ),
              );
            }

            that.bermudaTriangle3 = new google.maps.Polygon({
              paths: multi_city,
              strokeWeight: 3.6,
              strokeColor: "#c02e26",
              fillOpacity: 0,
              zIndex: 0,
            });

            that.bermudaTriangle3.setMap(that.map.state.map);
            that.citybermudaTrianglehover.push(that.bermudaTriangle3);
          } else {
            let city_reservdedata = citydata.map((item5, index5) => {
              return {
                lat: parseFloat(item5[1]),
                lng: parseFloat(item5[0]),
              };
            });

            that.bermudaTriangle3 = new google.maps.Polygon({
              paths: [city_reservdedata],
              strokeWeight: 3.6,
              strokeColor: "#c02e26",
              fillOpacity: 0,
              zIndex: 3,
            });

            that.bermudaTriangle3.setMap(that.map.state.map);
            that.citybermudaTrianglehover.push(that.bermudaTriangle3);
          }
        }
      });
  };

  check_city_unclick = (citynamedata, statename) => {
    clearsavedcitypolygon(citynamedata);
  };

  check_city_click = (citynamedata, statename, cityfullname, issaved) => {
    // Mark that user has interacted with the map
    this.hasUserInteracted = true;

    let address = citynamedata + ", " + statename;
    axios
      .get(
        `https://nominatim.openstreetmap.org/search?q=${address}&polygon_geojson=1&format=geojson`,
      )
      .then((res) => {
        let that = this;
        window.city = res;
        let cityname = address.split(",");
        if (res.data && res.data.features.length > 0) {
          that.clearpolysingle();
          that.clearhoveredmarkers();
          that.clearcitypolysingle();
          that.props.singleNeighbor([]);

          //that.props.singleCity(cityname[0]);
          var id = 0;
          var citydata = [];
          let searchaddress = address.replace(/,[^,]+$/, "%");
          if (
            searchaddress === "Hillsborough, CA%" ||
            searchaddress === "Hillsborough CA%" ||
            searchaddress === "Hillsborough, California%" ||
            searchaddress === "San Mateo%" ||
            searchaddress === "San Mateo" ||
            searchaddress === "Alameda, CA%" ||
            searchaddress === "San Mateo CA%" ||
            searchaddress === "San Mateo, CA%" ||
            searchaddress === "San Mateo, California%" ||
            searchaddress === "Hillsborough" ||
            searchaddress === "Hillsborough CA"
          ) {
            id = 1;
          } else {
            if (
              res.data.features[id].geometry !== undefined &&
              res.data.features[id].geometry.type === "Point"
            ) {
              if (res.data.features.length > 1) {
                id = 1;
              } else {
                id = 0;
              }
            }
          }
          let lat =
            (res.data.features[id].bbox[1] + res.data.features[id].bbox[3]) / 2;
          let lng =
            (res.data.features[id].bbox[0] + res.data.features[id].bbox[2]) / 2;
          let point = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
          if (
            this.getMapInstance() && this.getMapInstance().getBounds().contains(point) &&
            issaved === "click"
          ) {
            // window.open(
            //   "/City/?name=" + citynamedata + "&state=" + statename,
            //   "_blank"
            // );
            window.open(`/City/${cityfullname}`, "_blank");
          } else {
            if (issaved === "click") {
              that.map.state.map.panTo(point);
              let lhpStr = "npi";
              if (this.state.tabselect === 0) {
                lhpStr = "npi";
                this.bound_changed("npi");
              } else if (this.state.tabselect === 1) {
                lhpStr = "personal";
                this.bound_changed(lhpStr);
              } else if (this.state.tabselect === 5) {
                lhpStr = "price";
                this.bound_changed(lhpStr);
              } else if (this.state.tabselect === 2) {
                lhpStr = "all";
                let lhpStr1 = "all";
                this.bound_changed(lhpStr);
                this.get_school2(lhpStr1);
                this.get_homes();
              } else if (this.state.tabselect === 3) {
                lhpStr = "crime";
                this.bound_changed(lhpStr);
              } else if (
                this.state.tabselect === 4 ||
                this.state.tabselect === 16
              ) {
                lhpStr = "amenities";
                this.bound_changed(lhpStr);
              } else if (this.state.tabselect === 7) {
                lhpStr = "appreciation";
                this.bound_changed(lhpStr);
              } else if (this.state.tabselect === 6) {
                lhpStr = "value";
                this.bound_changed(lhpStr);
              } else if (this.state.tabselect === 8) {
                lhpStr = "all";
                let lhpStr1 = "all";
                this.bound_changed(lhpStr);
                this.get_school2(lhpStr1);
                this.get_homes();
              } else if (this.state.tabselect === 9) {
                lhpStr = "school";
                let lhpStr1 = "Primary";
                this.bound_changed(lhpStr);
                this.get_school2(lhpStr1);
                this.get_homes();
              } else if (this.state.tabselect === 10) {
                lhpStr = "school";
                let lhpStr1 = "Middle";
                this.bound_changed(lhpStr);
                this.get_school2(lhpStr1);
                this.get_homes();
              } else if (this.state.tabselect === 11) {
                lhpStr = "school";
                let lhpStr1 = "High";
                this.bound_changed(lhpStr);
                this.get_school2(lhpStr1);
                this.get_homes();
              } else if (this.state.tabselect === 12) {
                lhpStr = "walkability";
                this.clearschoolMarkers();
                this.clearpoly();
                this.clearschoolpoly();
                this.bound_changed(lhpStr);
                this.get_homes();
              } else if (this.state.tabselect === 13) {
                lhpStr = "publicspaces";
                this.clearschoolMarkers();
                this.clearpoly();
                this.clearschoolpoly();
                this.bound_changed(lhpStr);
                this.get_homes();
              } else if (this.state.tabselect === 14) {
                lhpStr = "walkability";
                this.clearschoolMarkers();
                this.clearpoly();
                this.clearschoolpoly();
                this.bound_changed(lhpStr);
                this.get_homes();
              } else if (this.state.tabselect === 15) {
                lhpStr = "curb";
                this.clearschoolMarkers();
                this.clearpoly();
                this.clearschoolpoly();
                this.bound_changed(lhpStr);
                this.get_homes();
              } else if (this.state.tabselect === 18) {
                lhpStr = "price";
                this.clearschoolMarkers();
                this.clearpoly();
                this.clearschoolpoly();
                this.bound_changed(lhpStr);
                this.get_homes();
              } else if (this.state.tabselect === 20) {
                lhpStr = "value";
                this.clearschoolMarkers();
                this.clearpoly();
                this.clearschoolpoly();
                this.bound_changed(lhpStr);
                this.get_homes();
              }
            }
          }
          if (
            res.data.features[id].geometry !== undefined &&
            res.data.features[id].geometry.type === "Polygon"
          ) {
            citydata = res.data.features[id].geometry.coordinates[0];
          } else if (res.data.features[id].geometry.type === "MultiPolygon") {
            var c_length = res.data.features[id].geometry.coordinates.length;
            citydata = res.data.features[id].geometry.coordinates[0][0];
          }
          window.y = res.data;

          if (res.data.features[id].geometry.type === "MultiPolygon") {
            var cities_length =
              res.data.features[id].geometry.coordinates.length;
            var multi_city = [];
            for (var i = 0; i < cities_length; i++) {
              multi_city.push(
                res.data.features[id].geometry.coordinates[i][0].map(
                  (item, index) => {
                    return {
                      lat: parseFloat(item[1]),
                      lng: parseFloat(item[0]),
                    };
                  },
                ),
              );
            }

            that.bermudaTriangle3 = new google.maps.Polygon({
              paths: multi_city,
              strokeWeight: 3.6,
              strokeColor: issaved === "click" ? "#c02e26" : "#c02e26",
              fillOpacity: 0,
              zIndex: 4,
            });

            that.bermudaTriangle3.setMap(that.map.state.map);
            google.maps.event.addListener(
              that.bermudaTriangle3,
              "mouseover",
              function (event) {
                that.bermudaTriangle3.setOptions({
                  zIndex: 0,
                });
              },
            );
            issaved === "click" &&
              that.citybermudaTrianglesingle.push(that.bermudaTriangle3);
            issaved === "save" &&
              that.savedcitypolygon.push({
                poly: that.bermudaTriangle3,
                city: citynamedata,
              });
          } else {
            let city_reservdedata = citydata.map((item5, index5) => {
              return {
                lat: parseFloat(item5[1]),
                lng: parseFloat(item5[0]),
              };
            });

            that.bermudaTriangle3 = new google.maps.Polygon({
              paths: [city_reservdedata],
              strokeWeight: 3.6,
              strokeColor: issaved === "click" ? "#c02e26" : "#c02e26",
              fillOpacity: 0,
              zIndex: 4,
            });

            that.bermudaTriangle3.setMap(that.map.state.map);
            google.maps.event.addListener(
              that.bermudaTriangle3,
              "mouseover",
              function (event) {
                that.bermudaTriangle3.setOptions({
                  zIndex: 0,
                });
              },
            );
            issaved === "click" &&
              that.citybermudaTrianglesingle.push(that.bermudaTriangle3);
            issaved === "save" &&
              that.savedcitypolygon.push({
                poly: that.bermudaTriangle3,
                city: citynamedata,
              });
          }
        }
      });
  };

  check_city_unhover = () => {
    this.clearpolysingle();
    this.clearhoveredmarkers();
    this.clearcitypolysingle();
    this.clearcitypolyhover();
  };

  check_click = (id, cat, name) => {
    // Mark that user has interacted with the map
    this.hasUserInteracted = true;

    let ids = id;
    if (id === "") {
      //this.clearpolyhoverd();
    } else {
      var result = [];
      if (
        this.state.fetchneighbor &&
        this.state.fetchneighbor.length > 0 &&
        cat === "top"
      ) {
        result = this.state.fetchneighbor.filter((item) => item.id === id);
      } else if (cat === "saved") {
        result = this.savedneighbordata.filter(
          (item) => item.neighborhoodId === id,
        );
      }
      //this.clearpolyhoverd();
      if (result && result.length > 0) {
        let point = new google.maps.LatLng(
          parseFloat(result[0].latitude),
          parseFloat(result[0].longitude),
        );

        if (this.map.state.map.getBounds().contains(point)) {
          window.open(`/Neighborhood/${name}`, "_blank");
        } else {
          this.drawPolygonHover(result, "is_click");
        }
      }
    }
  };
  formatStreetName = (streetName) =>
    streetName
      .toLowerCase()
      .split(" ")
      .map(
        (word) =>
          ({ ave: "Ave", st: "St", dr: "Dr" })[word] ||
          word.charAt(0).toUpperCase() + word.slice(1),
      )
      .join(" ");

  check_hover = (id) => {
    // let ids = id;
    // let zoom_level = this.map.state.map.getZoom();

    if (id === "") {
      this.clearpolyhoverd();
      this.setState({ selectedNeighborhood: [] });
    } else {
      if (
        this.state.fetchneighborright &&
        this.state.fetchneighborright.length > 0
      ) {
        var result = this.state.fetchneighborright.filter(
          (item) => item.id === id,
        );
        this.clearpolyhoverd();
        this.drawPolygonHover(result, "is_hover");
        this.setState({ selectedNeighborhood: result });
      } else {
        this.clearpolyhoverd();
      }
      // this.setState({selected_id: id});
      // const getdatanew = {
      //   start: 0,
      //   limit: 1,
      //   orderBy: "name",
      //   order: "ASC",
      //   fields: [
      //     {
      //       name: "id",
      //       value: ids,
      //       operator: "=",
      //     },
      //   ],
      //   zoomLevel: zoom_level,
      //   userdata: localStorage.getItem("globaluserid"),
      // };
      // getAllneighborboundrieslist(getdatanew)
      //   .then((result) => {
      //     // this.clearpolyhoverd();
      //     if (result.data.getneighborboundries.length > 0) {
      //       // setsingle();
      //       // function setsingle(){ propsnew.singleNeighbor(result.data.getneighborboundries)};
      //       this.clearpolyhoverd();
      //       this.drawPolygonHover(result.data.getneighborboundries);
      //       // this.setState({selectedNeighborhood:result.data.getneighborboundries})
      //     }
      //   })
      //   .catch((error) => {
      //   });
    }
  };

  get_recommed_neighborhood = () => {
    let preneighbordata = JSON.parse(
      localStorage.getItem("objAddNeighbourSearch"),
    );
    var geocoder = new google.maps.Geocoder();
    if (
      preneighbordata.findval != "" &&
      this.state.userdetails[7] === JSON.parse(localStorage.userpreemail)
    ) {
      if (localStorage.getItem("recomneighborhood")) {
        this.props.recommendedneighbor(
          JSON.parse(localStorage.getItem("recomneighborhood")),
        );
      } else {
        this.props.recommendedneighbor([]);
      }
    }
  };

  loadNhdata = () => {
    let lhpStr = "npi";
    if (this.state.tabselect === 0) {
      lhpStr = "npi";
      this.bound_changed("npi");
    } else if (this.state.tabselect === 1) {
      lhpStr = "personal";
      this.bound_changed(lhpStr);
    } else if (this.state.tabselect === 5) {
      lhpStr = "price";
      this.bound_changed(lhpStr);
    } else if (this.state.tabselect === 2) {
      lhpStr = "all";
      let lhpStr1 = "all";
      this.bound_changed(lhpStr);
      this.get_school2(lhpStr1);
      this.get_homes();
    } else if (this.state.tabselect === 3) {
      lhpStr = "crime";
      this.bound_changed(lhpStr);
    } else if (this.state.tabselect === 4 || this.state.tabselect === 16) {
      lhpStr = "amenities";
      this.bound_changed(lhpStr);
    } else if (this.state.tabselect === 7) {
      lhpStr = "appreciation";
      this.bound_changed(lhpStr);
    } else if (this.state.tabselect === 6) {
      lhpStr = "value";
      this.bound_changed(lhpStr);
    } else if (this.state.tabselect === 8) {
      lhpStr = "all";
      let lhpStr1 = "all";
      this.bound_changed(lhpStr);
      this.get_school2(lhpStr1);
      this.get_homes();
    } else if (this.state.tabselect === 9) {
      lhpStr = "school";
      let lhpStr1 = "Primary";
      this.bound_changed(lhpStr);
      this.get_school2(lhpStr1);
      this.get_homes();
    } else if (this.state.tabselect === 10) {
      lhpStr = "school";
      let lhpStr1 = "Middle";
      this.bound_changed(lhpStr);
      this.get_school2(lhpStr1);
      this.get_homes();
    } else if (this.state.tabselect === 11) {
      lhpStr = "school";
      let lhpStr1 = "High";
      this.bound_changed(lhpStr);
      this.get_school2(lhpStr1);
      this.get_homes();
    }
  };

  drawPolygonHover = (neighborhood, checkevent) => {
    if (neighborhood && neighborhood.length > 0) {
      if (
        this.state.selectedNeighborhood &&
        this.state.selectedNeighborhood.length > 0 &&
        this.state.selectedNeighborhood[0].id === neighborhood[0].id
      ) {
        // let map_bound = this.map.state.map.getBounds();

        let point = new google.maps.LatLng(
          parseFloat(neighborhood[0].latitude),
          parseFloat(neighborhood[0].longitude),
        );

        if (this.map.state.map.getBounds().contains(point)) {
        } else {
          if (
            !this.map.state.map.getBounds().contains(point) &&
            checkevent === "is_click"
          ) {
            this.map.state.map.panTo({
              lat: parseFloat(neighborhood[0].latitude),
              lng: parseFloat(neighborhood[0].longitude),
            });
          }
        }
        this.clearpolysingle();
        this.clearhoveredmarkers();
        setTimeout(
          () => this.drawPolygon(this.state.selectedNeighborhood),
          500,
        );
      } else {
        //this.clearpolyhoverd();

        // let map_bound = this.map.state.map.getBounds();

        let point = new google.maps.LatLng(
          parseFloat(neighborhood[0].latitude),
          parseFloat(neighborhood[0].longitude),
        );

        if (this.map.state.map.getBounds().contains(point)) {
        } else {
          if (
            !this.map.state.map.getBounds().contains(point) &&
            checkevent === "is_click"
          ) {
            this.map.state.map.panTo({
              lat: parseFloat(neighborhood[0].latitude),
              lng: parseFloat(neighborhood[0].longitude),
            });

            this.loadNhdata();
          }
        }

        let boundries = "";
        if (neighborhood[0].geometry_cords) {
          boundries = neighborhood[0].geometry_cords;
        }

        let reservdedata = JSON.parse("[" + boundries + "]");
        this.bermudaTriangle2 = new google.maps.Polygon({
          paths: reservdedata,
          strokeWeight:
            neighborhood[0].savedneighborhoodbyuser === "1" ||
            (neighborhood[0].savedneighbor &&
              neighborhood[0].savedneighbor.length > 0)
              ? 4
              : 3.5,
          strokeColor: "#c02e26",
          // strokeColor:
          //   neighborhood[0].savedneighborhoodbyuser === "1" ||
          //   (neighborhood[0].savedneighbor &&
          //     neighborhood[0].savedneighbor.length > 0)
          //     ? "#c02e26"
          //     : neighborhood[0].summary != null && neighborhood[0].summary != ""
          //     ? "#c02e26"
          //     : "#c02e26",
          fillOpacity: 0,
          zIndex: 4,
          id: neighborhood[0].id,
        });

        this.bermudaTriangle2.setMap(this.map.state.map);
        this.nbermudaTrianglehoverd.push(this.bermudaTriangle2);
      }
    }
  };

  clearpolyhoverd = () => {
    if (this.nbermudaTrianglehoverd && this.nbermudaTrianglehoverd.length > 0) {
      for (var i = 0; i < this.nbermudaTrianglehoverd.length; i++) {
        this.nbermudaTrianglehoverd[i].setMap(null);
      }
    }
  };

  componentDidMount() {
    // const google = window.google;
    this.handleWindowSizeChange();
    window.addEventListener("resize", this.handleWindowSizeChange);

    // const script = document.createElement("script");
    // script.src =
    //   "https://unpkg.com/@googlemaps/markerclusterer/dist/index.min.js";
    // script.async = true;
    // document.body.appendChild(script);
    const searchParams = new URLSearchParams(window.location.search);
    this.searchaddress = searchParams.get("address");
    setTimeout(() => this.gethomefilterdata(), 300);

    // Load data once map is ready - no artificial delay
    // Only use static JSON for actual mobile screen sizes (<=768px)
    if (this.searchaddress === null || this.searchaddress === "") {
      // Check actual screen width at mount time
      const windowWidth = typeof window !== 'undefined' ? window.innerWidth : 1920;
      const shouldUseStaticData = windowWidth <= 768 && !this.hasUserInteracted;

      if (!shouldUseStaticData) {
        // Desktop or tablet: use API immediately
        this.hasUserInteracted = true;
      }

      // Call bound_changed as soon as map is ready (check via requestAnimationFrame)
      setTimeout(() => {
        this.waitForMapAndLoadData("npi", shouldUseStaticData);
      }, 300);
    } else {
      // If there's an address search, always use dynamic data
      this.hasUserInteracted = true;
      setTimeout(() => {
        this.waitForMapAndLoadData("npi", false);
      }, 300);
    }

    getCurrentUser()
      .then((user) => {
        const attributes = user?.attributes;
        const mappedUserDetails = {
          role: attributes["custom:usertype"] || null,
          id: attributes?.sub || null,
          status: attributes?.email_verified === "true" ? true : false,
          first_name: attributes["custom:firstname"] || null,
          s_id: attributes["custom:id"] || null,
          last_name: attributes["custom:lastname"] || null,
          pwd: attributes["custom:confirmpassword"] || null,
          email: attributes.email || null,
        }; 
        const userdetails = user ? Object.values(mappedUserDetails || {}) : [];

        this.setState({
          userdetails: userdetails,
          loggedin: true,
        });
        const getdata = {
          start: 0,
          limit: 10,
          orderBy: "email",
          order: "ASC",
          fields: [{ name: "email", value: attributes?.email, operator: "=" }],
        };
        getAllUserList(getdata)
          .then((result) => {
            result.data.getUser.map((item, index) => {
              this.setState({ userId: item.id });
              //setTimeout(() => this.saveneighbordata(), 2000);
              // this.savedhomedata();
              // this.get_saved_cities();
              //this.get_recommed_neighborhood();
            });
            localStorage.setItem("searchuser", this.state.userdetails[7]);
          })
          .catch((error) => {
            console.error(error);
          });
      })

      .catch((err) => {
        if (err) {
          this.setState({
            loggedin: false,
            save: false,
          });
        }
        if (this.state.userdetails === "") {
          if (localStorage.getItem("objAddHomeSearch")) {
            this.getfilterdata = JSON.parse(
              localStorage.getItem("objAddHomeSearch"),
            );
          }
        }
        // window.location.href = '/login'
      });

    this.setState({ popupdisplay: "none" });
    const divEl = document.querySelector(".min_width_cls");

    divEl.addEventListener("mousemove", () => {
      this.clearpolyhoverd();
    });
  }

  gethomefilterdata = () => {
    let userId = localStorage.getItem("globaluserid");
    var getdata = {
      start: 0,
      limit: 100,
      order: "DESC",
      orderBy: "updatedDate",
      fields: [{ name: "userid", value: userId, operator: "=" }],
    };

    gethomefilter(getdata)
      .then((result) => {
        if (
          result &&
          result.data.gethomefilter &&
          result.data.gethomefilter.length > 0
        ) {
          this.setState({ gethomefilterdatares: result.data.gethomefilter });
          let mlsstatus = [];
          let propertytype = [];
          let propertysubtype = [];
          let pricequery = {};
          let bedquery = {};
          let bathquery = {};
          let sqftquery = {};
          let lotsizequery = {};
          let yearquery = {};
          let maxfeesquery = "";
          let soldDays = result.data.gethomefilter[0].solddate;

          if (
            result.data.gethomefilter[0].minprice > 0 &&
            result.data.gethomefilter[0].maxprice > 0
          ) {
            pricequery = {
              min: parseFloat(result.data.gethomefilter[0].minprice),
              max: parseFloat(result.data.gethomefilter[0].maxprice),
            };
          } else if (result.data.gethomefilter[0].minprice > 0) {
            pricequery = {
              min: parseFloat(result.data.gethomefilter[0].minprice),
            };
          } else if (result.data.gethomefilter[0].maxprice > 0) {
            pricequery = {
              max: parseFloat(result.data.gethomefilter[0].maxprice),
            };
          } else {
            pricequery = "";
          }

          if (
            result.data.gethomefilter[0].minbeds > 0 &&
            result.data.gethomefilter[0].maxbeds > 0
          ) {
            bedquery = {
              min: parseFloat(result.data.gethomefilter[0].minbeds),
              max: parseFloat(result.data.gethomefilter[0].maxbeds),
            };
          } else if (result.data.gethomefilter[0].minbeds > 0) {
            bedquery = {
              min: parseFloat(result.data.gethomefilter[0].minbeds),
            };
          } else if (result.data.gethomefilter[0].maxbeds > 0) {
            bedquery = {
              max: parseFloat(result.data.gethomefilter[0].maxbeds),
            };
          } else {
            bedquery = "";
          }

          if (
            result.data.gethomefilter[0].minbathss > 0 &&
            result.data.gethomefilter[0].maxbaths > 0
          ) {
            bathquery = {
              min: parseFloat(result.data.gethomefilter[0].minbaths),
              max: parseFloat(result.data.gethomefilter[0].maxbaths),
            };
          } else if (result.data.gethomefilter[0].minbaths > 0) {
            bathquery = {
              min: parseFloat(result.data.gethomefilter[0].minbaths),
            };
          } else if (result.data.gethomefilter[0].maxbaths > 0) {
            bathquery = {
              max: parseFloat(result.data.gethomefilter[0].maxbaths),
            };
          } else {
            bathquery = "";
          }

          // sqftquery = {
          //   min: result.data.gethomefilter[0].minsqft,
          //   max: result.data.gethomefilter[0].maxsqft
          // };
          // lotsizequery = {
          //   min: result.data.gethomefilter[0].minlotsize,
          //   max: result.data.gethomefilter[0].maxlotsize
          // };
          // yearquery = {
          //   min: result.data.gethomefilter[0].minyear,
          //   max: result.data.gethomefilter[0].maxyear
          // };

          // maxfeesquery = result.data.gethomefilter[0].maxhoafees;

          if (result.data.gethomefilter[0].is_sale === 1) {
            mlsstatus.push("Active");
            propertytype = [];
          }
          if (result.data.gethomefilter[0].is_pending === 1) {
            mlsstatus.push("Pending");
            propertytype = [];
          }
          if (result.data.gethomefilter[0].is_sold === 1) {
            mlsstatus.push("Sold");
            propertytype = [];
          }
          if (result.data.gethomefilter[0].is_rent === 1) {
            propertytype.push("Active");
            mlsstatus = [];
          } else {
            propertytype.push();
          }

          if (result.data.gethomefilter[0].propertytype !== "") {
            propertysubtype =
              result.data.gethomefilter[0].propertytype.split(", ");
            //propertytype.push("ResidentialLease");
          } else {
            // propertysubtype = [
            //   "SingleFamilyResidence",
            //   "Townhouse",
            //   "Duplex",
            //   "Apartment",
            //   "MultiFamily",
            //   "UnimprovedLand"
            // ];
            propertysubtype = [
              "SingleFamilyResidence",
              "Townhouse",
              //"Duplex",
              "Apartment",
              //"MultiFamily"
            ];
          }

          this.getfilterdata = {
            // propertyType: propertytype,
            //propertySubType: propertysubtype,
            //mlsStatus: mlsstatus,
            propertyType: propertysubtype,
            forRent: propertytype,
            forSale: mlsstatus,
            // price: pricequery,
            // bed: bedquery,
            // bath: bathquery,
            // squareFeet: sqftquery,
            // lotSize: lotsizequery,
            // yearBuilt: yearquery,
            // maxHOAFees: maxfeesquery
          };

          if (pricequery != "") {
            this.getfilterdata.price = pricequery;
          }

          if (bedquery != "") {
            this.getfilterdata.bed = bedquery;
          }

          if (bathquery != "") {
            this.getfilterdata.bath = bathquery;
          }

          if (soldDays > 0) {
            this.getfilterdata.soldDays = soldDays;
          }

          this.get_homes();
        } else {
        }
      })
      .catch((error) => {
        console.error("result.data.getfilter", error);
      });
  };

  savedhomedata = () => {
    this.savedhomedata = [];
    let savedhomedatadetails = [];

    const getdata = {
      start: 0,
      limit: 20,
      orderBy: "address",
      order: "ASC",
      fields: [
        {
          name: "userId",
          value: localStorage.getItem("globaluserid"),
          operator: "=",
        },
        {
          name: "savedStatus",
          value: 1,
          operator: "=",
        },
      ],
    };

    getAllSavedHomelist(getdata)
      .then((result) => {
        let savedhomesdata = [];
        let mlssaveddata = [];
        this.props.savedhomes(savedhomesdata);
        result.data.getsavedhome &&
          result.data.getsavedhome.map((item, index) => {
            if (!savedhomedatadetails.includes(item) && item.id !== null) {
              savedhomedatadetails.push(item.id);
              savedhomesdata.push(item);
            } else {
              mlssaveddata.push(item.homeid);
            }
          });
        //this.props.savedhomes(savedhomesdata);

        if (mlssaveddata && mlssaveddata.length > 0) {
          let listingIds = mlssaveddata.map((i) => Number(i));
          const getdatanew = {
            ListingKeyNumerics: listingIds,
          };

          Promise.all([
            getListingsByIds(getdatanew),
            getSlipStreamListngsByIds(getdatanew), // New API added
          ])
            .then(([listingsResponse, slipStreamResponse]) => {
              let combinedData = [];

              // Check and merge Listings By Ids
              if (
                listingsResponse?.data?.getListingsByIds &&
                Array.isArray(listingsResponse.data.getListingsByIds)
              ) {
                listingsResponse.data.getListingsByIds.forEach((item) => {
                  if (item !== null) {
                    this.savedhomedata.push(item);
                  }
                });
              }

              // Check and merge SlipStream Listings By Ids
              if (
                slipStreamResponse?.data?.getSlipStreamListngsByIds &&
                Array.isArray(slipStreamResponse.data.getSlipStreamListngsByIds)
              ) {
                slipStreamResponse.data.getSlipStreamListngsByIds.forEach(
                  (item) => {
                    if (item !== null) {
                      this.savedhomedata.push(item);
                    }
                  },
                );
              }

              // Merge saved data
              combinedData = [...savedhomesdata, ...this.savedhomedata];
              this.finalsavedhomedata = combinedData;

              // If any data exists, send it via props
              this.props.savedhomes(combinedData);
            })
            .catch((error) => {
              // In case of an error, send the default saved homes data
              this.props.savedhomes(savedhomesdata);
              console.error("Error fetching saved homes:", error);
            });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  saveneighbordata = () => {
    this.savedneighbordata = [];

    const getdata = {
      start: 0,
      limit: 100,
      orderBy: "id",
      order: "ASC",
      fields: [
        {
          name: "userId",
          value: localStorage.getItem("globaluserid"),
          operator: "=",
        },
        {
          name: "savedStatus",
          value: 1,
          operator: "=",
        },
      ],
    };
    getAllsavedneighborhoodbyuserList(getdata)
      .then((result) => {
        //this.props.savedneighbor(this.savedneighbordata);
        if (
          result.data &&
          result.data.getsavedneighborhoodbyuser &&
          result.data.getsavedneighborhoodbyuser.length === 0
        ) {
          this.savedneighbordata.push([]);
        }
        result.data &&
          result.data.getsavedneighborhoodbyuser &&
          result.data.getsavedneighborhoodbyuser.map((item, index) => {
            if (!this.savedneighbordata.includes(item)) {
              this.savedneighbordata.push(item);
              this.props.savedneighbor(this.savedneighbordata);
            }
          });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handleClick = (marker, event) => {
    this.setState({ selectedMarker: marker });
  };

  iconBoundary = (selectedMarker) => {
    this.setState({
      polyGon: selectedMarker,
    });
  };

  handleselectednhchange = (data) => {
    let neighborhoods = [];
    var schoolsdata = this.props.schoolbar_val / 10;
    var safetydata = this.props.crimebar_val / 10;
    var walkabilitydata = this.props.walkbar_val / 10;
    var publicspacesdata = this.props.townbar_val / 10;
    var curbAppealdata = this.props.curbbar_val / 10;
    var valueindexdata = this.props.valuebar_val / 10;
    //selected value from slider wrap

    var targetRadiusFromSearchLocations = 0; // in miles
    var targetSearchLocationLats;
    var targetSearchLocationLongs;
    var targetMinPrices = 0;
    var targetMaxPrices = 0;

    const minPriceAdjustments = 0.85;
    const maxPriceAdjustments = 1.15;
    const minRadiuss = 5.0; // in miles
    const bayAreaNeighborhoodMinimumMedianPrices = 500000.0; // benchmarked to median home price for Antioch
    const maxNviScaleFactors = 0.096;
    if (targetRadiusFromSearchLocations < minRadiuss) {
      targetRadiusFromSearchLocations = minRadiuss;
    }
    targetMinPrices *= minPriceAdjustments;
    targetMaxPrices *= maxPriceAdjustments;

    if (data.length > 0) {
      {
        data.map((item, index) => {
          neighborhoods.push({
            id: item.id,
            name: item.name,
            school: parseFloat(item.school),
            crime: parseFloat(item.crime),
            walkability: parseFloat(item.walkability),
            publicspaces: parseFloat(item.publicspaces),
            curb: parseFloat(item.curb),
            amenities: parseFloat(item.amenities),
            primaryschoolscore: item.primaryschoolscore || 0,
            middleschoolscore: item.middleschoolscore || 0,
            highschoolscore: item.highschoolscore || 0,
            npi: parseFloat(item.npi),
            medianprice: item.medianprice,
            value: parseFloat(item.value),
            personal: parseFloat(item.personal),
            personalNpi: 0,
            geometry_cords: item.geometry_cords,
            neighborhoodImages: item.neighborhoodImages,
            savedneighbor: item.savedneighbor,
            appreciation: item.appreciation,
            nhfullname: item.nhfullname,
            postalcity_name: item.postalcity_name,
            label: item.label,
          });
        });
      }
      if (neighborhoods.length > 0) {
        for (var i = 0; i < neighborhoods.length; i++) {
          var neighborhoodValueIndexs = 0;

          var sumOfWeights = 0;

          if (neighborhoods[i].school > 0) {
            sumOfWeights += Number(schoolsdata);
          }
          if (neighborhoods[i].crime > 0) {
            sumOfWeights += Number(safetydata);
          }
          if (neighborhoods[i].walkability > 0) {
            sumOfWeights += Number(walkabilitydata);
          }
          if (neighborhoods[i].publicspaces > 0) {
            sumOfWeights += Number(publicspacesdata);
          }
          if (neighborhoods[i].curb > 0) {
            sumOfWeights += Number(curbAppealdata);
          }
          var targetFactorWeights = {
            schools: schoolsdata / sumOfWeights,
            safety: safetydata / sumOfWeights,
            walkability: walkabilitydata / sumOfWeights,
            publicspaces: publicspacesdata / sumOfWeights,
            curbAppeal: curbAppealdata / sumOfWeights,
            elementarySchool: 0,
            middleSchool: 0,
            highSchool: 0,
            neighborhoodValueIndexs: valueindexdata / sumOfWeights,
          };
          targetFactorWeights["schools"] = schoolsdata / sumOfWeights;

          // Copy school weight into elementarySchool, middleSchool, highSchool
          targetFactorWeights["elementarySchool"] =
            targetFactorWeights["schools"];
          targetFactorWeights["middleSchool"] = targetFactorWeights["schools"];
          targetFactorWeights["highSchool"] = targetFactorWeights["schools"];
          // if (neighborhoods[i].medianprice !== 0) {
          //   neighborhoodValueIndexs =
          //     (neighborhoods[i].npi / 10) *
          //     (bayAreaNeighborhoodMinimumMedianPrices /
          //       neighborhoods[i].medianprice);
          // } else {
          //   neighborhoodValueIndexs = 0;
          // }
          // neighborhoodValueIndexs = parseFloat(neighborhoods[i].value) / 10;
          neighborhoodValueIndexs = get_converted_value(
            parseFloat(neighborhoods[i].value),
          );

          neighborhoods[i].personalNpi = Math.round(
            parseFloat(
              neighborhoods[i].school * targetFactorWeights["schools"] +
                neighborhoods[i].publicspaces *
                  2 *
                  targetFactorWeights["publicspaces"] +
                neighborhoods[i].crime * targetFactorWeights["safety"] +
                neighborhoods[i].curb * 2 * targetFactorWeights["curbAppeal"] +
                neighborhoods[i].walkability *
                  targetFactorWeights["walkability"] +
                neighborhoodValueIndexs *
                  targetFactorWeights["neighborhoodValueIndexs"],
            ) * 10,
          );

          // neighborhoods[i].personalNpi = Math.round(
          //   parseFloat(
          //     (neighborhoods[i].primaryschoolscore *
          //       targetFactorWeights["elementarySchool"]) /
          //       3.0 +
          //       (neighborhoods[i].middleschoolscore *
          //         targetFactorWeights["middleSchool"]) /
          //         3.0 +
          //       (neighborhoods[i].highschoolscore *
          //         targetFactorWeights["highSchool"]) /
          //         3.0 +
          //       neighborhoods[i].community * targetFactorWeights["community"] +
          //       neighborhoods[i].crime * targetFactorWeights["safety"] +
          //       neighborhoods[i].curb * targetFactorWeights["curbAppeal"] +
          //       neighborhoods[i].walkability *
          //         targetFactorWeights["walkability"] +
          //       neighborhoodValueIndexs *
          //         targetFactorWeights["neighborhoodValueIndexs"] *
          //         maxNviScaleFactors
          //   ) * 10
          // );
          //debugger;
        }
      }
      // this.clearpolysingle();
      // this.clearcitypolysingle();
      this.setState(
        {
          selectedNeighborhood: neighborhoods,
          selectednhid: neighborhoods[0].id,
        },
        () => {},
      );

      this.props.singleNeighbor(neighborhoods, "go");
    }
  };

  handleCloseClick = () => {
    let lat = localStorage.getItem("searchlatuser");
    let lang = localStorage.getItem("searchlanguser");
    this.clearpolysingle();
    this.clearhoveredmarkers();
    this.clearcitypolyhover();
    this.clearcitypolysingle();
    this.clearpoly();
    this.clearschoolpoly();
    this.map.state.map.setCenter({
      lat: parseFloat(lat),
      lng: parseFloat(lang),
    });
    this.map.state.map.setZoom(11);
  };

  refreshMap(address, isBayView) {
    const google = (window.google = window.google ? window.google : {});
    this.setState({ selectednhid: "" });
    var geocoder = new google.maps.Geocoder();
    if (geocoder) {
      if (address === undefined) {
        let lhpStr = "npi";
        if (this.state.tabselect === 0) {
          lhpStr = "npi";

          // setTimeout(() => {
          //   (this.bound_changed("npi"), this.get_homes());
          // }, 1500);
          this.bound_changed("npi");
          this.get_homes();
        } else if (this.state.tabselect === 1) {
          lhpStr = "personal";
          this.bound_changed(lhpStr);
          this.get_homes();
        } else if (this.state.tabselect === 5) {
          lhpStr = "price";
          this.bound_changed(lhpStr);
          this.get_homes();
        } else if (this.state.tabselect === 2) {
          lhpStr = "all";
          let lhpStr1 = "all";
          this.bound_changed(lhpStr);
          this.get_school2(lhpStr1);
          this.get_homes();
        } else if (this.state.tabselect === 3) {
          lhpStr = "crime";
          this.bound_changed(lhpStr);
          this.get_homes();
        } else if (this.state.tabselect === 4 || this.state.tabselect === 16) {
          lhpStr = "amenities";
          this.bound_changed(lhpStr);
          this.get_homes();
        } else if (this.state.tabselect === 7) {
          lhpStr = "appreciation";
          this.bound_changed(lhpStr);
          this.get_homes();
        } else if (this.state.tabselect === 6) {
          lhpStr = "value";
          this.bound_changed(lhpStr);
          this.get_homes();
        } else if (this.state.tabselect === 8) {
          lhpStr = "all";
          let lhpStr1 = "all";
          this.bound_changed(lhpStr);
          this.get_school2(lhpStr1);
          this.get_homes();
        } else if (this.state.tabselect === 9) {
          lhpStr = "school";
          let lhpStr1 = "Primary";
          this.bound_changed(lhpStr);
          this.get_school2(lhpStr1);
          this.get_homes();
        } else if (this.state.tabselect === 10) {
          lhpStr = "school";
          let lhpStr1 = "Middle";
          this.bound_changed(lhpStr);
          this.get_school2(lhpStr1);
          this.get_homes();
        } else if (this.state.tabselect === 11) {
          lhpStr = "school";
          let lhpStr1 = "High";
          this.bound_changed(lhpStr);
          this.get_school2(lhpStr1);
          this.get_homes();
        } else if (this.state.tabselect === 12) {
          lhpStr = "walkability";
          this.clearschoolMarkers();
          this.clearpoly();
          this.clearschoolpoly();
          this.bound_changed(lhpStr);
          this.get_homes();
        } else if (this.state.tabselect === 13) {
          lhpStr = "publicspaces";
          this.clearschoolMarkers();
          this.clearpoly();
          this.clearschoolpoly();
          this.bound_changed(lhpStr);
          this.get_homes();
        } else if (this.state.tabselect === 14) {
          lhpStr = "walkability";
          this.clearschoolMarkers();
          this.clearpoly();
          this.clearschoolpoly();
          this.bound_changed(lhpStr);
          this.get_homes();
        } else if (this.state.tabselect === 15) {
          lhpStr = "curb";
          this.clearschoolMarkers();
          this.clearpoly();
          this.clearschoolpoly();
          this.bound_changed(lhpStr);
          this.get_homes();
        } else if (this.state.tabselect === 18) {
          lhpStr = "price";
          this.clearschoolMarkers();
          this.clearpoly();
          this.clearschoolpoly();
          this.bound_changed(lhpStr);
          this.get_homes();
        } else if (this.state.tabselect === 20) {
          lhpStr = "value";
          this.clearschoolMarkers();
          this.clearpoly();
          this.clearschoolpoly();
          this.bound_changed(lhpStr);
          this.get_homes();
        }
      }

      this.gmarkers;
      for (let i = 0; i < this.gmarkers.length; i++) {
        this.gmarkers[i].setMap(null);
      }

      let url = window.location.origin;
      let finalurl;
      if (address && address != undefined && address != "") {
        finalurl = url + "/?address=" + address;
      } else {
        const searchParams = new URLSearchParams(window.location.search);
        const searchaddress = searchParams.get("address");
        //  finalurl = url+"/?address=San Francisco, CA, USA";
        if (searchaddress === null || searchaddress === "") {
          finalurl = url + "/?address=San Francisco, CA, USA";
        } else {
          finalurl = url + "/?address=" + searchaddress;
        }
      }

      localStorage.setItem("redirecturl", finalurl);
      this.clearpoly();
      this.clearschoolpoly();
      if (geocoder) {
        let is_listing = false;
        geocodeByAddress(address)
          .then((results) => getLatLng(results[0]))
          .then((latLng) => {
            let that = this;

            if (geocoder) {
              geocoder.geocode(
                { address: address },
                function (results, status) {
                  let searchaddress = address.replace(/,[^,]+$/, "%");

                  //    if(results[0].types[0] !="locality" && results[0].types[0] !="neighborhood"){

                  // }
                  // that.map.state.map.fitBounds(latLng);

                  // if(results[0].types[0] === "neighborhood"){

                  const getdatanew = {
                    start: 0,
                    limit: 1,
                    orderBy: "label",
                    order: "ASC",
                    fields: [
                      {
                        name: "label",
                        value: searchaddress,
                        operator: "LIKE",
                      },
                    ],
                  };
                  //  let propsnew = this.props;
                  let reversedCoordsnew = "";
                  getSearchNeighbors(getdatanew)
                    .then((result) => {
                      var schoolsdata = that.props.schoolbar_val / 10;
                      var safetydata = that.props.crimebar_val / 10;
                      var walkabilitydata = that.props.walkbar_val / 10;
                      var publicspacesdata = that.props.townbar_val / 10;
                      var curbAppealdata = that.props.curbbar_val / 10;
                      var valueindexdata = that.props.valuebar_val;
                      //selected value from slider wrap

                      var targetRadiusFromSearchLocations = 0; // in miles
                      var targetSearchLocationLats;
                      var targetSearchLocationLongs;
                      var targetMinPrices = 0;
                      var targetMaxPrices = 0;

                      const minPriceAdjustments = 0.85;
                      const maxPriceAdjustments = 1.15;
                      const minRadiuss = 5.0; // in miles
                      const bayAreaNeighborhoodMinimumMedianPrices = 500000.0; // benchmarked to median home price for Antioch
                      const maxNviScaleFactors = 0.096;
                      if (targetRadiusFromSearchLocations < minRadiuss) {
                        targetRadiusFromSearchLocations = minRadiuss;
                      }
                      targetMinPrices *= minPriceAdjustments;
                      targetMaxPrices *= maxPriceAdjustments;

                      let neighborhoods = [];
                      if (result.data.getSearchNeighbors.length > 0) {
                        {
                          result.data.getSearchNeighbors.map((item, index) => {
                            neighborhoods.push({
                              id: item.id,
                              name: item.name,
                              school: parseFloat(item.school),
                              crime: parseFloat(item.crime),
                              walkability: parseFloat(item.walkability),
                              publicspaces: parseFloat(item.publicspaces),
                              curb: parseFloat(item.curb),
                              amenities: parseFloat(item.amenities),
                              primaryschoolscore: item.primaryschoolscore || 0,
                              middleschoolscore: item.middleschoolscore || 0,
                              highschoolscore: item.highschoolscore || 0,
                              npi: parseFloat(item.npi),
                              medianprice: item.medianprice,
                              value: parseFloat(item.value),
                              personal: parseFloat(item.personal),
                              personalNpi: 0,
                              geometry_cords: item.geometry_cords,
                              neighborhoodImages: item.neighborhoodImages,
                              savedneighbor: item.savedneighbor,
                              is_display_prod: item.is_display_prod,
                              is_display_dev: item.is_display_dev,
                              appreciation: item.appreciation,
                              nhsummary: item.nhsummary,
                              nhfullname: item.nhfullname,
                              postalcity_name: item.postalcity_name,
                              label: item.label,
                            });
                          });
                        }
                        if (neighborhoods.length > 0) {
                          for (var i = 0; i < neighborhoods.length; i++) {
                            var sumOfWeights = 0;

                            if (neighborhoods[i].school > 0) {
                              sumOfWeights += Number(schoolsdata);
                            }
                            if (neighborhoods[i].crime > 0) {
                              sumOfWeights += Number(safetydata);
                            }
                            if (neighborhoods[i].walkability > 0) {
                              sumOfWeights += Number(walkabilitydata);
                            }
                            if (neighborhoods[i].publicspaces > 0) {
                              sumOfWeights += Number(publicspacesdata);
                            }
                            if (neighborhoods[i].curb > 0) {
                              sumOfWeights += Number(curbAppealdata);
                            }

                            var targetFactorWeights = {
                              schools: schoolsdata / sumOfWeights,
                              safety: safetydata / sumOfWeights,
                              walkability: walkabilitydata / sumOfWeights,
                              publicspaces: publicspacesdata / sumOfWeights,
                              curbAppeal: curbAppealdata / sumOfWeights,
                              elementarySchool: 0,
                              middleSchool: 0,
                              highSchool: 0,
                              neighborhoodValueIndexs:
                                valueindexdata / sumOfWeights,
                            };
                            targetFactorWeights["schools"] =
                              schoolsdata / sumOfWeights;

                            // Copy school weight into elementarySchool, middleSchool, highSchool
                            targetFactorWeights["elementarySchool"] =
                              targetFactorWeights["schools"];
                            targetFactorWeights["middleSchool"] =
                              targetFactorWeights["schools"];
                            targetFactorWeights["highSchool"] =
                              targetFactorWeights["schools"];
                            var neighborhoodValueIndexs = 0;
                            if (neighborhoods[i].medianprice !== 0) {
                              neighborhoodValueIndexs =
                                (neighborhoods[i].npi / 10) *
                                (bayAreaNeighborhoodMinimumMedianPrices /
                                  neighborhoods[i].medianprice);
                            } else {
                              neighborhoodValueIndexs = 0;
                            }

                            neighborhoodValueIndexs = get_converted_value(
                              neighborhoods[i].value,
                            );

                            // neighborhoodValueIndexs =
                            // neighborhoods[i].value / 10;
                            neighborhoods[i].personalNpi = Math.round(
                              parseFloat(
                                neighborhoods[i].school *
                                  targetFactorWeights["schools"] +
                                  neighborhoods[i].publicspaces *
                                    2 *
                                    targetFactorWeights["publicspaces"] +
                                  neighborhoods[i].crime *
                                    targetFactorWeights["safety"] +
                                  neighborhoods[i].curb *
                                    2 *
                                    targetFactorWeights["curbAppeal"] +
                                  neighborhoods[i].walkability *
                                    targetFactorWeights["walkability"],
                              ) * 10,
                            );
                          }
                        }
                        that.clearpolysingle();
                        that.clearhoveredmarkers();
                        that.clearcitypolysingle();
                        that.setState(
                          {
                            selectedNeighborhood: neighborhoods,
                            selectednhid: neighborhoods[0].id,
                            searchednh: neighborhoods,
                          },
                          () => {
                            setTimeout(function () {
                              var element =
                                document.getElementById("single_main_top");
                              if (element) {
                                element.classList.add("open");
                                element.scrollIntoView({
                                  behavior: "smooth",
                                });
                              }
                            }, 500);
                          },
                        );

                        that.props.singleNeighbor(neighborhoods);

                        result.data.getSearchNeighbors.map((item, index) => {
                          if (item.geometry_cords) {
                            that.props.addressInfo.setState({
                              address,
                              lat: parseFloat(item.latitude),
                              lng: parseFloat(item.longitude),
                              // zoom: that.props
                            });
                            that.map.state.map.setCenter({
                              lat: parseFloat(item.latitude),
                              lng: parseFloat(item.longitude),
                            });

                            let newdata = JSON.parse(item.geometry_cords[0]);
                            let reservdedata = newdata.map((item2, index2) => {
                              return {
                                lat: parseFloat(item2.x),
                                lng: parseFloat(item2.y),
                              };
                            });

                            // that.props.addressInfo.setState({
                            //   address,
                            //   lat: item2.x,
                            //   lng: item2.y,
                            //  // zoom: that.props
                            // });
                            let get_zoom = that.map.state.map.getZoom();
                            that.setState({ in_zoom: true });

                            if (get_zoom <= 11) {
                              that.map.state.map.setZoom(get_zoom + 2);
                            } else if (get_zoom === 12) {
                              that.map.state.map.setZoom(get_zoom + 1);
                            } else if (get_zoom > 12 && get_zoom <= 15) {
                              that.map.state.map.setZoom(get_zoom);
                            } else if (get_zoom >= 17) {
                              that.map.state.map.setZoom(get_zoom - 3);
                            } else if (get_zoom === 16) {
                              that.map.state.map.setZoom(get_zoom - 2);
                            }

                            that.bermudaTriangle2 = new google.maps.Polygon({
                              paths: [reservdedata],
                              strokeWeight: 3.5,
                              strokeColor: "#c02e26",
                              fillOpacity: 0,
                              zIndex: 4,
                              id: item.id,
                            });
                          }
                        });

                        google.maps.event.addListener(
                          that.bermudaTriangle2,
                          "dblclick",
                          function (event) {
                            //window.open(`/Neighborhood/?id=${that.id}`, "_blank");
                            //Router.push('/DetailsNh');
                          },
                        );

                        let propsnew = that.props;
                        google.maps.event.addListener(
                          that.bermudaTriangle2,
                          "click",
                          function (event) {
                            that.clearcitypolysingle();

                            let currenttab = propsnew.checkRhptab();
                            let ids = neighborhoods[0].id;
                            if (currenttab === 1 && !that.state.isClickable) {
                              window.open(
                                `/Neighborhood/${neighborhoods[0].nhfullname}`,
                                "_blank",
                              );
                            } else {
                              //propsnew.singleClick();
                            }

                            let single_nh_arr = [];
                            let single_nh = that.state.fetchneighbor.find(
                              (o) => o.id === ids,
                            );
                            single_nh_arr.push(single_nh);
                            if (single_nh_arr.length > 0) {
                              // setsingle();
                              // function setsingle() {
                              //   propsnew.singleNeighbor(single_nh_arr);
                              // }
                              that.drawPolygon(single_nh_arr);
                              that.setState({
                                selectedNeighborhood: single_nh_arr,
                              });
                              // var element =
                              //   document.getElementById("single_main_top");
                              // if (element) {
                              //   element.classList.add("open");
                              //   element.scrollIntoView();
                              // }
                            }

                            //Router.push('/DetailsNh');
                          },
                        );
                        google.maps.event.addListener(
                          that.bermudaTriangle2,
                          "mouseover",
                          function (event) {
                            that.clearpolysingle();
                            that.clearhoveredmarkers();
                            //that.clearcitypolysingle();

                            let nhid = neighborhoods[0].id;
                            let single_nh_arr = [];
                            let single_nh = that.state.fetchneighbor.find(
                              (o) => o.id === nhid,
                            );
                            if (single_nh && single_nh !== undefined) {
                              single_nh_arr.push(single_nh);
                            }
                            if (single_nh_arr.length > 0) {
                              // setsingle();
                              // function setsingle() {
                              //   propsnew.singleNeighbor(single_nh_arr);
                              // }
                              that.setState({
                                selectedNeighborhood: single_nh_arr,
                              });
                              // var element =
                              //   document.getElementById("single_main_top");
                              // if (element) {
                              //   element.classList.add("open");
                              //   setTimeout(function () {
                              //     element.scrollIntoView({
                              //       behavior: "smooth",
                              //     });
                              //   }, 500);
                              // }
                            }
                          },
                        );
                        that.bermudaTriangle2.setMap(that.map.state.map);
                        that.nbermudaTrianglesingle.push(that.bermudaTriangle2);
                      } else if (
                        results[0].types[0] === "university" ||
                        results[0].types[0] === "school" ||
                        results[0].types[0] === "establishment" ||
                        results[0].types[0] === "political"
                      ) {
                        let modifiedAddress =
                          address.includes("(") &&
                          address.includes(")") &&
                          address.match(/\([^,]*,[^)]*\)/)
                            ? address.replace(/\(([^)]+)\)/g, (match) =>
                                match.replace(",", "%%"),
                              )
                            : address;

                        let schooladdress = modifiedAddress.split(",");
                        let schoolname = schooladdress[0]
                          .trim()
                          .replace("%%", ",");
                        let schoolcity = schooladdress[1]?.trim();
                        const getdata = {
                          start: 0,
                          limit: 1,
                          orderBy: "School",
                          order: "DESC",
                          fields: [
                            {
                              name: "School",
                              value: schoolname,
                              operator: "=",
                            },
                            {
                              name: "City",
                              value: schoolcity,
                              operator: "=",
                            },
                          ],
                          zoomLevel: 13,
                        };
                        getSchoolinNh(getdata)
                          .then((result) => {
                            result.data.getSchoolinNh.map((item, index) => {
                              let schooltypes = "School";
                              if (
                                that.schoolgrades.primaryarr.includes(
                                  item.GSserved,
                                )
                              ) {
                                schooltypes = "Primary";
                              } else if (
                                that.schoolgrades.middlearr.includes(
                                  item.GSserved,
                                )
                              ) {
                                schooltypes = "Middle";
                              } else if (
                                that.schoolgrades.higharr.includes(
                                  item.GSserved,
                                )
                              ) {
                                schooltypes = "High";
                              }
                              that.props.checkschool(schooltypes);
                              that.setState({ selectedschoolid: item.id });
                              that.setState({
                                selectedschoollat: item.SchoolLat,
                              });
                              that.setState({
                                selectedschoollng: item.SchoolLong,
                              });
                              that.map.state.map.setCenter({
                                lat: parseFloat(item.SchoolLat),
                                lng: parseFloat(item.SchoolLong),
                              });
                              if (
                                item.Boundary !== "" &&
                                item.Boundary !== null
                              ) {
                                let sdata = [];

                                sdata.push(item.Boundary);

                                sdata &&
                                  sdata.length > 0 &&
                                  sdata.map((item3, index3) => {
                                    item3.map((item4, index4) => {
                                      //this.primary_polygon_points = [];
                                      let newdata = JSON.parse(item4);

                                      let reversedCoordsnew = newdata[0].map(
                                        (item5, index5) => {
                                          return {
                                            lat: parseFloat(item5.x),
                                            lng: parseFloat(item5.y),
                                          };
                                        },
                                      );

                                      that.schoolsinglepolygon =
                                        new google.maps.Polygon({
                                          paths: reversedCoordsnew,
                                          strokeWeight: 3.5,
                                          strokeColor: "#c02e26",
                                          fillOpacity: 0,
                                          zIndex: 2,
                                        });

                                      that.schoolsinglepolygon.setMap(
                                        that.map.state.map,
                                      );
                                      that.schoolsinglepoly.push(
                                        that.schoolsinglepolygon,
                                      );
                                    });
                                  });
                                let selectedicon = {
                                  url:
                                    process.env.NEXT_PUBLIC_CDN_ID +
                                    "static/images/schooliconlarge.png",
                                };
                                let myLatlng = {
                                  lat: parseFloat(item.SchoolLat),
                                  lng: parseFloat(item.SchoolLong),
                                };
                                const marker = new google.maps.Marker({
                                  position: myLatlng,
                                  icon: selectedicon,
                                });
                                // To add the marker to the map, call setMap();
                                marker.setMap(that.map.state.map);
                                that.singleschoolmarker.push(marker);
                              }

                              that.setState({ popupdisplay: "block" });
                              that.setState({ schoolpopupname: item.School });
                              that.setState({
                                schoolgreatschoolurl: item.greatschoolurl,
                              });
                              let schoolrate = 0;
                              if (
                                item.TestScores !== "" &&
                                item.TestScores > 0
                              ) {
                                schoolrate = item.TestScores / 2;
                              }
                              that.setState({
                                schoolpopuprating: item.TestScores,
                              });
                              that.setState({
                                schoolpopupgrade: schooltypes,
                              });
                              that.setState({
                                schoolpopuptype: item.GSserved,
                              });
                              that.setState({
                                schoolwebsite: item.Website,
                              });
                              that.setState({
                                schoolstudent: item.NumberofStudents,
                              });
                              that.setState({
                                schoolstudentratio: item.StudentRatio,
                              });
                            });
                          })
                          .catch((err) => {
                            that.map.state.map.setCenter({
                              lat: latLng.lat,
                              lng: latLng.lng,
                            });
                          });
                      } else {
                        that.map.state.map.fitBounds(
                          results[0].geometry.viewport,
                        );
                        that.props.addressInfo.setState({
                          address,
                          lat: latLng.lat,
                          lng: latLng.lng,
                          // zoom: that.props
                        });
                        if (
                          results[0].types[0] != "locality" &&
                          results[0].types[0] != "neighborhood"
                        ) {
                          let g_address = address.split(",");

                          that.setState({ selected_id_single: g_address });
                          that.setState({ selected_lat: latLng.lat });
                          that.setState({ selected_lng: latLng.lng });
                        }

                        // that.map.state.map.setCenter({
                        //   lat: latLng.lat,
                        //   lng: latLng.lng,
                        // });

                        var citydata = [];
                        that.setState({
                          selectedNeighborhood: [],
                          selectednhid: "",
                        });
                        that.props.singleNeighbor([]);
                        axios
                          .get(
                            `https://nominatim.openstreetmap.org/search?q=${address}&polygon_geojson=1&format=geojson`,
                          )
                          .then((res) => {
                            window.city = res;
                            let cityname = address.split(",");

                            if (res.data && res.data.features.length > 0) {
                              that.clearpolysingle();
                              that.clearhoveredmarkers();
                              that.clearcitypolysingle();
                              that.props.singleNeighbor([]);
                              var city_info = res.data;

                              that.setState({ singlecityname: cityname[0] });
                              //that.props.singleCity(cityname[0]);
                              var id = 0;
                              if (
                                searchaddress === "Hillsborough, CA%" ||
                                searchaddress === "Hillsborough CA%" ||
                                searchaddress === "Hillsborough, California%" ||
                                searchaddress === "San Mateo%" ||
                                searchaddress === "San Mateo" ||
                                searchaddress === "Alameda, CA%" ||
                                searchaddress === "San Mateo CA%" ||
                                searchaddress === "San Mateo, CA%" ||
                                searchaddress === "San Mateo, California%" ||
                                searchaddress === "Hillsborough" ||
                                searchaddress === "Hillsborough CA"
                              ) {
                                id = 1;
                              } else {
                                if (
                                  res.data &&
                                  res.data.features &&
                                  res.data.features[id].geometry.type ===
                                    "Point"
                                ) {
                                  id = 1;
                                }
                              }
                              if (
                                res.data &&
                                res.data.features &&
                                res.data.features[id] &&
                                res.data.features[id].geometry.type ===
                                  "Polygon"
                              ) {
                                citydata =
                                  res.data.features[id].geometry.coordinates[0];
                              } else if (
                                res.data &&
                                res.data.features &&
                                res.data.features[id] &&
                                res.data.features[id].geometry.type ===
                                  "MultiPolygon"
                              ) {
                                var c_length =
                                  res.data.features[id].geometry.coordinates
                                    .length;
                                citydata =
                                  res.data.features[id].geometry
                                    .coordinates[0][0];
                              }
                              window.y = res.data;
                              if (
                                res.data &&
                                res.data.features &&
                                res.data.features[id] &&
                                res.data.features[id].geometry.type ===
                                  "MultiPolygon"
                              ) {
                                var cities_length =
                                  res.data.features[id].geometry.coordinates
                                    .length;
                                var multi_city = [];
                                for (var i = 0; i < cities_length; i++) {
                                  multi_city.push(
                                    res.data.features[id].geometry.coordinates[
                                      i
                                    ][0].map((item, index) => {
                                      return {
                                        lat: parseFloat(item[1]),
                                        lng: parseFloat(item[0]),
                                      };
                                    }),
                                  );
                                }
                                that.bermudaTriangle3 = new google.maps.Polygon(
                                  {
                                    paths: multi_city,
                                    strokeWeight: 3.6,
                                    strokeColor: "#c02e26",
                                    fillOpacity: 0,
                                    zIndex: 4,
                                    name: city_info.features[id].properties
                                      .display_name,
                                  },
                                );
                                google.maps.event.addListener(
                                  that.bermudaTriangle3,
                                  "dblclick",
                                  function (event) {
                                    window.open(`/City/${that.name}`, "_blank");
                                  },
                                );
                                google.maps.event.addListener(
                                  that.bermudaTriangle3,
                                  "click",
                                  function (event) {
                                    // window.open(`/City/?name=?${this.name}`,'_blank');
                                    that.setState({ popupdisplay: "none" });
                                  },
                                );
                                google.maps.event.addListener(
                                  that.bermudaTriangle3,
                                  "mouseover",
                                  function (event) {
                                    that.bermudaTriangle3.setOptions({
                                      zIndex: 0,
                                    });
                                  },
                                );

                                that.bermudaTriangle3.setMap(
                                  that.map.state.map,
                                );
                                that.citybermudaTrianglesingle.push(
                                  that.bermudaTriangle3,
                                );
                              } else {
                                let city_reservdedata = citydata.map(
                                  (item5, index5) => {
                                    return {
                                      lat: parseFloat(item5[1]),
                                      lng: parseFloat(item5[0]),
                                    };
                                  },
                                );
                                that.bermudaTriangle3 = new google.maps.Polygon(
                                  {
                                    paths: [city_reservdedata],
                                    strokeWeight: 3.6,
                                    strokeColor: "#c02e26",
                                    fillOpacity: 0,
                                    zIndex: 4,
                                    name: city_info.features[0].properties
                                      .display_name,
                                  },
                                );
                                google.maps.event.addListener(
                                  that.bermudaTriangle3,
                                  "dblclick",
                                  function (event) {
                                    window.open(`/City/${this.name}`, "_blank");
                                    //Router.push('/DetailsNh');
                                  },
                                );
                                google.maps.event.addListener(
                                  that.bermudaTriangle3,
                                  "mouseover",
                                  function (event) {
                                    that.bermudaTriangle3.setOptions({
                                      zIndex: 0,
                                    });
                                  },
                                );
                                google.maps.event.addListener(
                                  that.bermudaTriangle3,
                                  "click",
                                  function (event) {
                                    // window.open(`/City/?name=?${this.name}`,'_blank');
                                  },
                                );
                                that.bermudaTriangle3.setMap(
                                  that.map.state.map,
                                );
                                that.citybermudaTrianglesingle.push(
                                  that.bermudaTriangle3,
                                );
                              }
                            }
                          });
                      }

                      if (status == google.maps.GeocoderStatus.OK) {
                        // that.map.state.map.fitBounds(
                        //   results[0].geometry.viewport
                        // );
                        setTimeout(() => that.onsetzoom(isBayView && 11), 500);
                      } else {
                        that.setState({ in_zoom: true });
                      }
                    })
                    .catch((error) => {
                      console.error(error);
                    });
                },
              );
            }

            that.map.state.map.data.forEach(function (feature) {
              that.map.state.map.data.remove(feature);
            });
            let lhpStr = "npi";
            if (that.props.addressInfo.state.lhpFactor === 1) {
              lhpStr = "personal";
            } else if (that.props.addressInfo.state.lhpFactor === 5) {
              lhpStr = "price";
            } else if (that.props.addressInfo.state.lhpFactor === 2) {
              lhpStr = "all";
            } else if (that.props.addressInfo.state.lhpFactor === 3) {
              lhpStr = "crime";
            } else if (that.props.addressInfo.state.lhpFactor === 4) {
              lhpStr = "walkability";
            } else if (that.props.addressInfo.state.lhpFactor === 7) {
              lhpStr = "appreciation";
            } else if (that.props.addressInfo.state.lhpFactor === 6) {
              lhpStr = "value";
            } else if (that.props.addressInfo.state.lhpFactor === 12) {
              lhpStr = "others";
            } else if (this.state.tabselect === 8) {
              lhpStr = "all";
              let lhpStr1 = "all";
            } else if (this.state.tabselect === 9) {
              lhpStr = "school";
              let lhpStr1 = "Primary";
            } else if (this.state.tabselect === 10) {
              lhpStr = "school";
              let lhpStr1 = "Middle";
            } else if (this.state.tabselect === 11) {
              lhpStr = "school";
              let lhpStr1 = "High";
            }
            //this.bound_changed(lhpStr);
          })
          .catch((error) => {
            console.error("Error", error);
          });
      }
    } else {
      //location.reload();
    }
  }

  onsetzoom = (zoom) => {
    let that = this;
    let c_zoom = that.map.state.map.getZoom();
    that.setState({ in_zoom: true });

    if (zoom) that.map.state.map.setZoom(zoom);
    else if (c_zoom <= 11) {
      that.map.state.map.setZoom(c_zoom + 2);
    } else if (c_zoom === 12) {
      that.map.state.map.setZoom(c_zoom + 1);
    } else if (c_zoom > 12 && c_zoom <= 15) {
      that.map.state.map.setZoom(c_zoom);
    } else if (c_zoom >= 17) {
      that.map.state.map.setZoom(c_zoom - 3);
    } else if (c_zoom === 16) {
      that.map.state.map.setZoom(c_zoom - 2);
    }
  };

  onZoomChanged = debounce(() => {
    // Mark that user has interacted with the map
    this.hasUserInteracted = true;

    this.neighborhoodsetpsdata = [];
    this.props.handletab(true);
    var mapzoom = this.map.state.map.getZoom();
    this.props.singleHome([]);
    this.setState({ selectedNeighborhood: [] });
    var prev_nh =
      this.state.selectedNeighborhood &&
      this.state.selectedNeighborhood.length > 0
        ? this.state.selectedNeighborhood
        : "";
    var prev_lat =
      this.state.selectedNeighborhood &&
      this.state.selectedNeighborhood.length > 0
        ? parseFloat(this.state.selectedNeighborhood[0].latitude)
        : "";
    var prev_lng =
      this.state.selectedNeighborhood &&
      this.state.selectedNeighborhood.length > 0
        ? parseFloat(this.state.selectedNeighborhood[0].longitude)
        : "";
    var prev_polygon =
      this.state.selectedNeighborhood &&
      this.state.selectedNeighborhood.length > 0
        ? this.state.selectedNeighborhood[0].geometry_cords
        : "";
    // this.inViewport(prev_nh, prev_lat, prev_lng, prev_polygon);
    let logindata = JSON.parse(localStorage.getItem("auth_query"));

    if (logindata) {
      localStorage.setItem("searchzoom", mapzoom);
    } else {
      localStorage.setItem("searchzoomuser", mapzoom);
    }
    this.props.addressInfo.changeZoom(mapzoom);
    if (this.state.in_zoom || mapzoom > 0) {
      let lhpStr = "npi";
      if (this.state.tabselect === "") {
        this.bound_changed("npi");
      } else if (this.state.tabselect === 0) {
        lhpStr = "npi";
        this.bound_changed("npi");
        //setTimeout(() => this.bound_changed("npi"), 500);
      } else if (this.state.tabselect === 1) {
        lhpStr = "personal";
        this.bound_changed(lhpStr);
      } else if (this.state.tabselect === 5) {
        lhpStr = "price";
        this.bound_changed(lhpStr);
      } else if (this.state.tabselect === 2) {
        lhpStr = "all";
        let lhpStr1 = "all";
        this.bound_changed(lhpStr);
        this.get_school2(lhpStr1);
        // this.get_homes();
      } else if (this.state.tabselect === 3) {
        lhpStr = "crime";
        this.bound_changed(lhpStr);
      } else if (this.state.tabselect === 4 || this.state.tabselect === 16) {
        lhpStr = "amenities";
        this.bound_changed(lhpStr);
      } else if (this.state.tabselect === 7) {
        lhpStr = "appreciation";
        this.bound_changed(lhpStr);
      } else if (this.state.tabselect === 6) {
        lhpStr = "value";
        this.bound_changed(lhpStr);
      } else if (this.state.tabselect === 8) {
        lhpStr = "all";
        let lhpStr1 = "all";
        this.bound_changed(lhpStr);
        this.get_school2(lhpStr1);
        // this.get_homes();
      } else if (this.state.tabselect === 9) {
        lhpStr = "school";
        let lhpStr1 = "Primary";
        this.bound_changed(lhpStr);
        this.get_school2(lhpStr1);
        // this.get_homes();
      } else if (this.state.tabselect === 10) {
        lhpStr = "school";
        let lhpStr1 = "Middle";
        this.bound_changed(lhpStr);
        this.get_school2(lhpStr1);
        // this.get_homes();
      } else if (this.state.tabselect === 11) {
        lhpStr = "school";
        let lhpStr1 = "High";
        this.bound_changed(lhpStr);
        this.get_school2(lhpStr1);
        // this.get_homes();
      } else if (this.state.tabselect === 12) {
        lhpStr = "walkability";

        this.bound_changed(lhpStr);
      } else if (this.state.tabselect === 13) {
        lhpStr = "publicspaces";

        this.bound_changed(lhpStr);
      } else if (this.state.tabselect === 14) {
        lhpStr = "walkability";

        this.bound_changed(lhpStr);
      } else if (this.state.tabselect === 15) {
        lhpStr = "curb";

        this.bound_changed(lhpStr);
      } else if (this.state.tabselect === 18) {
        lhpStr = "price";

        this.bound_changed(lhpStr);
      } else if (this.state.tabselect === 20) {
        lhpStr = "value";

        this.bound_changed(lhpStr);
      }
      this.get_homes();
    }
  }, 1000);

  inViewport = (prev_nh, prev_lat, prev_lng, prev_polygon) => {
    let bounds = this.map.state.map.getBounds();
    var point = new google.maps.LatLng(prev_lat, prev_lng);
    let propsnew = this.props;
    var status = this.map.state.map.getBounds().contains(point);
    if (status === false) {
      this.clearpolysingle();
      propsnew.singleNeighbor([]);
    } else {
      this.drawPolygon(prev_nh);
      var repeat = true;
      propsnew.singleNeighbor(prev_nh, repeat);
    }
  };

  drawPolygon = (neighborhood) => {
    if (neighborhood && neighborhood.length > 0) {
      let reservdedata = JSON.parse("[" + neighborhood[0].geometry_cords + "]");

      this.bermudaTriangle2 = new google.maps.Polygon({
        paths: reservdedata,
        strokeWeight: neighborhood[0].savedneighborhoodbyuser === "1" ? 4 : 3.5,
        // strokeColor:
        //   neighborhood[0].savedneighborhoodbyuser === "1"
        //     ? "#c02e26"
        //     : "#c02e26",
        strokeColor: "#c02e26",
        fillOpacity: 0,
        zIndex: 4,
        id: neighborhood[0].id,
      });
      let propsnew = this.props;
      let that = this;

      google.maps.event.addListener(
        this.bermudaTriangle2,
        "click",
        function (event) {
          let currenttab = propsnew.checkRhptab();
          if (currenttab === 1 && !that.state.isClickable) {
            window.open(
              `/Neighborhood/${neighborhood[0].nhfullname}`,
              "_blank",
            );
          } else {
            propsnew.singleClick();
          }
          // window.open(`/Neighborhood/?id=${neighborhood[0].id}`, "_blank");
        },
      );
      google.maps.event.addListener(
        that.bermudaTriangle2,
        "mouseover",
        function (event) {
          that.clearhoveredmarkers();
          !that.state.isMobile &&
            that.sethoveredmarker(
              neighborhood[0].latitude,
              neighborhood[0].longitude,
              neighborhood[0].nhfullname,
            );
          that.setState({ selectedNeighborhood: neighborhood });
          // setsingle();
          // function setsingle() {
          //   propsnew.singleNeighbor(neighborhood);
          // }
          // var element = document.getElementById("single_main_top");
          // if (element) {
          //   element.classList.add("open");
          //   setTimeout(function () {
          //     element.scrollIntoView({
          //       behavior: "smooth",
          //     });
          //   }, 500);
          // }
        },
      );
      google.maps.event.addListener(
        that.bermudaTriangle2,
        "mouseout",
        function (event) {
          that.clearhoveredmarkers();
        },
      );
      this.bermudaTriangle2.setMap(this.map.state.map);
      this.nbermudaTrianglesingle.push(this.bermudaTriangle2);
    }
  };

  onDragChanged = debounce(() => {
    // Mark that user has interacted with the map
    this.hasUserInteracted = true;

    this.setState({ drag_change: true });
    this.neighborhoodsetpsdata = [];
    this.props.singleHome([]);

    window.test = this.state.selectedNeighborhood;
    var prev_nh =
      this.state.selectedNeighborhood &&
      this.state.selectedNeighborhood.length > 0
        ? this.state.selectedNeighborhood
        : "";
    var prev_lat =
      this.state.selectedNeighborhood &&
      this.state.selectedNeighborhood.length > 0
        ? parseFloat(this.state.selectedNeighborhood[0].latitude)
        : "";
    var prev_lng =
      this.state.selectedNeighborhood &&
      this.state.selectedNeighborhood.length > 0
        ? parseFloat(this.state.selectedNeighborhood[0].longitude)
        : "";
    var prev_polygon =
      this.state.selectedNeighborhood &&
      this.state.selectedNeighborhood.length > 0
        ? this.state.selectedNeighborhood[0].geometry_cords
        : "";

    let lhpStr = "npi";
    if (this.state.tabselect === "") {
      this.bound_changed("npi");
    } else if (this.state.tabselect === 0) {
      lhpStr = "npi";
      this.bound_changed(lhpStr);
    } else if (this.state.tabselect === 1) {
      lhpStr = "personal";
      this.bound_changed(lhpStr);
    } else if (this.state.tabselect === 5) {
      lhpStr = "price";
      this.bound_changed(lhpStr);
    } else if (this.state.tabselect === 2) {
      lhpStr = "all";
      let lhpStr1 = "all";
      this.bound_changed(lhpStr);
      this.get_school2(lhpStr1);
      // this.get_homes();
    } else if (this.state.tabselect === 3) {
      lhpStr = "crime";
      this.bound_changed(lhpStr);
    } else if (this.state.tabselect === 4 || this.state.tabselect === 16) {
      lhpStr = "amenities";
      this.bound_changed(lhpStr);
    } else if (this.state.tabselect === 7) {
      lhpStr = "appreciation";
      this.bound_changed(lhpStr);
    } else if (this.state.tabselect === 6) {
      lhpStr = "value";
      this.bound_changed(lhpStr);
    } else if (this.state.tabselect === 8) {
      lhpStr = "all";
      let lhpStr1 = "all";
      this.bound_changed(lhpStr);
      this.get_school2(lhpStr1);
      // this.get_homes();
    } else if (this.state.tabselect === 9) {
      lhpStr = "school";
      let lhpStr1 = "Primary";
      this.bound_changed(lhpStr);
      this.get_school2(lhpStr1);
      this.get_homes();
    } else if (this.state.tabselect === 10) {
      lhpStr = "school";
      let lhpStr1 = "Middle";
      this.bound_changed(lhpStr);
      this.get_school2(lhpStr1);
      // this.get_homes();
    } else if (this.state.tabselect === 11) {
      lhpStr = "school";
      let lhpStr1 = "High";
      this.bound_changed(lhpStr);
      this.get_school2(lhpStr1);
      // this.get_homes();
    } else if (this.state.tabselect === 12) {
      lhpStr = "walkability";
      this.bound_changed(lhpStr);
    } else if (this.state.tabselect === 13) {
      lhpStr = "publicspaces";
      this.bound_changed(lhpStr);
    } else if (this.state.tabselect === 14) {
      lhpStr = "walkability";
      this.bound_changed(lhpStr);
    } else if (this.state.tabselect === 15) {
      lhpStr = "curb";
      this.bound_changed(lhpStr);
    } else if (this.state.tabselect === 18) {
      lhpStr = "price";

      this.bound_changed(lhpStr);
    } else if (this.state.tabselect === 20) {
      lhpStr = "value";

      this.bound_changed(lhpStr);
    }
    this.get_homes();
  }, 1000);

  getdatafromindex(val) {
    this.getfilterdata = val;
    this.get_homes();
  }

  clearsingleschoolMarker() {
    if (this.singleschoolmarker.length > 0) {
      for (var i = 0; i < this.singleschoolmarker.length; i++) {
        if (this.singleschoolmarker[i]) {
          this.singleschoolmarker[i].setMap(null);
        }
      }
    }
  }

  clearschoolMarkers() {
    if (this.pschoolarr.length > 1) {
      for (var i = 0; i < this.pschoolarr.length; i++) {
        if (this.pschoolarr[i]) {
          this.pschoolarr[i].clearMarkers();
        }
      }
    }
    if (this.schoolarr.length > 1) {
      for (var i = 0; i < this.schoolarr.length; i++) {
        this.schoolarr[i].clearMarkers();
      }
    }
    if (this.schoolmarkerCluster) {
      this.schoolmarkerCluster.clearMarkers();
    }
    if (this.pschoolmarkerCluster) {
      this.pschoolmarkerCluster.clearMarkers();
    }
  }

  lhpTabChange(address) {
    this.selecedtabs = address;
    this.props.handletab(true);
    this.neighborhoodsetpsdata = [];
    this.setState({ isFirsttimeload: false });
    this.setState({ selectedschoolid: "" });
    let last_tab = "";
    if (address != 8) {
      last_tab = address;
    }
    this.setState({ is_first: true });
    this.setState({ is_nh_count_first: true });
    this.setState({ limit: 0 });
    for (var i = 0; i < this.sbermudaTriangle.length; i++) {
      this.sbermudaTriangle[i].setMap(null);
    }

    // var loadedstring=cookie.load("map-cookie");
    let that = this;
    that.map.state.map &&
      that.map.state.map.data.forEach(function (feature) {
        that.map.state.map.data.remove(feature);
      });

    address !== undefined &&
      address !== 1 &&
      this.setState({ tabselect: address });
    this.clearschoolpolysingle();
    this.clearsingleschoolMarker();
    let lhpStr = "npi";
    if (address === 0) {
      lhpStr = "npi";
      this.clearschoolMarkers();
      this.clearpoly();
      this.clearschoolpoly();
      this.bound_changed(lhpStr);
      this.setState({ selectedtab: "Overall Score" });
      this.setState({ popupdisplay: "none" });
    } else if (address === "personal_right") {
      lhpStr = "personal";
      this.clearschoolMarkers();
      this.clearpoly();
      this.clearschoolpoly();
      setTimeout(() => this.bound_changed(lhpStr), 1500);

      this.setState({
        selectedtab: "Personal",
      });
      this.setState({ tabselect: 1 });
      this.setState({ popupdisplay: "none" });
      //Router.push('/PersSearch');
    } else if (address === 1) {
      this.setState({
        selectedtab: "Personal",
      });
      this.props.handletab(false);
      this.clearschoolMarkers();
      this.clearpoly();
      this.clearschoolpoly();
      this.bound_changed("personal");
      this.setState({ tabselect: 1 });
      this.setState({ popupdisplay: "none" });
    } else if (address === 2) {
      // lhpStr = 'school'
      lhpStr = "all";
      let lhpStr1 = "all";
      if (this.pschoolmarkerCluster) {
        this.pschoolmarkerCluster.clearMarkers();
      }
      if (this.pschoolarr.length > 1) {
        for (var i = 0; i < this.pschoolarr.length; i++) {
          this.pschoolarr[i].clearMarkers();
        }
      }
      if (this.arr.length > 0) {
        for (var i = 0; i < this.arr.length; i++) {
          this.arr[i].clearMarkers();
        }
      }
      this.clearpoly();
      this.clearschoolpoly();

      this.bound_changed(lhpStr1);
      this.get_school2(lhpStr);
      this.get_homes();
      this.setState({ selectedtab: "School" });
    } else if (address === 3) {
      lhpStr = "crime";
      this.clearschoolMarkers();
      this.clearpoly();
      this.clearschoolpoly();
      this.bound_changed(lhpStr);
      this.setState({ selectedtab: "Safety" });
      this.setState({ popupdisplay: "none" });
    } else if (address === 4 || address === 16) {
      this.clearschoolMarkers();
      lhpStr = "amenities";
      this.clearpoly();
      this.clearschoolpoly();
      this.bound_changed(lhpStr);
      this.setState({ selectedtab: "Amenities" });
      this.setState({ popupdisplay: "none" });
    } else if (address === 7) {
      this.clearschoolMarkers();
      lhpStr = "appreciation";
      this.clearpoly();
      this.clearschoolpoly();
      this.bound_changed(lhpStr);
      this.setState({ selectedtab: "Appreciation" });
      this.setState({ popupdisplay: "none" });
    } else if (address === 6) {
      lhpStr = "value";
      this.clearschoolMarkers();
      this.clearpoly();
      this.clearschoolpoly();
      this.bound_changed(lhpStr);
      this.setState({ selectedtab: "Value" });
      this.setState({ popupdisplay: "none" });
    } else if (address === 5) {
      lhpStr = "price";
      this.clearschoolMarkers();
      this.clearpoly();
      this.clearschoolpoly();
      this.bound_changed(lhpStr);
      this.setState({ selectedtab: "Price" });
      this.setState({ popupdisplay: "none" });
    } else if (address === 8) {
      this.setState({ popupdisplay: "none" });
      this.clearschoolMarkers();
      lhpStr = "all";
      let lhpStr1 = "all";

      if (this.arr.length > 0) {
        for (var i = 0; i < this.arr.length; i++) {
          this.arr[i].clearMarkers();
        }
      }

      if (this.schoolmarkerCluster) {
        this.schoolmarkerCluster.clearMarkers();
      }

      if (this.schoolarr.length > 1) {
        for (var i = 0; i < this.schoolarr.length; i++) {
          this.schoolarr[i].clearMarkers();
        }
      }
      if (this.pschoolarr.length > 1) {
        for (var i = 0; i < this.pschoolarr.length; i++) {
          this.pschoolarr[i].clearMarkers();
        }
      }
      if (this.pschoolmarkerCluster) {
        this.pschoolmarkerCluster.clearMarkers();
      }

      this.clearpoly();
      this.clearschoolpoly();
      this.bound_changed(lhpStr1);
      this.get_school2(lhpStr);
      this.get_homes(lhpStr);
      this.setState({ selectedtab: "School" });
    } else if (address === 9) {
      this.clearschoolMarkers();
      this.setState({ popupdisplay: "none" });
      lhpStr = "Primary";
      let lhpStr1 = "school";

      if (this.arr.length > 0) {
        for (var i = 0; i < this.arr.length; i++) {
          this.arr[i].clearMarkers();
        }
      }

      if (this.schoolmarkerCluster) {
        this.schoolmarkerCluster.clearMarkers();
      }

      if (this.schoolarr.length > 1) {
        for (var i = 0; i < this.schoolarr.length; i++) {
          this.schoolarr[i].clearMarkers();
        }
      }
      if (this.pschoolarr.length > 1) {
        for (var i = 0; i < this.pschoolarr.length; i++) {
          this.pschoolarr[i].clearMarkers();
        }
      }
      if (this.pschoolmarkerCluster) {
        this.pschoolmarkerCluster.clearMarkers();
      }

      this.clearpoly();
      this.clearschoolpoly();
      this.bound_changed(lhpStr1);
      this.get_school2(lhpStr);
      this.get_homes(lhpStr);
      this.setState({ selectedtab: "Elementary School" });
    } else if (address === 10) {
      this.clearschoolMarkers();
      this.setState({ popupdisplay: "none" });
      lhpStr = "Middle";
      let lhpStr1 = "school";
      if (this.arr.length > 0) {
        for (var i = 0; i < this.arr.length; i++) {
          this.arr[i].clearMarkers();
        }
      }

      if (this.schoolmarkerCluster) {
        this.schoolmarkerCluster.clearMarkers();
      }

      if (this.schoolarr.length > 1) {
        for (var i = 0; i < this.schoolarr.length; i++) {
          this.schoolarr[i].clearMarkers();
        }
      }
      if (this.pschoolarr.length > 1) {
        for (var i = 0; i < this.pschoolarr.length; i++) {
          this.pschoolarr[i].clearMarkers();
        }
      }
      if (this.pschoolmarkerCluster) {
        this.pschoolmarkerCluster.clearMarkers();
      }

      this.clearpoly();
      this.clearschoolpoly();
      this.bound_changed(lhpStr1);
      this.get_school2(lhpStr);
      this.get_homes(lhpStr);
      this.setState({ selectedtab: "Middle School" });
    } else if (address === 11) {
      this.clearschoolMarkers();
      this.setState({ popupdisplay: "none" });
      lhpStr = "High";
      let lhpStr1 = "school";

      if (this.arr.length > 0) {
        for (var i = 0; i < this.arr.length; i++) {
          this.arr[i].clearMarkers();
        }
      }

      if (this.schoolmarkerCluster) {
        this.schoolmarkerCluster.clearMarkers();
      }

      if (this.schoolarr.length > 1) {
        for (var i = 0; i < this.schoolarr.length; i++) {
          this.schoolarr[i].clearMarkers();
        }
      }
      if (this.pschoolarr.length > 1) {
        for (var i = 0; i < this.pschoolarr.length; i++) {
          this.pschoolarr[i].clearMarkers();
        }
      }
      if (this.pschoolmarkerCluster) {
        this.pschoolmarkerCluster.clearMarkers();
      }

      this.clearpoly();
      this.clearschoolpoly();
      this.bound_changed(lhpStr1);
      this.get_school2(lhpStr);
      this.get_homes(lhpStr);
      this.setState({ selectedtab: "High School" });
    } else if (address === 12) {
      lhpStr = "walkability";
      this.clearschoolMarkers();
      this.clearpoly();
      this.clearschoolpoly();
      this.bound_changed(lhpStr);
      this.setState({ selectedtab: "Near Merchants" });
      this.setState({ popupdisplay: "none" });
    } else if (address === 13) {
      lhpStr = "publicspaces";
      this.clearschoolMarkers();
      this.clearpoly();
      this.clearschoolpoly();
      this.bound_changed(lhpStr);
      this.setState({ selectedtab: "Public Spaces" });
      this.setState({ popupdisplay: "none" });
    } else if (address === 14) {
      lhpStr = "others";
      this.clearschoolMarkers();
      this.clearpoly();
      this.clearschoolpoly();
      this.bound_changed(lhpStr);
      this.setState({ selectedtab: "Walkable Streets" });
      this.setState({ popupdisplay: "none" });
    } else if (address === 15) {
      lhpStr = "curb";
      this.clearschoolMarkers();
      this.clearpoly();
      this.clearschoolpoly();
      this.bound_changed(lhpStr);
      this.setState({ selectedtab: "Curb Appeal" });
      this.setState({ popupdisplay: "none" });
    } else if (address === 17) {
      this.props.handletab(false);
    } else if (address === 18) {
      lhpStr = "price";
      this.clearschoolMarkers();
      this.clearpoly();
      this.clearschoolpoly();
      this.bound_changed(lhpStr);
      this.setState({ selectedtab: "Price" });
      this.setState({ popupdisplay: "none" });
    } else if (address === 20) {
      lhpStr = "value";
      this.clearschoolMarkers();
      this.clearpoly();
      this.clearschoolpoly();
      this.bound_changed(lhpStr);
      this.setState({ selectedtab: "Value" });
      this.setState({ popupdisplay: "none" });
    }
  }

  clearschoolpoly = () => {
    for (var i = 0; i < this.ppbermudaTriangle.length; i++) {
      this.ppbermudaTriangle[i].setMap(null);
    }

    this.school_points = [];
    this.schoolarr = [];
    //this.pschoolarr = [];
    this.primary_polygon_points = [];
    this.pschoolmarkers = [];
    this.pschoolpoints = [];
  };

  clearpoly = () => {
    for (var i = 0; i < this.nbermudaTriangle.length; i++) {
      this.nbermudaTriangle[i].setMap(null);
    }
    // for (var i = 0; i < this.ppbermudaTriangle.length; i++) {
    //   this.ppbermudaTriangle[i].setMap(null);
    // }
    this.polygon_points = [];
    //this.school_points = [];
    //this.schoolarr = [];
    //this.pschoolarr = [];
    //this.primary_polygon_points = [];
    //this.pschoolmarkers = [];
    //this.pschoolpoints = [];
  };

  clearpolysingle = () => {
    for (var i = 0; i < this.nbermudaTrianglesingle.length; i++) {
      //if (this.state.selectednhid)
      if (this.state.selectednhid !== this.nbermudaTrianglesingle[i].id) {
        this.nbermudaTrianglesingle[i].setMap(null);
      }
    }
  };
  oncloseclearpolysingle = () => {
    for (var i = 0; i < this.nbermudaTrianglesingle.length; i++) {
      //if (this.state.selectednhid)
      //if (this.state.selectednhid !== this.nbermudaTrianglesingle[i].id) {
      this.nbermudaTrianglesingle[i].setMap(null);

      //}
    }
    this.props.singleNeighbor([]);
    this.setState({ selectednhid: "" });
    this.setState({ searchednh: [] });
  };
  clearschoolpolysingle = () => {
    for (var i = 0; i < this.schoolsinglepoly.length; i++) {
      this.schoolsinglepoly[i].setMap(null);
    }
  };

  clearcitypolyhover = () => {
    for (var i = 0; i < this.citybermudaTrianglehover.length; i++) {
      this.citybermudaTrianglehover[i].setMap(null);
    }
  };

  clearcitypolysingle = () => {
    for (var i = 0; i < this.citybermudaTrianglesingle.length; i++) {
      this.citybermudaTrianglesingle[i].setMap(null);
    }
  };
  clearsavedcitypolygon = (cityname) => {
    for (var i = 0; i < this.savedcitypolygon.length; i++) {
      if (cityname === this.savedcitypolygon[i].city) {
        this.savedcitypolygon[i].poly.setMap(null);
      }
    }
  };

  initialize_home = (finallisitng, lhpStr) => {
    let savedhomeids = [];
    if (this.finalsavedhomedata && this.finalsavedhomedata.length > 0) {
      this.finalsavedhomedata.map((item, index) => {
        savedhomeids.push(item.ListingKeyNumeric);
      });
    }
    let selectedarea = "";
    if (this.getfilterdata && Object.keys(this.getfilterdata).length > 0) {
      if (this.getfilterdata.forSale.includes("Active")) {
        selectedarea = "active";
      } else if (
        this.getfilterdata.forSale.includes("Sold") ||
        this.getfilterdata.forSale.includes("Pending")
      ) {
        selectedarea = "soldpending";
      }
    }
    if (finallisitng && (finallisitng === null || finallisitng.length === 0)) {
      // this.setState({ loaderdispaly: "none" });
      this.setState(
        {
          fetchhome: [],
        },
        function () {
          this.props.onChange([]);
          this.props.homefiltercount([]);
        },
      );
    }
    if (finallisitng && finallisitng.length > 0) {
      this.setState(
        {
          fetchhome: finallisitng,
        },
        function () {
          this.props.onChange(finallisitng);
          this.props.homefiltercount(finallisitng);
        },
      );
      let locations = [];

      let arr = this.state.fetchhome.sort(function (a, b) {
        return b.MlsStatus.localeCompare(a.MlsStatus);
      });

      const res = {};
      let statusdata = [];
      arr.forEach((obj) => {
        const key = parseFloat(obj.Longitude).toFixed(6);
        const key2 = parseFloat(obj.Latitude).toFixed(6);
        const finalkey = key + " " + key2;

        if (!res[finalkey]) {
          res[finalkey] = { count: 0, ...obj };
        }

        res[finalkey].count += 1;

        if (obj.MlsStatus === "Active") {
          res[finalkey].allstatus = "Active";
          return;
        } else if (
          obj.StandardStatus === "Pending" ||
          obj.MlsStatus === "Contingent"
        ) {
          res[finalkey].allstatus = "Pending";
          return;
        } else if (obj.MlsStatus === "Sold" || obj.MlsStatus === "Closed") {
          res[finalkey].allstatus = "Sold";
          return;
        } else {
          res[finalkey].allstatus = "";
          return;
        }
      });
      //return Object.values(res);

      let uniquedata = Object.values(res);
      locations = uniquedata.map((item, index) => {
        /* return {
        lat: parseFloat(item.lat),
        lng: parseFloat(item.lang),
        price: item.price,
        beds: item.bedCount,
        bath: item.bathCount
      }*/

        //if (!this.home_points.includes(item.Latitude + item.Longitude)) {
        //this.home_points.push(item.Latitude + item.Longitude);
        if (!this.home_points.includes(item.ListingKeyNumeric)) {
          this.home_points.push(item.ListingKeyNumeric);
          let anchor_origin = new google.maps.Point(35, 25);
          // if (this.home_cords.includes(item.Latitude + item.Longitude)) {
          //   anchor_origin = new google.maps.Point(38, 42);
          // } else {
          this.home_cords.push(item.Latitude + item.Longitude);
          // }

          return {
            lat: parseFloat(item.Latitude),
            lng: parseFloat(item.Longitude),
            price: item.ListPrice,
            beds: item.BedroomsTotal,
            baths: item.BathroomsTotalInteger,
            homeaddress: item.UnparsedAddress,
            ListingKeyNumeric: item.ListingKeyNumeric,
            PropertySubType: item.PropertySubType,
            latlng: item.Latitude + item.Longitude,
            anchor_origin: anchor_origin,
            mlsstatus: item.MlsStatus,
            PropertyType: item.PropertyType,
            StandardStatus: item.StandardStatus,
            count: item.count,
            allstatus: item.allstatus,
            ClosePrice: item.ClosePrice,
            SourceId: item.SourceId || "",
            exists: false,
          };
        } else {
          return { exists: true };
        }
      });

      let redhomeicon = {
        url: process.env.NEXT_PUBLIC_CDN_ID + "static/images/Price2-red.png",
        scaledSize: new google.maps.Size(35, 25),
        strokeColor: "#c02e26",
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(35, 25),
        labelOrigin: new google.maps.Point(18, 8),
        //fontSize: "8px"
      };

      /* let markers = locations.map(function(location, i) {
       let price = location.price;
       let newloc = {lat:location.lat,lng:location.lng};
       return new google.maps.Marker({
         position: newloc,
         label: `${humanFormat(price)}`,
         icon: icons
       });
     });*/
      if (this.arr.length > 0) {
        for (var i = 0; i < this.arr.length; i++) {
          this.arr[i].clearMarkers();
        }
      }
      this.homegmarkers = [];
      this.home_points = [];
      this.arr = [];

      locations.map((location, i) => {
        if (location.exists) {
          return;
        }
        // let duplicate_points = this.home_cords.filter(
        //   (item, index) => this.home_cords.indexOf(item) !== index
        // );

        // let icon_origin = new google.maps.Point(35, 25);

        // if (duplicate_points.includes(location.latlng)) {
        //   if (location.ListingKeyNumeric === 14640941) {
        //     icon_origin = new google.maps.Point(38, 42);
        //   } else {
        //     icon_origin = new google.maps.Point(35, 25);
        //   }
        // }

        let icons = "";
        if (location.count > 1) {
          if (savedhomeids.includes(location.ListingKeyNumeric)) {
            icons = redhomeicon;
          } else if (location.PropertyType === "ResidentialLease") {
            icons = {
              url:
                process.env.NEXT_PUBLIC_CDN_ID +
                "static/images/Price2-purple.png",
              scaledSize: new google.maps.Size(35, 25),
              strokeColor: "#c02e26",
              origin: new google.maps.Point(0, 0),
              anchor: location.anchor_origin,
              labelOrigin: new google.maps.Point(18, 8),
              //fontSize: "8px"
            };
          } else if (location.allstatus === "Sold") {
            icons = {
              url:
                process.env.NEXT_PUBLIC_CDN_ID +
                "static/images/Price2-blue.png",
              scaledSize: new google.maps.Size(35, 25),
              strokeColor: "#c02e26",
              origin: new google.maps.Point(0, 0),
              anchor: location.anchor_origin,
              labelOrigin: new google.maps.Point(18, 8),
              //fontSize: "8px"
            };
          } else if (location.allstatus === "Pending") {
            icons = {
              url:
                process.env.NEXT_PUBLIC_CDN_ID +
                "static/images/Price2-green.png",
              scaledSize: new google.maps.Size(35, 25),
              strokeColor: "#c02e26",
              origin: new google.maps.Point(0, 0),
              anchor: location.anchor_origin,
              labelOrigin: new google.maps.Point(18, 8),
              //fontSize: "8px"
            };
          } else {
            icons = {
              url: process.env.NEXT_PUBLIC_CDN_ID + "static/images/Price2.png",
              scaledSize: new google.maps.Size(35, 25),
              strokeColor: "#c02e26",
              origin: new google.maps.Point(0, 0),
              anchor: location.anchor_origin,
              labelOrigin: new google.maps.Point(18, 8),
              //fontSize: "8px"
            };
          }
        } else {
          if (savedhomeids.includes(location.ListingKeyNumeric)) {
            icons = redhomeicon;
          } else if (location.PropertyType === "ResidentialLease") {
            icons = {
              url:
                process.env.NEXT_PUBLIC_CDN_ID +
                "static/images/Price2-purple.png",
              scaledSize: new google.maps.Size(35, 25),
              strokeColor: "#c02e26",
              origin: new google.maps.Point(0, 0),
              anchor: location.anchor_origin,
              labelOrigin: new google.maps.Point(18, 8),
              //fontSize: "8px"
            };
          } else if (location.mlsstatus === "Sold") {
            icons = {
              url:
                process.env.NEXT_PUBLIC_CDN_ID +
                "static/images/Price2-blue.png",
              scaledSize: new google.maps.Size(35, 25),
              strokeColor: "#c02e26",
              origin: new google.maps.Point(0, 0),
              anchor: location.anchor_origin,
              labelOrigin: new google.maps.Point(18, 8),
              //fontSize: "8px"
            };
          } else if (
            location.StandardStatus === "Pending" ||
            location.mlsstatus === "Contingent"
          ) {
            icons = {
              url:
                process.env.NEXT_PUBLIC_CDN_ID +
                "static/images/Price2-green.png",
              scaledSize: new google.maps.Size(35, 25),
              strokeColor: "#c02e26",
              origin: new google.maps.Point(0, 0),
              anchor: location.anchor_origin,
              labelOrigin: new google.maps.Point(18, 8),
              //fontSize: "8px"
            };
          } else {
            icons = {
              url: process.env.NEXT_PUBLIC_CDN_ID + "static/images/Price2.png",
              scaledSize: new google.maps.Size(35, 25),
              strokeColor: "#c02e26",
              origin: new google.maps.Point(0, 0),
              anchor: location.anchor_origin,
              labelOrigin: new google.maps.Point(18, 8),
              //fontSize: "8px"
            };
          }
        }
        let price;

        if (location.mlsstatus === "Sold") {
          price = location.ClosePrice;
        } else {
          price = location.price;
        }
        let newloc = {
          lat: location.lat,
          lng: location.lng,
        };

        let bedcount = location.BedroomsTotal;
        let bathcount = location.BathroomsTotalInteger;
        let homeaddress = location.UnparsedAddress;
        let listingkey = location.ListingKeyNumeric;
        let status = location.mlsstatus;
        let properttype = location.PropertyType;
        let StandardStatus = location.StandardStatus;
        let markercount = location.count;
        let SourceId = location.SourceId;
        let marker;
        let clickid = "";
        let hoverid = "";
        let markertext = "";
        markertext =
          location.count > 1
            ? location.count.toString() + " " + "Units"
            : price &&
              price != null &&
              `${humanFormat(price, {
                decimals: price.toString().length < 7 ? 0 : 2,
              })}`;

        marker = new google.maps.Marker({
          position: new google.maps.LatLng(location.lat, location.lng),
          id: listingkey,
          label: {
            text: markertext,
            color: "#fff",
            fontSize: "12px",
          },
          icon: icons,
          status: status,
          properttype: properttype,
          StandardStatus: StandardStatus,
          SourceId: SourceId,
          // animation: google.maps.Animation.DROP
        });
        //}
        var infowindow = new google.maps.InfoWindow({
          disableAutoPan: true,
        });

        var infowaycontent =
          "<div style={{display: 'flex', flexDirection: 'column'}}> <div> Price: $" +
          `${price && humanFormat(price)}` +
          "</div> </div> <div> bed:" +
          `${bedcount || 0}` +
          "</div> </div> <div> bath:" +
          `${bathcount || 0}` +
          "</div> </div>";
        google.maps.event.addListener(
          marker,
          "mouseover",
          (function (marker, i) {
            return function () {
              let icons_all = {
                scaledSize: new google.maps.Size(35, 25),
                strokeColor: "#c02e26",
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(35, 25),
                labelOrigin: new google.maps.Point(18, 8),
              };
              let homemarkers = this.homegmarkers;
              homemarkers.filter(function (markersdata) {
                if (savedhomeids.includes(markersdata.id)) {
                  icons_all.url =
                    process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/Price2-red.png";
                } else if (markersdata.properttype === "ResidentialLease") {
                  icons_all.url =
                    process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/Price2-purple.png";
                } else if (markersdata.status === "Sold") {
                  icons_all.url =
                    process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/Price2-blue.png";
                } else if (
                  markersdata.StandardStatus === "Pending" ||
                  markersdata.status === "Contingent"
                ) {
                  icons_all.url =
                    process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/Price2-green.png";
                } else {
                  icons_all.url =
                    process.env.NEXT_PUBLIC_CDN_ID + "static/images/Price2.png";
                }
                //if (clickid !== markersdata.id) {
                markersdata.setIcon(icons_all);
                // }
              });
              hoverid = marker.id;
              infowindow.setContent(infowaycontent);

              icons_all.url =
                process.env.NEXT_PUBLIC_CDN_ID + "static/images/Price2-red.png";
              let icon_hover = {
                url:
                  process.env.NEXT_PUBLIC_CDN_ID +
                  "static/images/Price2-red.png",
                scaledSize: new google.maps.Size(35, 25),
                strokeColor: "#c02e26",
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(35, 25),
                labelOrigin: new google.maps.Point(18, 8),
                zIndex: 4,
                //fontSize: "8px"
              };

              marker.setIcon(icon_hover);

              // infowindow.open(this.map, marker);
            };
          })(marker, i).bind(this),
        );

        google.maps.event.addListener(
          marker,
          "mouseout",
          (function (marker, i) {
            return function () {
              infowindow.close(this.map, marker);
              let homemarkers = this.homegmarkers;
              let icons_all = {
                scaledSize: new google.maps.Size(35, 25),
                strokeColor: "#c02e26",
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(35, 25),
                labelOrigin: new google.maps.Point(18, 8),
              };
              homemarkers.filter(function (markersdata) {
                if (savedhomeids.includes(markersdata.id)) {
                  icons_all.url =
                    process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/Price2-red.png";
                } else if (markersdata.properttype === "ResidentialLease") {
                  icons_all.url =
                    process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/Price2-purple.png";
                } else if (markersdata.status === "Sold") {
                  icons_all.url =
                    process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/Price2-blue.png";
                } else if (
                  markersdata.StandardStatus === "Pending" ||
                  markersdata.status === "Contingent"
                ) {
                  icons_all.url =
                    process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/Price2-green.png";
                } else {
                  icons_all.url =
                    process.env.NEXT_PUBLIC_CDN_ID + "static/images/Price2.png";
                }
                if (clickid !== markersdata.id) {
                  markersdata.setIcon(icons_all);
                }
              });
            };
          })(marker, i).bind(this),
        );
        let iwindow = null;
        iwindow = new google.maps.InfoWindow({
          maxWidth: 350,
          maxHeight: 450,
        });
        var openwindow;

        google.maps.event.addListener(
          marker,
          "click",
          (function (marker, i) {
            return function () {
              clickid = marker.id;
              if (this.state.selected_id_single != "") {
                this.setState({ selected_id_single: "" });
              }
              for (var i = 0; i < this.infwindows.length; i++) {
                this.infwindows[i].close();
              }
              for (let i = 0; i < this.externalmarkers.length; i++) {
                this.externalmarkers[i].setMap(null);
              }
              // for (let i = 0; i < this.homegmarkers.length; i++) {
              //   if (this.homegmarkers[i].properttype === "ResidentialLease") {
              //     icons_all.url =
              //       process.env.NEXT_PUBLIC_CDN_ID +
              //       "static/images/Price2-purple.png";
              //   } else if (this.homegmarkers[i].status === "Sold") {
              //     icons_all.url =
              //       process.env.NEXT_PUBLIC_CDN_ID + "static/images/Price2-blue.png";
              //   } else if (
              //     this.homegmarkers[i].StandardStatus === "Pending" ||
              //     this.homegmarkers[i].status === "Contingent"
              //   ) {
              //     icons_all.url =
              //       process.env.NEXT_PUBLIC_CDN_ID +
              //       "static/images/Price2-green.png";
              //   } else {
              //     icons_all.url =
              //       process.env.NEXT_PUBLIC_CDN_ID + "static/images/Price2.png";
              //   }
              //   if (clickid !== this.homegmarkers[i].id) {
              //     this.homegmarkers[i].setIcon(icons_all);
              //   }
              // }
              if (markercount > 1) {
                const clicked_lat = newloc.lat.toFixed(6).toString();
                const clicked_lng = newloc.lng.toFixed(6).toString();
                let filterdhomesunsort = this.state.fetchhome.filter(
                  function (currentElement) {
                    let currentElementlat = parseFloat(
                      currentElement.Latitude,
                    ).toFixed(6);
                    let currentElementlng = parseFloat(
                      currentElement.Longitude,
                    ).toFixed(6);

                    return (
                      currentElementlat.toString() === clicked_lat &&
                      currentElementlng.toString() === clicked_lng
                    );
                  },
                );
                let datainfo = "";

                let filterdhomes = filterdhomesunsort.sort(function (a, b) {
                  return a.MlsStatus.localeCompare(b.MlsStatus);
                });

                const categoryhomes = filterdhomes.reduce((acc, curr) => {
                  if (!acc[curr.MlsStatus]) acc[curr.MlsStatus] = []; //If this type wasn't previously stored
                  acc[curr.MlsStatus].push(curr);
                  return acc;
                }, {});

                if (categoryhomes.Active && categoryhomes.Active.length > 0) {
                  let activefilterhomes = categoryhomes.Active;
                  for (
                    let i = 0, num = activefilterhomes.length;
                    i < num;
                    i++
                  ) {
                    let bathtotal;
                    let bedtotal;
                    let infoprice;
                    if (activefilterhomes[i].BathroomsHalf) {
                      bathtotal =
                        activefilterhomes[i].BathroomsFull +
                        activefilterhomes[i].BathroomsHalf * 0.5;
                    } else {
                      if (activefilterhomes[i].BathroomsFull != null) {
                        bathtotal = activefilterhomes[i].BathroomsFull;
                      } else {
                        bathtotal = "0";
                      }
                    }
                    if (activefilterhomes[i].BedroomsTotal != null) {
                      bedtotal = activefilterhomes[i].BedroomsTotal;
                    } else {
                      bedtotal = "0";
                    }
                    if (activefilterhomes[i].mlsstatus === "Sold") {
                      infoprice =
                        "$" + humanFormat(activefilterhomes[i].ClosePrice);
                    } else if (
                      Number.isInteger(activefilterhomes[i].ListPrice)
                    ) {
                      infoprice =
                        "$" + humanFormat(activefilterhomes[i].ListPrice);
                    } else {
                      infoprice = activefilterhomes[i].ListPrice;
                    }
                    let media;

                    if (activefilterhomes[i].SourceId) {
                      if (activefilterhomes[i].ThumbnailUrl) {
                        media = activefilterhomes[i].ThumbnailUrl;
                      } else {
                        media =
                          process.env.NEXT_PUBLIC_CDN_ID +
                          "static/images/homedefault.jpg";
                      }
                    } else {
                      if (
                        activefilterhomes[i].Media &&
                        activefilterhomes[i].Media.length > 0
                      ) {
                        media = activefilterhomes[i].Media[0].MediaURL;
                      } else {
                        media =
                          process.env.NEXT_PUBLIC_CDN_ID +
                          "static/images/homedefault.jpg";
                      }
                    }
                    if (i === 0) {
                      datainfo +=
                        "<div className='infotitle' style='padding: 5px 10px;'>Active</div>";
                    }
                    datainfo +=
                      '<div className="buildingRow" style="display: flex;flex-wrap: nowrap;justify-content: space-between;padding: 4px 10px;"><div className="left" style="width: 37%;height: 82px;"><img src="' +
                      media +
                      '" style="width: 100%;height: auto;" ></div><div className="right" style=" width: 58%;display: flex;flex-direction: column;justify-content: space-between;    padding: 11px 0;"><a target="_blank" href="' +
                      "/DetailsListing/?id=" +
                      activefilterhomes[i].ListingKeyNumeric +
                      '"className="unitNumber button-text link" style="font-size: 1rem;font-weight: 500;text-align: left;display: inline-block;fill: #1080a2;">' +
                      "#" +
                      activefilterhomes[i].ListingKeyNumeric +
                      '</a><div className="price" style="font-size: 1rem;font-weight: 500;">' +
                      infoprice +
                      '</div><div className="amenity" style="font-size: 0.75rem;">' +
                      bedtotal +
                      " beds · " +
                      bathtotal +
                      "  baths · " +
                      activefilterhomes[i].LivingArea +
                      " sq. ft.</div></div></div></div>";
                  }
                }
                if (
                  categoryhomes.Contingent &&
                  categoryhomes.Contingent.length > 0
                ) {
                  let pendingfilterhomes = categoryhomes.Contingent;
                  for (
                    let i = 0, num = pendingfilterhomes.length;
                    i < num;
                    i++
                  ) {
                    let bathtotal;
                    let bedtotal;
                    let infoprice;
                    if (pendingfilterhomes[i].BathroomsHalf) {
                      bathtotal =
                        pendingfilterhomes[i].BathroomsFull +
                        pendingfilterhomes[i].BathroomsHalf * 0.5;
                    } else {
                      if (pendingfilterhomes[i].BathroomsFull != null) {
                        bathtotal = pendingfilterhomes[i].BathroomsFull;
                      } else {
                        bathtotal = "0";
                      }
                    }
                    if (pendingfilterhomes[i].BedroomsTotal != null) {
                      bedtotal = pendingfilterhomes[i].BedroomsTotal;
                    } else {
                      bedtotal = "0";
                    }
                    if (pendingfilterhomes[i].mlsstatus === "Sold") {
                      infoprice =
                        "$" + humanFormat(pendingfilterhomes[i].ClosePrice);
                    } else if (
                      Number.isInteger(pendingfilterhomes[i].ListPrice)
                    ) {
                      infoprice =
                        "$" + humanFormat(pendingfilterhomes[i].ListPrice);
                    } else {
                      infoprice = pendingfilterhomes[i].ListPrice;
                    }
                    let media;

                    if (pendingfilterhomes[i].SourceId) {
                      if (pendingfilterhomes[i].ThumbnailUrl) {
                        media = pendingfilterhomes[i].ThumbnailUrl;
                      } else {
                        media =
                          process.env.NEXT_PUBLIC_CDN_ID +
                          "static/images/homedefault.jpg";
                      }
                    } else {
                      if (
                        pendingfilterhomes[i].Media &&
                        pendingfilterhomes[i].Media.length > 0
                      ) {
                        media = pendingfilterhomes[i].Media[0].MediaURL;
                      } else {
                        media =
                          process.env.NEXT_PUBLIC_CDN_ID +
                          "static/images/homedefault.jpg";
                      }
                    }
                    if (i === 0) {
                      datainfo +=
                        "<div className='infotitle' style='padding: 5px 10px;'>Pending</div>";
                    }
                    datainfo +=
                      '<div className="buildingRow" style="display: flex;flex-wrap: nowrap;justify-content: space-between;padding: 4px 10px;"><div className="left" style="width: 37%;height: 82px;"><img src="' +
                      media +
                      '" style="width: 100%;height: auto;"></div><div className="right" style=" width: 58%;display: flex;flex-direction: column;justify-content: space-between;    padding: 11px 0;"><a target="_blank" href="' +
                      "/DetailsListing/?id=" +
                      pendingfilterhomes[i].ListingKeyNumeric +
                      '"className="unitNumber button-text link" style="font-size: 1rem;font-weight: 500;text-align: left;display: inline-block;fill: #1080a2;">' +
                      "#" +
                      pendingfilterhomes[i].ListingKeyNumeric +
                      '</a><div className="price" style="font-size: 1rem;font-weight: 500;">' +
                      infoprice +
                      '</div><div className="amenity" style="font-size: 0.75rem;">' +
                      bedtotal +
                      " beds · " +
                      bathtotal +
                      "  baths · " +
                      pendingfilterhomes[i].LivingArea +
                      " sq. ft.</div></div></div></div>";
                  }
                }

                if (categoryhomes.Closed && categoryhomes.Closed.length > 0) {
                  let Closedhomes = categoryhomes.Closed;
                  for (let i = 0, num = Closedhomes.length; i < num; i++) {
                    let bathtotal;
                    let bedtotal;
                    let infoprice;
                    if (Closedhomes[i].BathroomsHalf) {
                      bathtotal =
                        Closedhomes[i].BathroomsFull +
                        Closedhomes[i].BathroomsHalf * 0.5;
                    } else {
                      if (Closedhomes[i].BathroomsFull != null) {
                        bathtotal = Closedhomes[i].BathroomsFull;
                      } else {
                        bathtotal = "0";
                      }
                    }
                    if (Closedhomes[i].BedroomsTotal != null) {
                      bedtotal = Closedhomes[i].BedroomsTotal;
                    } else {
                      bedtotal = "0";
                    }
                    if (Closedhomes[i].mlsstatus === "Sold") {
                      infoprice = "$" + humanFormat(Closedhomes[i].ClosePrice);
                    } else if (Number.isInteger(Closedhomes[i].ListPrice)) {
                      infoprice = "$" + humanFormat(Closedhomes[i].ListPrice);
                    } else {
                      infoprice = Closedhomes[i].ListPrice;
                    }
                    let media;

                    if (Closedhomes[i].SourceId) {
                      if (Closedhomes[i].ThumbnailUrl) {
                        media = Closedhomes[i].ThumbnailUrl;
                      } else {
                        media =
                          process.env.NEXT_PUBLIC_CDN_ID +
                          "static/images/homedefault.jpg";
                      }
                    } else {
                      if (
                        Closedhomes[i].Media &&
                        Closedhomes[i].Media.length > 0
                      ) {
                        media = Closedhomes[i].Media[0].MediaURL;
                      } else {
                        media =
                          process.env.NEXT_PUBLIC_CDN_ID +
                          "static/images/homedefault.jpg";
                      }
                    }
                    if (
                      categoryhomes.Contingent &&
                      categoryhomes.Contingent.length > 0
                    ) {
                      datainfo += "";
                    } else if (i === 0) {
                      datainfo +=
                        "<div className='infotitle' style='padding: 5px 10px;'>Closed</div>";
                    }
                    datainfo +=
                      '<div className="buildingRow" style="display: flex;flex-wrap: nowrap;justify-content: space-between;padding: 4px 10px;"><div className="left" style="width: 37%;height: 82px;"><img src="' +
                      media +
                      '" style="width: 100%;height: auto;"></div><div className="right" style=" width: 58%;display: flex;flex-direction: column;justify-content: space-between;    padding: 11px 0;"><a target="_blank" href="' +
                      "/DetailsListing/?id=" +
                      Closedhomes[i].ListingKeyNumeric +
                      '"className="unitNumber button-text link" style="font-size: 1rem;font-weight: 500;text-align: left;display: inline-block;fill: #1080a2;">' +
                      "#" +
                      Closedhomes[i].ListingKeyNumeric +
                      '</a><div className="price" style="font-size: 1rem;font-weight: 500;">' +
                      infoprice +
                      '</div><div className="amenity" style="font-size: 0.75rem;">' +
                      bedtotal +
                      " beds · " +
                      bathtotal +
                      "  baths · " +
                      Closedhomes[i].LivingArea +
                      " sq. ft.</div></div></div></div>";
                  }
                }

                if (categoryhomes.Pending && categoryhomes.Pending.length > 0) {
                  let Pendinghomes = categoryhomes.Pending;
                  for (let i = 0, num = Pendinghomes.length; i < num; i++) {
                    let bathtotal;
                    let bedtotal;
                    let infoprice;
                    if (Pendinghomes[i].BathroomsHalf) {
                      bathtotal =
                        Pendinghomes[i].BathroomsFull +
                        Pendinghomes[i].BathroomsHalf * 0.5;
                    } else {
                      if (Pendinghomes[i].BathroomsFull != null) {
                        bathtotal = Pendinghomes[i].BathroomsFull;
                      } else {
                        bathtotal = "0";
                      }
                    }
                    if (Pendinghomes[i].BedroomsTotal != null) {
                      bedtotal = Pendinghomes[i].BedroomsTotal;
                    } else {
                      bedtotal = "0";
                    }
                    if (Pendinghomes[i].mlsstatus === "Sold") {
                      infoprice = "$" + humanFormat(Pendinghomes[i].ClosePrice);
                    } else if (Number.isInteger(Pendinghomes[i].ListPrice)) {
                      infoprice = "$" + humanFormat(Pendinghomes[i].ListPrice);
                    } else {
                      infoprice = Pendinghomes[i].ListPrice;
                    }
                    let media;

                    if (Pendinghomes[i].SourceId) {
                      if (Pendinghomes[i].ThumbnailUrl) {
                        media = Pendinghomes[i].ThumbnailUrl;
                      } else {
                        media =
                          process.env.NEXT_PUBLIC_CDN_ID +
                          "static/images/homedefault.jpg";
                      }
                    } else {
                      if (
                        Pendinghomes[i].Media &&
                        Pendinghomes[i].Media.length > 0
                      ) {
                        media = Pendinghomes[i].Media[0].MediaURL;
                      } else {
                        media =
                          process.env.NEXT_PUBLIC_CDN_ID +
                          "static/images/homedefault.jpg";
                      }
                    }
                    if (
                      categoryhomes.Contingent &&
                      categoryhomes.Contingent.length > 0
                    ) {
                      datainfo += "";
                    } else if (i === 0) {
                      datainfo +=
                        "<div className='infotitle' style='padding: 5px 10px;'>Pending</div>";
                    }
                    datainfo +=
                      '<div className="buildingRow" style="display: flex;flex-wrap: nowrap;justify-content: space-between;padding: 4px 10px;"><div className="left" style="width: 37%;height: 82px;"><img src="' +
                      media +
                      '" style="width: 100%;height: auto;"></div><div className="right" style=" width: 58%;display: flex;flex-direction: column;justify-content: space-between;    padding: 11px 0;"><a target="_blank" href="' +
                      "/DetailsListing/?id=" +
                      Pendinghomes[i].ListingKeyNumeric +
                      '"className="unitNumber button-text link" style="font-size: 1rem;font-weight: 500;text-align: left;display: inline-block;fill: #1080a2;">' +
                      "#" +
                      Pendinghomes[i].ListingKeyNumeric +
                      '</a><div className="price" style="font-size: 1rem;font-weight: 500;">' +
                      infoprice +
                      '</div><div className="amenity" style="font-size: 0.75rem;">' +
                      bedtotal +
                      " beds · " +
                      bathtotal +
                      "  baths · " +
                      Pendinghomes[i].LivingArea +
                      " sq. ft.</div></div></div></div>";
                  }
                }

                if (
                  categoryhomes.PendingDoNotShow &&
                  categoryhomes.PendingDoNotShow.length > 0
                ) {
                  let pendingshowfilterhomes = categoryhomes.PendingDoNotShow;
                  for (
                    let i = 0, num = pendingshowfilterhomes.length;
                    i < num;
                    i++
                  ) {
                    let bathtotal;
                    let bedtotal;
                    let infoprice;
                    if (pendingshowfilterhomes[i].BathroomsHalf) {
                      bathtotal =
                        pendingshowfilterhomes[i].BathroomsFull +
                        pendingshowfilterhomes[i].BathroomsHalf * 0.5;
                    } else {
                      if (pendingshowfilterhomes[i].BathroomsFull != null) {
                        bathtotal = pendingshowfilterhomes[i].BathroomsFull;
                      } else {
                        bathtotal = "0";
                      }
                    }
                    if (pendingshowfilterhomes[i].BedroomsTotal != null) {
                      bedtotal = pendingshowfilterhomes[i].BedroomsTotal;
                    } else {
                      bedtotal = "0";
                    }
                    if (pendingshowfilterhomes[i].mlsstatus === "Sold") {
                      infoprice =
                        "$" + humanFormat(pendingshowfilterhomes[i].ClosePrice);
                    } else if (
                      Number.isInteger(pendingshowfilterhomes[i].ListPrice)
                    ) {
                      infoprice =
                        "$" + humanFormat(pendingshowfilterhomes[i].ListPrice);
                    } else {
                      infoprice = pendingshowfilterhomes[i].ListPrice;
                    }
                    let media;

                    if (pendingshowfilterhomes[i].SourceId) {
                      if (pendingshowfilterhomes[i].ThumbnailUrl) {
                        media = pendingshowfilterhomes[i].ThumbnailUrl;
                      } else {
                        media =
                          process.env.NEXT_PUBLIC_CDN_ID +
                          "static/images/homedefault.jpg";
                      }
                    } else {
                      if (
                        pendingshowfilterhomes[i].Media &&
                        pendingshowfilterhomes[i].Media.length > 0
                      ) {
                        media = pendingshowfilterhomes[i].Media[0].MediaURL;
                      } else {
                        media =
                          process.env.NEXT_PUBLIC_CDN_ID +
                          "static/images/homedefault.jpg";
                      }
                    }
                    if (
                      categoryhomes.Contingent &&
                      categoryhomes.Contingent.length > 0
                    ) {
                      datainfo += "";
                    } else if (i === 0) {
                      datainfo +=
                        "<div className='infotitle' style='padding: 5px 10px;'>Pending</div>";
                    }
                    datainfo +=
                      '<div className="buildingRow" style="display: flex;flex-wrap: nowrap;justify-content: space-between;padding: 4px 10px;"><div className="left" style="width: 37%;height: 82px;"><img src="' +
                      media +
                      '" style="width: 100%;height: auto;"></div><div className="right" style=" width: 58%;display: flex;flex-direction: column;justify-content: space-between;    padding: 11px 0;"><a target="_blank" href="' +
                      "/DetailsListing/?id=" +
                      pendingshowfilterhomes[i].ListingKeyNumeric +
                      '"className="unitNumber button-text link" style="font-size: 1rem;font-weight: 500;text-align: left;display: inline-block;fill: #1080a2;">' +
                      "#" +
                      pendingshowfilterhomes[i].ListingKeyNumeric +
                      '</a><div className="price" style="font-size: 1rem;font-weight: 500;">' +
                      infoprice +
                      '</div><div className="amenity" style="font-size: 0.75rem;">' +
                      bedtotal +
                      " beds · " +
                      bathtotal +
                      "  baths · " +
                      pendingshowfilterhomes[i].LivingArea +
                      " sq. ft.</div></div></div></div>";
                  }
                }

                if (categoryhomes.Sold && categoryhomes.Sold.length > 0) {
                  let soldfilterhomes = categoryhomes.Sold;
                  for (let i = 0, num = soldfilterhomes.length; i < num; i++) {
                    let bathtotal;
                    let bedtotal;
                    let infoprice;
                    if (soldfilterhomes[i].BathroomsHalf) {
                      bathtotal =
                        soldfilterhomes[i].BathroomsFull +
                        soldfilterhomes[i].BathroomsHalf * 0.5;
                    } else {
                      if (soldfilterhomes[i].BathroomsFull != null) {
                        bathtotal = soldfilterhomes[i].BathroomsFull;
                      } else {
                        bathtotal = "0";
                      }
                    }
                    if (soldfilterhomes[i].BedroomsTotal != null) {
                      bedtotal = soldfilterhomes[i].BedroomsTotal;
                    } else {
                      bedtotal = "0";
                    }
                    if (soldfilterhomes[i].mlsstatus === "Sold") {
                      infoprice =
                        "$" + humanFormat(soldfilterhomes[i].ClosePrice);
                    } else if (Number.isInteger(soldfilterhomes[i].ListPrice)) {
                      infoprice =
                        "$" + humanFormat(soldfilterhomes[i].ListPrice);
                    } else {
                      infoprice = soldfilterhomes[i].ListPrice;
                    }
                    let media;

                    if (soldfilterhomes[i].SourceId) {
                      if (soldfilterhomes[i].ThumbnailUrl) {
                        media = soldfilterhomes[i].ThumbnailUrl;
                      } else {
                        media =
                          process.env.NEXT_PUBLIC_CDN_ID +
                          "static/images/homedefault.jpg";
                      }
                    } else {
                      if (
                        soldfilterhomes[i].Media &&
                        soldfilterhomes[i].Media.length > 0
                      ) {
                        media = soldfilterhomes[i].Media[0].MediaURL;
                      } else {
                        media =
                          process.env.NEXT_PUBLIC_CDN_ID +
                          "static/images/homedefault.jpg";
                      }
                    }
                    if (i === 0) {
                      datainfo +=
                        "<div className='infotitle' style='padding: 5px 10px;'>Sold</div>";
                    }
                    datainfo +=
                      '<div className="buildingRow" style="display: flex;flex-wrap: nowrap;justify-content: space-between;padding: 4px 10px;"><div className="left" style="width: 37%;height: 82px;"><img src="' +
                      media +
                      '" style="width: 100%;height: auto;"></div><div className="right" style=" width: 58%;display: flex;flex-direction: column;justify-content: space-between;    padding: 11px 0;"><a target="_blank" href="' +
                      "/DetailsListing/?id=" +
                      soldfilterhomes[i].ListingKeyNumeric +
                      '"className="unitNumber button-text link" style="font-size: 1rem;font-weight: 500;text-align: left;display: inline-block;fill: #1080a2;">' +
                      "#" +
                      soldfilterhomes[i].ListingKeyNumeric +
                      '</a><div className="price" style="font-size: 1rem;font-weight: 500;">' +
                      infoprice +
                      '</div><div className="amenity" style="font-size: 0.75rem;">' +
                      bedtotal +
                      " beds · " +
                      bathtotal +
                      "  baths · " +
                      soldfilterhomes[i].LivingArea +
                      " sq. ft.</div></div></div></div>";
                  }
                }
                iwindow.setContent(datainfo);
                iwindow.open(this.map, marker);
                this.infwindows.push(iwindow);

                // infowindow.setContent("test");
                // infowindow.open(this.map, marker);
              } else if (markercount === 1) {
                this.setState({ selected_listingkey: listingkey });
                let icons_all = {
                  scaledSize: new google.maps.Size(35, 25),
                  strokeColor: "#c02e26",
                  origin: new google.maps.Point(0, 0),
                  anchor: new google.maps.Point(35, 25),
                  labelOrigin: new google.maps.Point(18, 8),
                };
                let homemarkers = this.homegmarkers;
                homemarkers.filter(function (markersdata) {
                  if (markersdata.properttype === "ResidentialLease") {
                    icons_all.url =
                      process.env.NEXT_PUBLIC_CDN_ID +
                      "static/images/Price2-purple.png";
                  } else if (markersdata.status === "Sold") {
                    icons_all.url =
                      process.env.NEXT_PUBLIC_CDN_ID +
                      "static/images/Price2-blue.png";
                  } else if (
                    markersdata.StandardStatus === "Pending" ||
                    markersdata.status === "Contingent"
                  ) {
                    icons_all.url =
                      process.env.NEXT_PUBLIC_CDN_ID +
                      "static/images/Price2-green.png";
                  } else {
                    icons_all.url =
                      process.env.NEXT_PUBLIC_CDN_ID +
                      "static/images/Price2.png";
                  }
                  // if (clickid !== person.id) {
                  markersdata.setIcon(icons_all);
                  //}
                });

                let icons = {
                  url:
                    process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/Price2-red.png",
                  scaledSize: new google.maps.Size(35, 25),
                  strokeColor: "#c02e26",
                  origin: new google.maps.Point(0, 0),
                  anchor: new google.maps.Point(35, 25),
                  labelOrigin: new google.maps.Point(18, 8),
                  //fontSize: "8px"
                };
                for (var i = 0; i < this.homegmarkers.length; i++) {
                  if (listingkey === this.homegmarkers[i].id) {
                    this.homegmarkers[i].setIcon(icons);
                    //break;
                  } else {
                  }
                }
                let selecteddata = this.state.fetchhome.filter(
                  (x) => x.ListingKeyNumeric === listingkey,
                );
                this.setState(
                  {
                    singlehome: selecteddata,
                    popupdisplay: "none",
                  },
                  function () {
                    this.props.singleHome(selecteddata);
                    google.maps.event.clearListeners(marker, "mouseout");
                    clickid = marker.id;
                  },
                );

                // if (marker.SourceId !== "") {
                //   const getdatanew = {
                //     start: 0,
                //     limit: 1,
                //     orderBy: "id",
                //     order: "ASC",
                //     fields: [
                //       {
                //         name: "id",
                //         value: this.state.selected_listingkey,
                //         operator: "=",
                //       },
                //     ],
                //   };

                //   getNHmaphomelist(getdatanew)
                //     .then((result) => {
                //       if (result.data.getnhmaphome.length > 0) {
                //         let icondefault = {
                //           url:
                //             process.env.NEXT_PUBLIC_CDN_ID +
                //             "static/images/Price2.png",
                //           scaledSize: new google.maps.Size(35, 25),
                //           strokeColor: "#c02e26",
                //           origin: new google.maps.Point(0, 0),
                //           anchor: new google.maps.Point(35, 25),
                //           labelOrigin: new google.maps.Point(18, 8),
                //           //fontSize: "8px"
                //         };
                //         let icons = {
                //           url:
                //             process.env.NEXT_PUBLIC_CDN_ID +
                //             "static/images/Price2-red.png",
                //           scaledSize: new google.maps.Size(35, 25),
                //           strokeColor: "#c02e26",
                //           origin: new google.maps.Point(0, 0),
                //           anchor: new google.maps.Point(35, 25),
                //           labelOrigin: new google.maps.Point(18, 8),
                //           //fontSize: "8px"
                //         };
                //         for (var i = 0; i < this.homegmarkers.length; i++) {
                //           if (
                //             this.state.selected_listingkey ===
                //             this.homegmarkers[i].id
                //           ) {
                //             this.homegmarkers[i].setIcon(icons);
                //             //break;
                //           } else {
                //           }
                //         }
                //         this.setState(
                //           {
                //             singlehome: result.data.getnhmaphome,
                //           },
                //           function () {
                //             this.props.singleHome(result.data.getnhmaphome);
                //           }
                //         );
                //       }
                //     })
                //     .catch((error) => {
                //       console.error(error);
                //     });
                // } else {
                //   const getdatanew = {
                //     ListingKeyNumerics: listingkey,
                //   };

                //   getListingsByIds(getdatanew)
                //     .then((result) => {
                //       if (result.data.getListingsByIds.length > 0) {
                //         let icondefault = {
                //           url:
                //             process.env.NEXT_PUBLIC_CDN_ID +
                //             "static/images/Price2.png",
                //           scaledSize: new google.maps.Size(35, 25),
                //           strokeColor: "#c02e26",
                //           origin: new google.maps.Point(0, 0),
                //           anchor: new google.maps.Point(35, 25),
                //           labelOrigin: new google.maps.Point(18, 8),
                //           //fontSize: "8px"
                //         };
                //         let icons = {
                //           url:
                //             process.env.NEXT_PUBLIC_CDN_ID +
                //             "static/images/Price2-red.png",
                //           scaledSize: new google.maps.Size(35, 25),
                //           strokeColor: "#c02e26",
                //           origin: new google.maps.Point(0, 0),
                //           anchor: new google.maps.Point(35, 25),
                //           labelOrigin: new google.maps.Point(18, 8),
                //           //fontSize: "8px"
                //         };
                //         for (var i = 0; i < this.homegmarkers.length; i++) {
                //           if (listingkey === this.homegmarkers[i].id) {
                //             this.homegmarkers[i].setIcon(icons);
                //             //break;
                //           } else {
                //           }
                //         }
                //         this.setState(
                //           {
                //             singlehome: result.data.getListingsByIds,
                //           },
                //           function () {
                //             this.props.singleHome(result.data.getListingsByIds);
                //           }
                //         );
                //       }
                //     })
                //     .catch((error) => {
                //       console.error(error);
                //     });
                // }
              }

              setTimeout(function () {
                var element = document.getElementById("selectedhometop");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }, 1500);
            };
          })(marker, i).bind(this),
        );

        this.homegmarkers.push(marker);
        // this.setState({ loaderdispaly: "none" });
      });

      //var markerCluster = new MarkerClusterer(this.map, gmarkers);

      var clusterStyles = [
        {
          textColor: "white",
          url:
            selectedarea === "active"
              ? "/static/images/E1.png"
              : "/static/images/E1.png",
          height: 20,
          width: 20,
          textSize: 0.001,
        },
        {
          textColor: "white",
          url:
            selectedarea === "active"
              ? "/static/images/E2.png"
              : "/static/images/E2.png",
          height: 25,
          width: 25,
          textSize: 0.001,
        },
        {
          textColor: "white",
          url:
            selectedarea === "active"
              ? "/static/images/E3.png"
              : "/static/images/E3.png",
          height: 30,
          width: 30,
          textSize: 0.001,
        },
      ];
      var mcOptions = {
        gridSize: 150,
        //minimumClusterSize: 10,
        // styles: clusterStyles,
        maxZoom: 14,
        // minimumClusterSize: 10
        textSize: 0.001,
      };
      function getClusterStyle(markersCount) {
        if (markersCount < 10) {
          return clusterStyles[0];
        } else if (markersCount < 20) {
          return clusterStyles[1];
        } else {
          return clusterStyles[2];
        }
      }

      // let zoom_level = this.map.state.map.getZoom();
      this.homemarkerCluster = new MarkerClusterer({
        map: this.map.state.map,
        markers: this.homegmarkers,
        algorithm: new SuperClusterAlgorithm({
          radius: 270, // Equivalent to grid size
          maxZoom: 14,

          // minPoints: 0,
        }),
        renderer: {
          render: ({ markers, _position: position }) => {
            const clusterStyle = getClusterStyle(markers.length);
            return new google.maps.Marker({
              position: {
                lat: position.lat(),
                lng: position.lng(),
              },
              icon: {
                url: clusterStyle.url,
                scaledSize: new google.maps.Size(
                  clusterStyle.width,
                  clusterStyle.height,
                ),
              },
            });
          },
        },

        // algorithmOptions: mcOptions,
      });

      // Add a marker clusterer to manage the markers.*/
      /* this.homemarkerCluster = new MarkerClusterer(this.map.state.map, this.homegmarkers,
     {
         imagePath: './static/images/m',
         maxZoom: 14,
         gridSize: 200
     }); */
      this.arr.push(this.homemarkerCluster);
    } else {
      if (this.arr.length > 0) {
        for (var i = 0; i < this.arr.length; i++) {
          this.arr[i].clearMarkers();
        }
      }
      this.homegmarkers = [];
      this.home_points = [];
      this.arr = [];
    }

    let selectedicons = {
      url: process.env.NEXT_PUBLIC_CDN_ID + "static/images/Price2-red.png",
      scaledSize: new google.maps.Size(35, 25),
      strokeColor: "#c02e26",
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(35, 25),
      labelOrigin: new google.maps.Point(18, 8),
      //fontSize: "8px"
    };
    if (this.state.selected_id_single !== "") {
      let filteredaddress = this.state.fetchhome.filter(
        (x) => x.UnparsedAddress === this.state.selected_id_single[0],
      );
      if (filteredaddress && filteredaddress.length > 0) {
        for (var i = 0; i < this.homegmarkers.length; i++) {
          if (
            filteredaddress[0].ListingKeyNumeric === this.homegmarkers[i].id
          ) {
            this.homegmarkers[i].setIcon(selectedicons);

            //break;

            this.setState(
              {
                singlehome: filteredaddress,
              },
              function () {
                this.props.singleHome(filteredaddress, "");
              },
            );
          } else {
          }
        }
      } else {
        this.addSelectedmarker();
      }
    }
  };

  addSelectedmarker = () => {
    let selectedicons = {
      url: process.env.NEXT_PUBLIC_CDN_ID + "static/images/Price2-red.png",
      scaledSize: new google.maps.Size(35, 25),
      strokeColor: "#c02e26",
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(35, 25),
      labelOrigin: new google.maps.Point(18, 8),
      //fontSize: "8px"
    };
    const getdataMLS = {
      address: this.state.selected_id_single[0],
    };

    const getdataSFAR = {
      start: 0,
      limit: 1,
      orderBy: "address",
      order: "ASC",
      fields: [
        {
          name: "UnparsedAddress",
          value: this.state.selected_id_single[0],
          operator: "=",
        },
      ],
    };
    Promise.all([
      getMLSListingByAddress(getdataMLS),
      getNHmaphomelist(getdataSFAR),
    ])
      .then((result) => {
        // that.map.state.map.setZoom(15);
        if (
          result &&
          result[0].data.getMLSListingByAddress !== null &&
          result[0].data.getMLSListingByAddress.length > 0
        ) {
          let price;
          let mlsresult = result[0].data.getMLSListingByAddress[0];
          if (mlsresult.MlsStatus === "Sold") {
            if (mlsresult.ClosePrice && mlsresult.ClosePrice !== undefined) {
              price = mlsresult.ClosePrice;
            } else {
              price = mlsresult.ListPrice;
            }
          } else {
            price = mlsresult.ListPrice;
          }
          let markertext = `${humanFormat(price, {
            decimals: price.toString().length < 7 ? 0 : 2,
          })}`;
          let singlemarker = new google.maps.Marker({
            position: {
              lat: parseFloat(mlsresult.Latitude),
              lng: parseFloat(mlsresult.Longitude),
            },
            label: {
              text: markertext,
              color: "#fff",
              fontSize: "12px",
            },
            icon: selectedicons,
          });
          this.externalmarkers.push(singlemarker);
          singlemarker.setMap(this.map.state.map);

          this.setState(
            {
              singlehome: mlsresult,
            },
            function () {
              this.props.singleHome(result[0].data.getMLSListingByAddress, "");
            },
          );
          singlemarker.addListener("click", () => {
            window.open(
              `/DetailsListing/?id=${mlsresult.ListingKeyNumeric}`,
              "_blank",
            );
          });
        } else if (
          result &&
          result[1].data.getnhmaphome.length > 0 &&
          result[1].data.getnhmaphome[0].MlsStatus
        ) {
          let price;
          let sfarresult = result[1].data.getnhmaphome[0];
          if (sfarresult.MlsStatus === "Sold") {
            if (sfarresult.ClosePrice) {
              price = sfarresult.ClosePrice;
            } else {
              price = sfarresult.ListPrice;
            }
          } else {
            price = sfarresult.ListPrice;
          }
          let markertext = `${humanFormat(price, {
            decimals: price.toString().length < 7 ? 0 : 2,
          })}`;
          let singlemarker = new google.maps.Marker({
            position: {
              lat: parseFloat(sfarresult.Latitude),
              lng: parseFloat(sfarresult.Longitude),
            },
            label: {
              text: markertext,
              color: "#fff",
              fontSize: "12px",
            },
            icon: selectedicons,
          });
          this.externalmarkers.push(singlemarker);
          singlemarker.setMap(this.map.state.map);

          this.setState(
            {
              singlehome: result[1].data.getnhmaphome,
            },
            function () {
              this.props.singleHome(result[1].data.getnhmaphome, "");
            },
          );
          singlemarker.addListener("click", () => {
            window.open(
              `/DetailsListing/?id=${sfarresult.ListingKeyNumeric}`,
              "_blank",
            );
          });
        } else {
          let singlemarker = new google.maps.Marker({
            position: {
              lat: this.state.selected_lat,
              lng: this.state.selected_lng,
            },
            // title: this.state.selected_id_single,
          });
          this.gmarkers.push(singlemarker);
          singlemarker.setMap(this.map.state.map);
        }
      })
      .catch((error) => {
        let singlemarker = new google.maps.Marker({
          position: {
            lat: this.state.selected_lat,
            lng: this.state.selected_lng,
          },
          //title: this.state.selected_id_single,
        });
        this.gmarkers.push(singlemarker);
        singlemarker.setMap(this.map.state.map);
      });
  };

  get_homes = async (lhpStr) => {
    let zoom_level = this.map?.state?.map?.getZoom();
    let bounds = this.map?.state?.map?.getBounds();
    if (
      zoom_level <= 11 &&
      (lhpStr === "Primary" || lhpStr === "Middle" || lhpStr === "High")
    ) {
    } else {
      if (bounds && bounds !== undefined) {
        let north = bounds.getNorthEast().lat();
        let east = bounds.getNorthEast().lng();
        let south = bounds.getSouthWest().lat();
        let west = bounds.getSouthWest().lng();
        let northEast = new google.maps.LatLng(north, east);
        let northWest = new google.maps.LatLng(north, west);
        let southEast = new google.maps.LatLng(south, east);
        let southWest = new google.maps.LatLng(south, west);
        let finallatlng =
          "(" +
          northWest.lat().toFixed(6) +
          " " +
          northWest.lng().toFixed(6) +
          "," +
          southEast.lat().toFixed(6) +
          " " +
          southEast.lng().toFixed(6) +
          "," +
          southWest.lat().toFixed(6) +
          " " +
          southWest.lng().toFixed(6) +
          "," +
          northEast.lat().toFixed(6) +
          " " +
          northEast.lng().toFixed(6) +
          "," +
          northWest.lat().toFixed(6) +
          " " +
          northWest.lng().toFixed(6) +
          ")";

        let appdata2 = {};
        if (this.getfilterdata && Object.keys(this.getfilterdata).length > 0) {
          let filters = Object.assign(this.getfilterdata);
          appdata2 = filters;
        }
        const getdatanew2 = {
          start: 0,
          limit: 100,
          orderBy: "id",
          order: finallatlng,
          fields: appdata2,
        };

        let apilatlang =
          northWest.lng().toFixed(6) +
          " " +
          northWest.lat().toFixed(6) +
          "," +
          southWest.lng().toFixed(6) +
          " " +
          southWest.lat().toFixed(6) +
          "," +
          southEast.lng().toFixed(6) +
          " " +
          southEast.lat().toFixed(6) +
          "," +
          northEast.lng().toFixed(6) +
          " " +
          northEast.lat().toFixed(6) +
          "," +
          northWest.lng().toFixed(6) +
          " " +
          northWest.lat().toFixed(6);

        if (zoom_level > 0) {
          this.setState({ loaderdispaly: "block" });
          let appdata = "";

          if (
            this.getfilterdata &&
            Object.keys(this.getfilterdata).length > 0
          ) {
            let filters = Object.assign(this.getfilterdata, {
              coordinate: apilatlang,
            });
            appdata = filters;
          } else {
            appdata = { coordinate: apilatlang, page: "nhmap" };
          }
          const getdatanew = {
            appdata,
          };
          let finallisitng = [];
          let that = this;
          // var startTime = performance.now();
          let data = [];
          if (zoom_level >= 13)
            data = [
              getNHmaphomelist(getdatanew2),
              getMlslistings(getdatanew),
              getSlipstreamListings(getdatanew),
            ];
          Promise.allSettled(data)
            .then((results) => {
              that.setState({ loaderdispaly: "none" });
              let mlsdata = [];
              let dbdata = [];

              // If MLS listings exist, assign them
              if (
                results[1].status === "fulfilled" &&
                Array.isArray(results[1].value.data.getMlslistings)
              ) {
                mlsdata = results[1].value.data.getMlslistings;
              }

              // If Slipstream listings exist, merge them (even if mlsdata is empty)
              if (
                results[2].status === "fulfilled" &&
                Array.isArray(results[2].value.data.getSlipstreamListings)
              ) {
                mlsdata = [
                  ...mlsdata,
                  ...results[2].value.data.getSlipstreamListings,
                ];
              }

              // If NH map home listings exist, assign them
              if (
                results[0].status === "fulfilled" &&
                Array.isArray(results[0].value.data.getnhmaphome)
              ) {
                dbdata = results[0].value.data.getnhmaphome;
              }

              const finallisitng = [...mlsdata, ...dbdata];
              that.initialize_home(finallisitng, lhpStr);
            })
            .catch(function (error) {
              // if there's an error, log it

              // var startTime1 = performance.now();
              that.initialize_home(finallisitng, lhpStr);
              //  var endTime2 = performance.now();

              //return finallisitng;
            });
        }
      }
    }
  };

  get_school = (lhpStr) => {
    let zoom_level = this.map?.state?.map?.getZoom();
    let bounds = this.map.state.map.getBounds();
    let north = bounds.getNorthEast().lat();
    let east = bounds.getNorthEast().lng();
    let south = bounds.getSouthWest().lat();
    let west = bounds.getSouthWest().lng();
    let northEast = new google.maps.LatLng(north, east);
    let northWest = new google.maps.LatLng(north, west);
    let southEast = new google.maps.LatLng(south, east);
    let southWest = new google.maps.LatLng(south, west);

    let finallatlng =
      "(" +
      northWest.lat().toFixed(6) +
      " " +
      northWest.lng().toFixed(6) +
      "," +
      southEast.lat().toFixed(6) +
      " " +
      southEast.lng().toFixed(6) +
      "," +
      southWest.lat().toFixed(6) +
      " " +
      southWest.lng().toFixed(6) +
      "," +
      northWest.lat().toFixed(6) +
      " " +
      northWest.lng().toFixed(6) +
      "," +
      northWest.lat().toFixed(6) +
      " " +
      northWest.lng().toFixed(6) +
      ")";
    let sdata = [];

    if (zoom_level > 0) {
      this.setState({ loaderdispaly: "block" });
      const getdatanew = {
        start: 0,
        limit: 100,
        orderBy: "id",
        order: finallatlng,
        fields: [
          {
            name: "lat",
            value: south,
            operator: ">",
          },
          {
            name: "lat",
            value: north,
            operator: "<",
          },
          {
            name: "lang",
            value: west,
            operator: ">",
          },
          {
            name: "lang",
            value: east,
            operator: "<",
          },
        ],
      };

      getAllSchoolList(getdatanew)
        .then((result) => {
          if (result.data.getSchool.length === 0) {
            this.setState({ loaderdispaly: "none" });
          }
          if (result.data.getSchool.length > 0) {
            this.setState({ loaderdispaly: "none" });

            let locations = [];

            locations = result.data.getSchool.map((item, index) => {
              if (!this.schoolpoints.includes(item.lat + item.lang)) {
                this.schoolpoints.push(item.lat + item.lang);
                return {
                  id: item.id,
                  lat: parseFloat(item.lat),
                  lng: parseFloat(item.lang),
                  schoolname: item.schoolname,
                  county: item.county,
                  schooltype: item.schooltype,
                  instructionlevel: item.instructionlevel,
                  website: item.schoolurl,
                  noofstudent: item.noofstudent,
                  //homejunctionschoolid : item.homejunctionschoolid,
                  //grade : item.gradelow,
                  exists: false,
                };
              } else {
                return { exists: true };
              }
            });

            let icons = {
              url:
                process.env.NEXT_PUBLIC_CDN_ID + "static/images/schoolicon.png",
            };

            locations.map((location, i) => {
              if (location.exists) {
                return;
              }

              let schoolname = location.schoolname;
              let id = location.id;
              let newloc = {
                lat: location.lat,
                lng: location.lng,
              };
              let county = location.county;
              let schooltype = location.schooltype;
              let instructionlevel = location.instructionlevel;

              var marker = new google.maps.Marker({
                position: newloc,
                //label: {text:`${schoolname}`, color: '#000'},
                icon: icons,
                //animation: google.maps.Animation.DROP,
              });
              var infowindow = new google.maps.InfoWindow({
                disableAutoPan: true,
              });

              var infowaycontent =
                "<div className='school_popuop'><div style={{display: 'flex', flexDirection: 'column'}}> <div> Schoolname:" +
                `${schoolname}` +
                "</div> </div> <div> schooltype:" +
                `${schooltype || "not available"}` +
                "</div> </div> <div> instructionlevel:" +
                `${instructionlevel || "not available"}` +
                "</div> </div></div>";
              google.maps.event.addListener(
                marker,
                "mouseover",
                (function (marker, i) {
                  return function () {
                    infowindow.setContent(infowaycontent);
                    infowindow.open(this.map, marker);
                  };
                })(marker, i),
              );

              google.maps.event.addListener(
                marker,
                "mouseout",
                (function (marker, i) {
                  return function () {
                    infowindow.close(this.map, marker);
                  };
                })(marker, i),
              );

              this.schoolmarkers.push(marker);

              google.maps.event.addListener(
                marker,
                "mouseover",
                function (marker, i) {
                  if (this.sbermudaTriangle.length > 0) {
                    for (var i = 0; i < this.sbermudaTriangle.length; i++) {
                      this.sbermudaTriangle[i].setMap(null);
                    }
                  }

                  const getdatanew = {
                    start: 0,
                    limit: 1,
                    orderBy: "schoolname",
                    order: "ASC",
                    fields: [
                      {
                        name: "id",
                        value: id,
                        operator: "=",
                      },
                    ],
                  };
                  let school_points = [];
                  //let new_mapthis.map.state.map
                  getAllSchoolList(getdatanew)
                    .then((result) => {
                      if (result.data.getSchool.length === 0) {
                      }
                      if (result.data.getSchool.length > 0) {
                        let i;
                        let reversedCoordsnew;

                        function getschoolcolor(value) {
                          let color = "";
                          if (value === "High") {
                            color = "#006600";
                          } else if (value === "Primary") {
                            color = "#ffa64d";
                          } else if (value === "Middle") {
                            color = "#00b300";
                          } else {
                            color = "#000";
                          }
                          return color;
                        }

                        result.data.getSchool.map((item, index) => {
                          if (item.school_cords) {
                            sdata = [];
                            sdata.push(item.school_cords);
                          }

                          sdata.map((item3, index3) => {
                            item3.map((item4, index4) => {
                              this.school_points = [];
                              if (!this.school_points.includes(item4)) {
                                this.school_points.push(item4);

                                let newdata = JSON.parse(item4);

                                reversedCoordsnew = newdata.map(
                                  (item5, index5) => {
                                    return {
                                      lat: parseFloat(item5.x),
                                      lng: parseFloat(item5.y),
                                    };
                                  },
                                );
                                this.schoolTriangle = new google.maps.Polygon({
                                  paths: [reversedCoordsnew],
                                  strokeColor: "#c02e26",
                                  strokeWeight: 2,
                                  fillColor: getschoolcolor(
                                    item.instructionlevel,
                                  ),
                                  fillOpacity: 0.5,
                                  zIndex: 1,
                                });

                                this.schoolTriangle.setMap(this.map.state.map);
                                this.sbermudaTriangle.push(this.schoolTriangle);
                              }
                            });
                          });
                        });
                      }
                    })
                    .catch((error) => {
                      console.error(error);
                    });
                }.bind(this),
              );
              google.maps.event.addListener(
                marker,
                "mouseout",
                function (marker, i) {
                  for (var i = 0; i < this.sbermudaTriangle.length; i++) {
                    this.sbermudaTriangle[i].setMap(null);
                  }
                }.bind(this),
              );

              google.maps.event.addListener(
                this.map.state.map,
                "mousemove",
                function (marker, i) {
                  if (this.sbermudaTriangle.length > 0) {
                    for (var i = 0; i < this.sbermudaTriangle.length; i++) {
                      this.sbermudaTriangle[i].setMap(null);
                    }
                  }
                }.bind(this),
              );
            });
            //var markerCluster = new MarkerClusterer(this.map, gmarkers);
            //   // Add a marker clusterer to manage the markers.*/
            //   this.schoolmarkerCluster = new MarkerClusterer(
            //     this.map.state.map,
            //     this.schoolmarkers,
            //     {
            //       imagePath:
            //         "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
            //     }
            //   );
            // }
            this.schoolmarkerCluster = new MarkerClusterer({
              map: this.map.state.map,
              markers: this.schoolmarkers,
              renderer: {
                render: ({ markers, _position: position }) => {
                  return new google.maps.Marker({
                    position: {
                      lat: position.lat(),
                      lng: position.lng(),
                    },
                    icon: {
                      url: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
                    },
                  });
                },
              },
            });
          }
          this.schoolarr.push(this.schoolmarkerCluster);
        })

        .catch((error) => {
          console.error(error);
        });
    }
  };

  // get_school2 = (lhpStr) => {
  //   let zoom_level = this.map.state.map.getZoom();
  //   if (zoom_level > 0) {
  //     this.setState({ is_display_zoom_msg: false });
  //     let bounds = this.map.state.map.getBounds();
  //     let north = bounds.getNorthEast().lat();
  //     let east = bounds.getNorthEast().lng();
  //     let south = bounds.getSouthWest().lat();
  //     let west = bounds.getSouthWest().lng();

  //     let northEast;
  //     let northWest;
  //     let southEast;
  //     let southWest;
  //     if (zoom_level > 12) {
  //       let scaleFactor = 0.35;
  //       let deltaWidth = scaleFactor * Math.abs(east - west);
  //       let deltaHeight = scaleFactor * Math.abs(south - north);

  //       let newBoundNorth = north + deltaHeight;
  //       let newBoundSouth = south - deltaHeight;
  //       let newBoundEast = east + deltaWidth;
  //       let newBoundWest = west - deltaWidth;
  //       northEast = new google.maps.LatLng(newBoundNorth, newBoundEast);
  //       northWest = new google.maps.LatLng(newBoundNorth, newBoundWest);
  //       southEast = new google.maps.LatLng(newBoundSouth, newBoundEast);
  //       southWest = new google.maps.LatLng(newBoundSouth, newBoundWest);
  //     } else {
  //       northEast = new google.maps.LatLng(north, east);
  //       northWest = new google.maps.LatLng(north, west);
  //       southEast = new google.maps.LatLng(south, east);
  //       southWest = new google.maps.LatLng(south, west);
  //     }
  //     // let northEast = new google.maps.LatLng(north, east);
  //     // let northWest = new google.maps.LatLng(north, west);
  //     // let southEast = new google.maps.LatLng(south, east);
  //     // let southWest = new google.maps.LatLng(south, west);

  //     let finallatlng =
  //       "(" +
  //       northWest.lat().toFixed(6) +
  //       " " +
  //       northWest.lng().toFixed(6) +
  //       "," +
  //       southWest.lat().toFixed(6) +
  //       " " +
  //       southWest.lng().toFixed(6) +
  //       "," +
  //       southEast.lat().toFixed(6) +
  //       " " +
  //       southEast.lng().toFixed(6) +
  //       "," +
  //       northEast.lat().toFixed(6) +
  //       " " +
  //       northEast.lng().toFixed(6) +
  //       "," +
  //       northWest.lat().toFixed(6) +
  //       " " +
  //       northWest.lng().toFixed(6) +
  //       ")";
  //     let sdata = [];

  //     let primaryscore = [];
  //     let middlescore = [];
  //     let highscore = [];
  //     let allscore = [];
  //     let schoolresults = [];

  //     if (zoom_level > 0) {
  //       this.setState({ loaderdispaly: "block" });
  //       const getdatanew = {
  //         start: 0,
  //         limit: 100,
  //         orderBy: "id",
  //         order: finallatlng,
  //         fields: [
  //           {
  //             name: "lat",
  //             value: south,
  //             operator: ">",
  //           },
  //           {
  //             name: "lat",
  //             value: north,
  //             operator: "<",
  //           },
  //           {
  //             name: "lang",
  //             value: west,
  //             operator: ">",
  //           },
  //           {
  //             name: "lang",
  //             value: east,
  //             operator: "<",
  //           },
  //         ],
  //         zoomLevel: zoom_level,
  //         device: this.state.isMobile ? "mobile" : "desktop",
  //       };

  //       getAllSchoolList(getdatanew)
  //         .then((result) => {
  //           this.clearschoolpoly();
  //           this.clearschoolMarkers();

  //           let schooltypes = "";
  //           schoolresults = result.data.getSchool;

  //           if (result.data.getSchool && result.data.getSchool.length === 0) {
  //             this.setState({ loaderdispaly: "none" });
  //           }
  //           if (result.data.getSchool && result.data.getSchool.length > 0) {
  //             this.setState({ loaderdispaly: "none" });

  //             let locations = [];
  //             let filteredSchools = [];
  //             if (lhpStr === "Primary") {
  //               filteredSchools = result.data.getSchool.filter((school) =>
  //                 this.schoolgrades.primaryarr.includes(school.instructionlevel)
  //               );
  //               schooltypes = "Primary";
  //             } else if (lhpStr === "Middle") {
  //               filteredSchools = result.data.getSchool.filter((school) =>
  //                 this.schoolgrades.middlearr.includes(school.instructionlevel)
  //               );
  //               schooltypes = "Middle";
  //             } else if (lhpStr === "High") {
  //               filteredSchools = result.data.getSchool.filter((school) =>
  //                 this.schoolgrades.higharr.includes(school.instructionlevel)
  //               );
  //               schooltypes = "High";
  //             } else {
  //               filteredSchools = result.data.getSchool;
  //             }
  //             locations = filteredSchools.map((item, index) => {
  //               if (item.school_cords !== "" && item.school_cords !== null) {
  //                 //let polygoncordinates = item.school_cords[0].split(",");
  //                 //let polygoncords_length = polygoncordinates.length;
  //                 // if (
  //                 //   polygoncords_length > 0 &&
  //                 //   item.schoolname === "Palo Alto High"
  //                 // ) {
  //                 if (lhpStr === "all") {
  //                   if (
  //                     this.schoolgrades.primaryarr.includes(
  //                       item.instructionlevel
  //                     )
  //                   ) {
  //                     schooltypes = "Primary";
  //                   } else if (
  //                     this.schoolgrades.middlearr.includes(
  //                       item.instructionlevel
  //                     )
  //                   ) {
  //                     schooltypes = "Middle";
  //                   } else if (
  //                     this.schoolgrades.higharr.includes(item.instructionlevel)
  //                   ) {
  //                     schooltypes = "High";
  //                   }
  //                 }

  //                 if (
  //                   item.school_cords &&
  //                   schooltypes === lhpStr
  //                   //polygoncords_length > 10
  //                 ) {
  //                   let schoolcordinate = [];
  //                   if (item.school_cords && item.school_cords != "") {
  //                     // schoolcordinate = item.school_cords[0];
  //                     for (var i = 0; i < item.school_cords.length; i++) {
  //                       sdata.push({
  //                         cords: item.school_cords[i],
  //                         rating: item.rating,
  //                       });
  //                     }
  //                   }

  //                   // if (lhpStr === "Primary" && schooltypes === lhpStr) {
  //                   //   primaryscore.push(item.rating);
  //                   // }

  //                   // if (lhpStr === "Middle" && schooltypes === lhpStr) {
  //                   //   middlescore.push(item.rating);
  //                   // }

  //                   // if (lhpStr === "High" && schooltypes === lhpStr) {
  //                   //   highscore.push(item.rating);
  //                   // }
  //                 }
  //                 // }else if(lhpStr === "all"){

  //                 //   sdata.push(item.school_cords);
  //                 //   allscore.push(item.rating);
  //                 // }

  //                 this.s_id = item.id;

  //                 /* if(lhpStr === "Primary"){    */
  //                 //this.primaryschool.push(item.school);
  //                 /*}*/
  //                 this.sfetchid.push(item.id);
  //                 //if (polygoncords_length > 10) {
  //                 sdata &&
  //                   sdata.length > 0 &&
  //                   sdata.map((item3, index3) => {
  //                     //this.primary_polygon_points = [];
  //                     if (item3.cords && item3.cords != undefined) {
  //                       if (
  //                         !this.primary_polygon_points.includes(item3.cords)
  //                       ) {
  //                         this.primary_polygon_points.push(item3.cords);
  //                         let newdata = JSON.parse(item3.cords);
  //                         let reversedCoordsnew =
  //                           newdata[0].length > 5 &&
  //                           newdata[0].map((item5, index5) => {
  //                             return {
  //                               lat: parseFloat(item5.x),
  //                               lng: parseFloat(item5.y),
  //                             };
  //                           });

  //                         this.pbermudaTriangle = new google.maps.Polygon({
  //                           paths: [reversedCoordsnew],
  //                           strokeColor: "#FF0000",
  //                           strokeOpacity: 0.00001,
  //                           strokeWeight: 0,
  //                           //fillColor: "#ffa64d",
  //                           fillOpacity: zoom_level > 14 ? 0.25 : 0.75,
  //                           zIndex: 1,
  //                           fillColor: get_school_color(item3.rating),
  //                         });
  //                         // if (lhpStr === "Primary") {
  //                         //   if (primaryscore && primaryscore.length > 0) {
  //                         //     this.pbermudaTriangle.setOptions({
  //                         //       fillColor: this.get_school_color(
  //                         //         primaryscore[index3]
  //                         //       ),
  //                         //     });
  //                         //   }
  //                         // }

  //                         // if (lhpStr === "Middle") {
  //                         //   if (middlescore && middlescore.length > 0) {
  //                         //     this.pbermudaTriangle.setOptions({
  //                         //       fillColor: this.get_school_color(
  //                         //         middlescore[index3]
  //                         //       ),
  //                         //     });
  //                         //   }
  //                         // }

  //                         // if (lhpStr === "High") {
  //                         //   if (highscore && highscore.length > 0) {
  //                         //     this.pbermudaTriangle.setOptions({
  //                         //       fillColor: this.get_schools_color(
  //                         //         highscore[index3]
  //                         //       ),
  //                         //     });
  //                         //   }
  //                         // }
  //                         this.pbermudaTriangle.setMap(this.map.state.map);
  //                         this.ppbermudaTriangle.push(this.pbermudaTriangle);
  //                       }
  //                     }
  //                   });
  //               }
  //               // }
  //               //}
  //               if (
  //                 item.school_cords !== "" ||
  //                 item.school_cords !== null ||
  //                 item.city == "San Francisco" ||
  //                 item.city == "Belmont" ||
  //                 item.schooldistname == "Belmont-Redwood Shores Elementary"
  //               ) {
  //                 if (
  //                   !this.pschoolpoints.includes(item.lat + item.lang) &&
  //                   lhpStr === "all"
  //                 ) {
  //                   this.pschoolpoints.push(item.lat + item.lang);
  //                   return {
  //                     id: item.id,
  //                     lat: parseFloat(item.lat),
  //                     lng: parseFloat(item.lang),
  //                     schoolname: item.schoolname,
  //                     county: item.county,
  //                     schooltype: schooltypes,
  //                     instructionlevel: item.instructionlevel,
  //                     rating: item.rating,
  //                     website: item.schoolurl,
  //                     noofstudent: item.noofstudent,
  //                     studentratio: item.studentratio,
  //                     greatschoolurl: item.greatschoolurl,
  //                     //homejunctionschoolid : item.homejunctionschoolid,
  //                     // grade : item.gradelow,
  //                     exists: false,
  //                   };
  //                 } else if (
  //                   !this.pschoolpoints.includes(item.lat + item.lang) &&
  //                   schooltypes === lhpStr
  //                 ) {
  //                   this.pschoolpoints.push(item.lat + item.lang);
  //                   return {
  //                     id: item.id,
  //                     lat: parseFloat(item.lat),
  //                     lng: parseFloat(item.lang),
  //                     schoolname: item.schoolname,
  //                     county: item.county,
  //                     schooltype: schooltypes,
  //                     instructionlevel: item.instructionlevel,
  //                     rating: item.rating,
  //                     website: item.schoolurl,
  //                     noofstudent: item.noofstudent,
  //                     studentratio: item.studentratio,
  //                     greatschoolurl: item.greatschoolurl,
  //                     //homejunctionschoolid : item.homejunctionschoolid,
  //                     // grade : item.gradelow,
  //                     exists: false,
  //                   };
  //                 } else {
  //                   return { exists: true };
  //                 }
  //               }
  //             });

  //             /**HERE */
  //             let primarydata = [];

  //             let icons = {
  //               url: process.env.NEXT_PUBLIC_CDN_ID + "static/images/schoolicon.png",
  //             };
  //             let selectedicon = {
  //               url:
  //                 process.env.NEXT_PUBLIC_CDN_ID +
  //                 "static/images/schooliconlarge.png",
  //             };
  //             let markericon = "";
  //             let selectedid = this.state.selectedschoolid;
  //             let data = locations.filter(function (element) {
  //               return element !== undefined;
  //             });
  //             data.map((location, i) => {
  //               if (location.exists) {
  //                 this.pschoolmarkers.filter(function (element) {
  //                   if (element.id === selectedid) {
  //                     element.setIcon(selectedicon);
  //                   } else {
  //                     element.setIcon(icons);
  //                   }
  //                 });
  //                 return;
  //               }

  //               if (location.id === selectedid) {
  //                 markericon = {
  //                   url:
  //                     process.env.NEXT_PUBLIC_CDN_ID +
  //                     "static/images/schooliconlarge.png",
  //                 };
  //               } else {
  //                 markericon = {
  //                   url:
  //                     process.env.NEXT_PUBLIC_CDN_ID +
  //                     "static/images/schoolicon.png",
  //                 };
  //               }
  //               let schoolname = location.schoolname;
  //               let id = location.id;
  //               let newloc = {
  //                 lat: location.lat,
  //                 lng: location.lng,
  //               };
  //               // let schooltypes = "";
  //               // if (
  //               //   this.schoolgrades.primaryarr.includes(location.instructionlevel)
  //               // ) {
  //               //   schooltypes = "Primary";
  //               // } else if (
  //               //   this.schoolgrades.middlearr.includes(location.instructionlevel)
  //               // ) {
  //               //   schooltypes = "Middle";
  //               // } else if (
  //               //   this.schoolgrades.higharr.includes(location.instructionlevel)
  //               // ) {
  //               //   schooltypes = "High";
  //               // }
  //               let county = location.county;
  //               let schooltype = location.schooltype;
  //               let rating = location.rating;
  //               let instructionlevel = location.instructionlevel;
  //               let website = location.website;
  //               let noofstudent = location.noofstudent;
  //               let grades = location.schooltype;
  //               let studentratio = location.studentratio;
  //               let greatschoolurl = location.greatschoolurl;
  //               var marker = new google.maps.Marker({
  //                 id: location.id,
  //                 position: newloc,
  //                 //label: {text:`${schoolname}`, color: '#000'},
  //                 icon: markericon,
  //                 //animation: google.maps.Animation.DROP,
  //               });
  //               var infowindow = new google.maps.InfoWindow({
  //                 disableAutoPan: true,
  //               });

  //               // var infowaycontent = "<div className='school_popuop'><div style={{display: 'flex', flexDirection: 'column'}}  className='school_name'> <div> " + `${schoolname}` + "</div> <div> instructionlevel:" + `${instructionlevel || "not available"}` + "</div><div> rating:" + `${rating || "not available"}` + "</div></div><div className='school_right'><div className='school_rating_name'>Rating</div><div className='school_rating'> " + `${rating}` + "</div> </div></div>  </div>  </div>";

  //               // let info = "<div className='school_popup'> <div className='left_part'> <div className='school_name'> <strong>" + `${schoolname}` + "</strong> </div> <div className='school_data'> <div className='school_level'>" + `${instructionlevel || "-"}` + "</div> <div className='school_grade'>Grades: " + `${grades || "-"}` + "</div> </div>  </div> <div className='right_part'>     <div className='rating_txt_popup'>Rating</div><div className='rating_num_popup'>" + `${rating || "-"}` + "</div> </div> </div> ";

  //               // let info = "<div className='school_popup'> <div className='left_part'> <div className='school_name'> <strong>" + `${schoolname}` + "</strong> </div> <div className='school_data'> <div className='school_level'>" + `${instructionlevel || "not available"}` + "</div> <div className='school_grade'>Grades: 9-12</div> <div className='school_student'>No of students: 9-12</div> <div className='school_teacher'>Student/Teacher: 17:1</div> <div className='school_website'>Webiste: www.google.com</div> </div>  </div> <div className='right_part'>     <div className='rating_txt_popup'>Rating</div>     <div className='rating_num_popup'>" + `${rating || "not available"}` + "</div> </div> </div> "

  //               google.maps.event.addListener(
  //                 marker,
  //                 "click",
  //                 (function (marker, i) {
  //                   return function () {
  //                     this.setState({ popupdisplay: "none", singlehome: [] });
  //                     this.clearsingleschoolMarker();
  //                     this.setState({ selectedschoolid: "" });
  //                     this.pschoolmarkers.filter(function (element) {
  //                       element.setIcon({
  //                         url:
  //                           process.env.NEXT_PUBLIC_CDN_ID +
  //                           "static/images/schoolicon.png",
  //                       });
  //                     });
  //                     marker.setIcon(selectedicon);
  //                     this.clearschoolpolysingle();
  //                     this.setState({ selectedschoolid: marker.id });
  //                     this.setState({ popupdisplay: "block" });
  //                     this.setState({ schoolpopupname: schoolname });
  //                     this.setState({ schoolgreatschoolurl: greatschoolurl });
  //                     let schoolrating = 0;

  //                     if (rating !== "" && rating > 0) {
  //                       schoolrating = rating / 2;
  //                     }
  //                     this.setState({ schoolpopuprating: rating });
  //                     this.setState({ schoolpopupgrade: grades });
  //                     this.setState({ schoolpopuptype: instructionlevel });
  //                     this.setState({ schoolwebsite: website });
  //                     this.setState({ schoolstudent: noofstudent });
  //                     this.setState({ schoolstudentratio: studentratio });
  //                   };
  //                 })(marker, i).bind(this)
  //               );

  //               google.maps.event.addListener(
  //                 marker,
  //                 "mouseover",
  //                 (function (marker, i) {
  //                   return function () {
  //                     //infowindow.setPosition({lat: -34, lng: 151});
  //                     //infowindow.setContent(info);
  //                     //infowindow.open(this.map, marker);
  //                     //this.clearschoolpolysingle();
  //                     // this.setState({ popupdisplay: "none" });
  //                     if (this.sbermudaTriangle.length > 0) {
  //                       for (var i = 0; i < this.sbermudaTriangle.length; i++) {
  //                         this.sbermudaTriangle[i].setMap(null);
  //                       }
  //                     }

  //                     let hoverschool = schoolresults.filter(
  //                       (item) => item.id === id
  //                     );
  //                     let school_points = [];
  //                     //let new_mapthis.map.state.map

  //                     if (hoverschool.length === 0) {
  //                     }
  //                     if (hoverschool.length > 0) {
  //                       let i;
  //                       let reversedCoordsnew;

  //                       hoverschool.map((item, index) => {
  //                         let polygoncordinates =
  //                           item.school_cords[index].split(",");
  //                         let polygoncords_length = polygoncordinates.length;
  //                         if (item.school_cords) {
  //                           sdata = [];
  //                           sdata.push(item.school_cords);
  //                         }

  //                         //if (polygoncords_length > 10) {
  //                         sdata.map((item3, index3) => {
  //                           item3.map((item4, index4) => {
  //                             this.school_points = [];
  //                             if (!this.school_points.includes(item4)) {
  //                               this.school_points.push(item4);

  //                               let newdata = JSON.parse(item4);

  //                               reversedCoordsnew =
  //                                 newdata[0].length > 5 &&
  //                                 newdata[0].map((item5, index5) => {
  //                                   return {
  //                                     lat: parseFloat(item5.x),
  //                                     lng: parseFloat(item5.y),
  //                                   };
  //                                 });

  //                               this.schoolTriangle = new google.maps.Polygon({
  //                                 paths: [reversedCoordsnew],
  //                                 strokeColor: "#c02e26",
  //                                 strokeWeight: 3.6,
  //                                 //fillColor: getschoolcolor(item.instructionlevel),
  //                                 fillOpacity: 0.0,
  //                                 zIndex: 3,
  //                               });

  //                               this.schoolTriangle.setMap(this.map.state.map);
  //                               this.sbermudaTriangle.push(this.schoolTriangle);
  //                             }
  //                           });
  //                         });
  //                         //}
  //                       });
  //                     }
  //                   };
  //                 })(marker, i).bind(this)
  //               );
  //               google.maps.event.addListener(
  //                 marker,
  //                 "mouseout",
  //                 (function (marker, i) {
  //                   return function () {
  //                     //infowindow.close(this.map, marker);
  //                     //this.setState({ popupdisplay: "none" });

  //                     for (var i = 0; i < this.sbermudaTriangle.length; i++) {
  //                       //if (marker.id !== this.state.selectedschoolid) {
  //                       this.sbermudaTriangle[i].setMap(null);
  //                       //}
  //                     }
  //                   };
  //                 })(marker, i).bind(this)
  //               );

  //               this.pschoolmarkers.push(marker);
  //             });
  //             var clusterStyles = [
  //               {
  //                 textColor: "white",
  //                 url: "/static/images/E1.png",
  //                 height: 20,
  //                 width: 20,
  //                 textSize: 0.001,
  //               },
  //               {
  //                 textColor: "white",
  //                 url: "/static/images/E2.png",
  //                 height: 25,
  //                 width: 25,
  //                 textSize: 0.001,
  //               },
  //               {
  //                 textColor: "white",
  //                 url: "/static/images/E3.png",
  //                 height: 30,
  //                 width: 30,
  //                 textSize: 0.001,
  //               },
  //             ];
  //             var mcOptions = {
  //               gridSize: 150,
  //               //minimumClusterSize: 10,
  //               styles: clusterStyles,
  //               maxZoom: 14,
  //               // minimumClusterSize: 10
  //               textSize: 0.001,
  //             };
  //             function getClusterStyle(markersCount) {
  //               if (markersCount < 10) {
  //                 return clusterStyles[0];
  //               } else if (markersCount < 20) {
  //                 return clusterStyles[1];
  //               } else {
  //                 return clusterStyles[2];
  //               }
  //             }
  //             //var markerCluster = new MarkerClusterer(this.map, gmarkers);
  //             // Add a marker clusterer to manage the markers.
  //             this.pschoolmarkerCluster = new MarkerClusterer(
  //               {
  //                 map: this.map.state.map,
  //                 markers: this.pschoolmarkers,
  //                 algorithm: new SuperClusterAlgorithm({
  //                   radius: zoom_level < 13 ? 250 : 50, // Equivalent to grid size
  //                 }),
  //                 renderer: {
  //                   render: ({ markers, _position: position }) => {
  //                     const clusterStyle = getClusterStyle(markers.length);
  //                     return new google.maps.Marker({
  //                       position: {
  //                         lat: position.lat(),
  //                         lng: position.lng(),
  //                       },
  //                       icon: {
  //                         url: clusterStyle.url,
  //                         scaledSize: new google.maps.Size(
  //                           clusterStyle.width,
  //                           clusterStyle.height
  //                         ),
  //                       },
  //                     });
  //                   },
  //                 },
  //               }
  //               // {
  //               //   imagePath:
  //               //     "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
  //               // }
  //             );
  //           }
  //           this.pschoolarr.push(this.pschoolmarkerCluster);
  //         })
  //         .catch((error) => {
  //           console.error(error);
  //         });
  //     }
  //   } else if (lhpStr !== "all") {
  //     this.setState({ is_display_zoom_msg: true });
  //   }
  // };

  get_school2 = async (lhpStr) => {
    let zoom_level = this.map?.state?.map?.getZoom();
    if (zoom_level > 0) {
      this.setState({ is_display_zoom_msg: false });
      this.setState({ loaderdispaly: "block" });

      let bounds = this.map.state.map.getBounds();
      let north = bounds.getNorthEast().lat();
      let east = bounds.getNorthEast().lng();
      let south = bounds.getSouthWest().lat();
      let west = bounds.getSouthWest().lng();

      const midLat = (north + south) / 2;
      const midLng = (east + west) / 2;

      const quadrants = [
        { north, south: midLat, east: midLng, west }, // Top-Left
        { north, south: midLat, east, west: midLng }, // Top-Right
        { north: midLat, south, east: midLng, west }, // Bottom-Left
        { north: midLat, south, east, west: midLng }, // Bottom-Right
      ];

      const buildLatLngString = (n, s, e, w) => {
        const nw = new google.maps.LatLng(n, w);
        const sw = new google.maps.LatLng(s, w);
        const se = new google.maps.LatLng(s, e);
        const ne = new google.maps.LatLng(n, e);
        return (
          "(" +
          nw.lat().toFixed(6) +
          " " +
          nw.lng().toFixed(6) +
          "," +
          sw.lat().toFixed(6) +
          " " +
          sw.lng().toFixed(6) +
          "," +
          se.lat().toFixed(6) +
          " " +
          se.lng().toFixed(6) +
          "," +
          ne.lat().toFixed(6) +
          " " +
          ne.lng().toFixed(6) +
          "," +
          nw.lat().toFixed(6) +
          " " +
          nw.lng().toFixed(6) +
          ")"
        );
      };

      const fetchAndRenderSchools = async (latlng, bounds) => {
        const getdatanew = {
          start: 0,
          limit: 100,
          orderBy: "id",
          order: latlng,
          fields: [
            { name: "lat", value: bounds.south, operator: ">" },
            { name: "lat", value: bounds.north, operator: "<" },
            { name: "lang", value: bounds.west, operator: ">" },
            { name: "lang", value: bounds.east, operator: "<" },
          ],
          zoomLevel: zoom_level,
          device: this.state.isMobile ? "mobile" : "desktop",
        };

        try {
          const result = await getAllSchoolList(getdatanew);
          if (result.data.getSchool && result.data.getSchool.length > 0) {
            this.renderFetchedSchools(result, lhpStr, zoom_level);
          }
        } catch (error) {
          console.error("Quadrant load error", error);
        }
      };

      for (const q of quadrants) {
        const latlng = buildLatLngString(q.north, q.south, q.east, q.west);
        await fetchAndRenderSchools(latlng, q);
      }

      this.setState({ loaderdispaly: "none" });
    } else if (lhpStr !== "all") {
      this.setState({ is_display_zoom_msg: true });
    }
  };

  renderFetchedSchools = (result, lhpStr, zoom_level) => {
    // this.clearschoolpoly();
    // this.clearschoolMarkers();

    let schooltypes = "";
    // schoolresults = result.data.getSchool;

    if (result.data.getSchool && result.data.getSchool.length === 0) {
      this.setState({ loaderdispaly: "none" });
    }
    if (result.data.getSchool && result.data.getSchool.length > 0) {
      this.setState({ loaderdispaly: "none" });

      let locations = [];
      let filteredSchools = [];
      let sdata = [];

      let primaryscore = [];
      let middlescore = [];
      let highscore = [];
      let allscore = [];
      let schoolresults = [];
      if (lhpStr === "Primary") {
        filteredSchools = result.data.getSchool.filter((school) =>
          this.schoolgrades.primaryarr.includes(school.instructionlevel),
        );
        schooltypes = "Primary";
      } else if (lhpStr === "Middle") {
        filteredSchools = result.data.getSchool.filter((school) =>
          this.schoolgrades.middlearr.includes(school.instructionlevel),
        );
        schooltypes = "Middle";
      } else if (lhpStr === "High") {
        filteredSchools = result.data.getSchool.filter((school) =>
          this.schoolgrades.higharr.includes(school.instructionlevel),
        );
        schooltypes = "High";
      } else {
        filteredSchools = result.data.getSchool;
      }
      locations = filteredSchools.map((item, index) => {
        if (item.school_cords !== "" && item.school_cords !== null) {
          //let polygoncordinates = item.school_cords[0].split(",");
          //let polygoncords_length = polygoncordinates.length;
          // if (
          //   polygoncords_length > 0 &&
          //   item.schoolname === "Palo Alto High"
          // ) {
          if (lhpStr === "all") {
            if (this.schoolgrades.primaryarr.includes(item.instructionlevel)) {
              schooltypes = "Primary";
            } else if (
              this.schoolgrades.middlearr.includes(item.instructionlevel)
            ) {
              schooltypes = "Middle";
            } else if (
              this.schoolgrades.higharr.includes(item.instructionlevel)
            ) {
              schooltypes = "High";
            }
          }

          if (
            item.school_cords &&
            schooltypes === lhpStr
            //polygoncords_length > 10
          ) {
            let schoolcordinate = [];
            if (item.school_cords && item.school_cords != "") {
              // schoolcordinate = item.school_cords[0];
              for (var i = 0; i < item.school_cords.length; i++) {
                sdata.push({
                  cords: item.school_cords[i],
                  rating: item.rating,
                });
              }
            }

            // if (lhpStr === "Primary" && schooltypes === lhpStr) {
            //   primaryscore.push(item.rating);
            // }

            // if (lhpStr === "Middle" && schooltypes === lhpStr) {
            //   middlescore.push(item.rating);
            // }

            // if (lhpStr === "High" && schooltypes === lhpStr) {
            //   highscore.push(item.rating);
            // }
          }
          // }else if(lhpStr === "all"){

          //   sdata.push(item.school_cords);
          //   allscore.push(item.rating);
          // }

          this.s_id = item.id;

          /* if(lhpStr === "Primary"){    */
          //this.primaryschool.push(item.school);
          /*}*/
          this.sfetchid.push(item.id);
          //if (polygoncords_length > 10) {
          sdata &&
            sdata.length > 0 &&
            sdata.map((item3, index3) => {
              //this.primary_polygon_points = [];
              if (item3.cords && item3.cords != undefined) {
                if (!this.primary_polygon_points.includes(item3.cords)) {
                  this.primary_polygon_points.push(item3.cords);
                  let newdata = JSON.parse(item3.cords);
                  let reversedCoordsnew =
                    newdata[0].length > 5 &&
                    newdata[0].map((item5, index5) => {
                      return {
                        lat: parseFloat(item5.x),
                        lng: parseFloat(item5.y),
                      };
                    });

                  this.pbermudaTriangle = new google.maps.Polygon({
                    paths: [reversedCoordsnew],
                    strokeColor: "#FF0000",
                    strokeOpacity: 0.00001,
                    strokeWeight: 0,
                    //fillColor: "#ffa64d",
                    fillOpacity: zoom_level > 14 ? 0.25 : 0.75,
                    zIndex: 1,
                    fillColor: get_school_color(item3.rating),
                  });
                  // if (lhpStr === "Primary") {
                  //   if (primaryscore && primaryscore.length > 0) {
                  //     this.pbermudaTriangle.setOptions({
                  //       fillColor: this.get_school_color(
                  //         primaryscore[index3]
                  //       ),
                  //     });
                  //   }
                  // }

                  // if (lhpStr === "Middle") {
                  //   if (middlescore && middlescore.length > 0) {
                  //     this.pbermudaTriangle.setOptions({
                  //       fillColor: this.get_school_color(
                  //         middlescore[index3]
                  //       ),
                  //     });
                  //   }
                  // }

                  // if (lhpStr === "High") {
                  //   if (highscore && highscore.length > 0) {
                  //     this.pbermudaTriangle.setOptions({
                  //       fillColor: this.get_schools_color(
                  //         highscore[index3]
                  //       ),
                  //     });
                  //   }
                  // }
                  this.pbermudaTriangle.setMap(this.map.state.map);
                  this.ppbermudaTriangle.push(this.pbermudaTriangle);
                }
              }
            });
        }
        // }
        //}
        if (
          item.school_cords !== "" ||
          item.school_cords !== null ||
          item.city == "San Francisco" ||
          item.city == "Belmont" ||
          item.schooldistname == "Belmont-Redwood Shores Elementary"
        ) {
          if (
            !this.pschoolpoints.includes(item.lat + item.lang) &&
            lhpStr === "all"
          ) {
            this.pschoolpoints.push(item.lat + item.lang);
            return {
              id: item.id,
              lat: parseFloat(item.lat),
              lng: parseFloat(item.lang),
              schoolname: item.schoolname,
              county: item.county,
              schooltype: schooltypes,
              instructionlevel: item.instructionlevel,
              rating: item.rating,
              website: item.schoolurl,
              noofstudent: item.noofstudent,
              studentratio: item.studentratio,
              greatschoolurl: item.greatschoolurl,
              //homejunctionschoolid : item.homejunctionschoolid,
              // grade : item.gradelow,
              exists: false,
            };
          } else if (
            !this.pschoolpoints.includes(item.lat + item.lang) &&
            schooltypes === lhpStr
          ) {
            this.pschoolpoints.push(item.lat + item.lang);
            return {
              id: item.id,
              lat: parseFloat(item.lat),
              lng: parseFloat(item.lang),
              schoolname: item.schoolname,
              county: item.county,
              schooltype: schooltypes,
              instructionlevel: item.instructionlevel,
              rating: item.rating,
              website: item.schoolurl,
              noofstudent: item.noofstudent,
              studentratio: item.studentratio,
              greatschoolurl: item.greatschoolurl,
              //homejunctionschoolid : item.homejunctionschoolid,
              // grade : item.gradelow,
              exists: false,
            };
          } else {
            return { exists: true };
          }
        }
      });

      /**HERE */
      let primarydata = [];

      let icons = {
        url: process.env.NEXT_PUBLIC_CDN_ID + "static/images/schoolicon.png",
      };
      let selectedicon = {
        url:
          process.env.NEXT_PUBLIC_CDN_ID + "static/images/schooliconlarge.png",
      };
      let markericon = "";
      let selectedid = this.state.selectedschoolid;
      let data = locations.filter(function (element) {
        return element !== undefined;
      });
      data.map((location, i) => {
        if (location.exists) {
          this.pschoolmarkers.filter(function (element) {
            if (element.id === selectedid) {
              element.setIcon(selectedicon);
            } else {
              element.setIcon(icons);
            }
          });
          return;
        }

        if (location.id === selectedid) {
          markericon = {
            url:
              process.env.NEXT_PUBLIC_CDN_ID +
              "static/images/schooliconlarge.png",
          };
        } else {
          markericon = {
            url:
              process.env.NEXT_PUBLIC_CDN_ID + "static/images/schoolicon.png",
          };
        }
        let schoolname = location.schoolname;
        let id = location.id;
        let newloc = {
          lat: location.lat,
          lng: location.lng,
        };
        // let schooltypes = "";
        // if (
        //   this.schoolgrades.primaryarr.includes(location.instructionlevel)
        // ) {
        //   schooltypes = "Primary";
        // } else if (
        //   this.schoolgrades.middlearr.includes(location.instructionlevel)
        // ) {
        //   schooltypes = "Middle";
        // } else if (
        //   this.schoolgrades.higharr.includes(location.instructionlevel)
        // ) {
        //   schooltypes = "High";
        // }
        let county = location.county;
        let schooltype = location.schooltype;
        let rating = location.rating;
        let instructionlevel = location.instructionlevel;
        let website = location.website;
        let noofstudent = location.noofstudent;
        let grades = location.schooltype;
        let studentratio = location.studentratio;
        let greatschoolurl = location.greatschoolurl;
        var marker = new google.maps.Marker({
          id: location.id,
          position: newloc,
          //label: {text:`${schoolname}`, color: '#000'},
          icon: markericon,
          //animation: google.maps.Animation.DROP,
        });
        var infowindow = new google.maps.InfoWindow({
          disableAutoPan: true,
        });

        // var infowaycontent = "<div className='school_popuop'><div style={{display: 'flex', flexDirection: 'column'}}  className='school_name'> <div> " + `${schoolname}` + "</div> <div> instructionlevel:" + `${instructionlevel || "not available"}` + "</div><div> rating:" + `${rating || "not available"}` + "</div></div><div className='school_right'><div className='school_rating_name'>Rating</div><div className='school_rating'> " + `${rating}` + "</div> </div></div>  </div>  </div>";

        // let info = "<div className='school_popup'> <div className='left_part'> <div className='school_name'> <strong>" + `${schoolname}` + "</strong> </div> <div className='school_data'> <div className='school_level'>" + `${instructionlevel || "-"}` + "</div> <div className='school_grade'>Grades: " + `${grades || "-"}` + "</div> </div>  </div> <div className='right_part'>     <div className='rating_txt_popup'>Rating</div><div className='rating_num_popup'>" + `${rating || "-"}` + "</div> </div> </div> ";

        // let info = "<div className='school_popup'> <div className='left_part'> <div className='school_name'> <strong>" + `${schoolname}` + "</strong> </div> <div className='school_data'> <div className='school_level'>" + `${instructionlevel || "not available"}` + "</div> <div className='school_grade'>Grades: 9-12</div> <div className='school_student'>No of students: 9-12</div> <div className='school_teacher'>Student/Teacher: 17:1</div> <div className='school_website'>Webiste: www.google.com</div> </div>  </div> <div className='right_part'>     <div className='rating_txt_popup'>Rating</div>     <div className='rating_num_popup'>" + `${rating || "not available"}` + "</div> </div> </div> "

        google.maps.event.addListener(
          marker,
          "click",
          (function (marker, i) {
            return function () {
              this.setState({ popupdisplay: "none", singlehome: [] });
              this.clearsingleschoolMarker();
              this.setState({ selectedschoolid: "" });
              this.pschoolmarkers.filter(function (element) {
                element.setIcon({
                  url:
                    process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/schoolicon.png",
                });
              });
              marker.setIcon(selectedicon);
              this.clearschoolpolysingle();
              this.setState({ selectedschoolid: marker.id });
              this.setState({ popupdisplay: "block" });
              this.setState({ schoolpopupname: schoolname });
              this.setState({ schoolgreatschoolurl: greatschoolurl });
              let schoolrating = 0;

              if (rating !== "" && rating > 0) {
                schoolrating = rating / 2;
              }
              this.setState({ schoolpopuprating: rating });
              this.setState({ schoolpopupgrade: grades });
              this.setState({ schoolpopuptype: instructionlevel });
              this.setState({ schoolwebsite: website });
              this.setState({ schoolstudent: noofstudent });
              this.setState({ schoolstudentratio: studentratio });
            };
          })(marker, i).bind(this),
        );

        google.maps.event.addListener(
          marker,
          "mouseover",
          (function (marker, i) {
            return function () {
              //infowindow.setPosition({lat: -34, lng: 151});
              //infowindow.setContent(info);
              //infowindow.open(this.map, marker);
              //this.clearschoolpolysingle();
              // this.setState({ popupdisplay: "none" });
              if (this.sbermudaTriangle.length > 0) {
                for (var i = 0; i < this.sbermudaTriangle.length; i++) {
                  this.sbermudaTriangle[i].setMap(null);
                }
              }

              let hoverschool = schoolresults.filter((item) => item.id === id);
              let school_points = [];
              //let new_mapthis.map.state.map

              if (hoverschool.length === 0) {
              }
              if (hoverschool.length > 0) {
                let i;
                let reversedCoordsnew;

                hoverschool.map((item, index) => {
                  let polygoncordinates = item.school_cords[index].split(",");
                  let polygoncords_length = polygoncordinates.length;
                  if (item.school_cords) {
                    sdata = [];
                    sdata.push(item.school_cords);
                  }

                  //if (polygoncords_length > 10) {
                  sdata.map((item3, index3) => {
                    item3.map((item4, index4) => {
                      this.school_points = [];
                      if (!this.school_points.includes(item4)) {
                        this.school_points.push(item4);

                        let newdata = JSON.parse(item4);

                        reversedCoordsnew =
                          newdata[0].length > 5 &&
                          newdata[0].map((item5, index5) => {
                            return {
                              lat: parseFloat(item5.x),
                              lng: parseFloat(item5.y),
                            };
                          });

                        this.schoolTriangle = new google.maps.Polygon({
                          paths: [reversedCoordsnew],
                          strokeColor: "#c02e26",
                          strokeWeight: 3.6,
                          //fillColor: getschoolcolor(item.instructionlevel),
                          fillOpacity: 0.0,
                          zIndex: 3,
                        });

                        this.schoolTriangle.setMap(this.map.state.map);
                        this.sbermudaTriangle.push(this.schoolTriangle);
                      }
                    });
                  });
                  //}
                });
              }
            };
          })(marker, i).bind(this),
        );
        google.maps.event.addListener(
          marker,
          "mouseout",
          (function (marker, i) {
            return function () {
              //infowindow.close(this.map, marker);
              //this.setState({ popupdisplay: "none" });

              for (var i = 0; i < this.sbermudaTriangle.length; i++) {
                //if (marker.id !== this.state.selectedschoolid) {
                this.sbermudaTriangle[i].setMap(null);
                //}
              }
            };
          })(marker, i).bind(this),
        );

        this.pschoolmarkers.push(marker);
      });
      var clusterStyles = [
        {
          textColor: "white",
          url: "/static/images/E1.png",
          height: 20,
          width: 20,
          textSize: 0.001,
        },
        {
          textColor: "white",
          url: "/static/images/E2.png",
          height: 25,
          width: 25,
          textSize: 0.001,
        },
        {
          textColor: "white",
          url: "/static/images/E3.png",
          height: 30,
          width: 30,
          textSize: 0.001,
        },
      ];
      var mcOptions = {
        gridSize: 150,
        //minimumClusterSize: 10,
        styles: clusterStyles,
        maxZoom: 14,
        // minimumClusterSize: 10
        textSize: 0.001,
      };
      function getClusterStyle(markersCount) {
        if (markersCount < 10) {
          return clusterStyles[0];
        } else if (markersCount < 20) {
          return clusterStyles[1];
        } else {
          return clusterStyles[2];
        }
      }
      //var markerCluster = new MarkerClusterer(this.map, gmarkers);
      // Add a marker clusterer to manage the markers.
      this.pschoolmarkerCluster = new MarkerClusterer(
        {
          map: this.map?.state?.map,
          markers: this.pschoolmarkers,
          algorithm: new SuperClusterAlgorithm({
            radius: zoom_level < 13 ? 250 : 50, // Equivalent to grid size
          }),
          renderer: {
            render: ({ markers, _position: position }) => {
              const clusterStyle = getClusterStyle(markers.length);
              return new google.maps.Marker({
                position: {
                  lat: position.lat(),
                  lng: position.lng(),
                },
                icon: {
                  url: clusterStyle.url,
                  scaledSize: new google.maps.Size(
                    clusterStyle.width,
                    clusterStyle.height,
                  ),
                },
              });
            },
          },
        },
        // {
        //   imagePath:
        //     "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
        // }
      );
    }
    this.pschoolarr.push(this.pschoolmarkerCluster);
  };

  /**
   * Wait for map to be ready and then load data
   * Uses requestAnimationFrame for efficient polling without blocking
   * CRITICAL: Also waits for bounds to be available (map tiles loaded)
   */
  waitForMapAndLoadData = (lhpStr, useStaticData) => {
    const checkMapReady = () => {

      // Check if map reference exists and has the state.map property
      if (this.map && this.map.state && this.map.state.map) {
        const bounds = this.map.state.map.getBounds();

        if (bounds) {
          // Map is FULLY ready with bounds calculated - safe to load data
          this.bound_changed(lhpStr, useStaticData);
        } else {
          // Map object exists but bounds not ready yet (tiles still loading)
          requestAnimationFrame(checkMapReady);
        }
      } else {
        // Map not ready yet, check again on next frame
        requestAnimationFrame(checkMapReady);
      }
    };

    // Start checking immediately
    requestAnimationFrame(checkMapReady);
  };

  bound_changed = (lhpStr, useStaticData = false) => {
    if (lhpStr === "school" || lhpStr === "all") {
    } else {
      this.clearschoolMarkers();
    }

    this.props.handletab(true);
    if (!this.state.isFromsavenh) {
      this.setState({ loaderdispaly: "block" });
    }
    if (lhpStr != "personal") {
      localStorage.setItem("is_already_perosnal", false);
    }

    // Check current screen size to determine if we should use static data
    const windowWidth = typeof window !== 'undefined' ? window.innerWidth : 1920;
    const isCurrentlyMobileSize = windowWidth <= 768;

    // Only use static data if:
    // 1. useStaticData flag is true (passed from componentDidMount)
    // 2. Current screen is actually mobile size (<=768px)
    // 3. User hasn't interacted yet
    const shouldUseStaticData = useStaticData && isCurrentlyMobileSize && !this.hasUserInteracted;

    // If shouldUseStaticData is true, load from MapResultData and return early
    if (shouldUseStaticData) {
      // Check if map is ready
      if (!this.map || !this.map.state.map) {
        // Map not ready yet, use requestAnimationFrame for faster retry
        requestAnimationFrame(() => this.bound_changed(lhpStr, useStaticData));
        return;
      }
    }

    // this.setState({ popupdisplay: "none" });
    let zoom_level = this.map && this.map.state.map.getZoom();
    let bounds = this.map && this.map.state.map.getBounds();

    // if (lhpStr === "school" && zoom_level <= 11) {
    //   this.setState({ loaderdispaly: "none" });
    //   this.props.handletab(false);
    // } else {
    this.setState({ is_display_zoom_msg: false });
    if (bounds) {
      let north = bounds.getNorthEast().lat();
      let east = bounds.getNorthEast().lng();
      let south = bounds.getSouthWest().lat();
      let west = bounds.getSouthWest().lng();
      let northEast;
      let northWest;
      let southEast;
      let southWest;

      let logindata = JSON.parse(localStorage.getItem("auth_query"));

      localStorage.setItem(
        "searchlatuser",
        this.map.state.map.getCenter().lat(),
      );
      localStorage.setItem(
        "searchlanguser",
        this.map.state.map.getCenter().lng(),
      );
      localStorage.setItem("searchzoomuser", zoom_level);
      let centerLat, centerLng;
      // let northEast, northWest, southEast, southWest;

      if (zoom_level > 12) {
        // Calculate deltas for adjustment
        let deltaWidth = 0.15 * Math.abs(east - west);
        let deltaHeight = 0.15 * Math.abs(south - north);

        // Adjust the boundaries based on zoom level
        let newBoundNorth = north + deltaHeight;
        let newBoundSouth = south - deltaHeight;
        let newBoundEast = east + deltaWidth;
        let newBoundWest = west - deltaWidth;

        // Update the center coordinates with the new boundaries
        centerLat = (newBoundNorth + newBoundSouth) / 2;
        centerLng = (newBoundEast + newBoundWest) / 2;

        // Define the corners using the new adjusted boundaries
        northEast = new google.maps.LatLng(newBoundNorth, newBoundEast);
        northWest = new google.maps.LatLng(newBoundNorth, newBoundWest);
        southEast = new google.maps.LatLng(newBoundSouth, newBoundEast);
        southWest = new google.maps.LatLng(newBoundSouth, newBoundWest);
      } else {
        // Use original boundaries if zoom level is not greater than 12
        centerLat = (north + south) / 2;
        centerLng = (east + west) / 2;

        // Define the corners using the original boundaries
        northEast = new google.maps.LatLng(north, east);
        northWest = new google.maps.LatLng(north, west);
        southEast = new google.maps.LatLng(south, east);
        southWest = new google.maps.LatLng(south, west);
      }
      let center = new google.maps.LatLng(centerLat, centerLng);

      let rightlanglat =
        "(" +
        northWest.lat().toFixed(6) +
        " " +
        northWest.lng().toFixed(6) +
        "," +
        southWest.lat().toFixed(6) +
        " " +
        southWest.lng().toFixed(6) +
        "," +
        southEast.lat().toFixed(6) +
        " " +
        southEast.lng().toFixed(6) +
        "," +
        northEast.lat().toFixed(6) +
        " " +
        northEast.lng().toFixed(6) +
        "," +
        northWest.lat().toFixed(6) +
        " " +
        northWest.lng().toFixed(6) +
        ")";

      let finallatlng1 =
        `(` +
        `${northWest.lat().toFixed(6)} ${northWest.lng().toFixed(6)},` +
        `${northWest.lat().toFixed(6)} ${center.lng().toFixed(6)},` +
        `${center.lat().toFixed(6)} ${center.lng().toFixed(6)},` +
        `${northWest.lat().toFixed(6)} ${center.lng().toFixed(6)},` +
        `${northWest.lat().toFixed(6)} ${northWest.lng().toFixed(6)})`;

      let finallatlng2 =
        `(` +
        `${northWest.lat().toFixed(6)} ${center.lng().toFixed(6)},` +
        `${northEast.lat().toFixed(6)} ${northEast.lng().toFixed(6)},` +
        `${center.lat().toFixed(6)} ${northEast.lng().toFixed(6)},` +
        `${center.lat().toFixed(6)} ${center.lng().toFixed(6)},` +
        `${northWest.lat().toFixed(6)} ${center.lng().toFixed(6)})`;

      let finallatlng3 =
        `(` +
        `${southWest.lat().toFixed(6)} ${southWest.lng().toFixed(6)},` +
        `${southWest.lat().toFixed(6)} ${center.lng().toFixed(6)},` +
        `${center.lat().toFixed(6)} ${center.lng().toFixed(6)},` +
        `${southWest.lat().toFixed(6)} ${southWest.lng().toFixed(6)},` +
        `${southWest.lat().toFixed(6)} ${southWest.lng().toFixed(6)})`;

      let finallatlng4 =
        `(` +
        `${center.lat().toFixed(6)} ${center.lng().toFixed(6)},` +
        `${southEast.lat().toFixed(6)} ${southEast.lng().toFixed(6)},` +
        `${southEast.lat().toFixed(6)} ${east.toFixed(6)},` +
        `${center.lat().toFixed(6)} ${east.toFixed(6)},` +
        `${center.lat().toFixed(6)} ${center.lng().toFixed(6)})`;

      let orderfield = "";
      if (!useStaticData) {
        if (this.selecedtabs === 9) {
          orderfield = "primaryschoolscore";
        } else if (this.selecedtabs === 10) {
          orderfield = "middleschoolscore";
        } else if (this.selecedtabs === 11) {
          orderfield = "highschoolscore";
        } else if (lhpStr === "all") {
          orderfield = "school";
        } else if (lhpStr) {
          orderfield = lhpStr === "price" ? "medianprice" : lhpStr;
        } else {
          orderfield = "npi";
        }
      }
      let limit = 0;

      if (zoom_level > 13) {
        limit = 250;
      } else {
        limit = 100;
      }
      this.setState({ selectedNeighborhood: [] });
      const defaultalt = localStorage.getItem("searchlatuser");
      if (zoom_level < 14) {
        if (!this.polygonCleared) {
          // Clear polygon only once when switching to zoom_level < 14
          this.clearpoly();
          this.polygonCleared = true; // Set flag to indicate polygon is cleared
        }

        // Use shouldUseStaticData (already calculated above) instead of checking flags again
        if (shouldUseStaticData) {
          // Use static data for initial render on mobile only
          const result = {
            data: {
              getnhmapneighborboundries: MapResultData?.data?.getnhmapneighborboundries || []
            }
          };

          // Render the static data using existing logic
          this.renderBoundries(result, lhpStr, zoom_level);

          // Mark initial load as complete
          this.isInitialLoad = false;
        } else {
          // Desktop/tablet or user has interacted - use GraphQL API

          this.callApiForQuadrant(
            limit,
            orderfield,
            finallatlng1,
            south,
            north,
            west,
            east,
            lhpStr,
            "13",
            defaultalt,
          );
          this.callApiForQuadrant(
            limit,
            orderfield,
            finallatlng2,
            south,
            north,
            west,
            east,
            lhpStr,
            "13",
            defaultalt,
          );
          this.callApiForQuadrant(
            limit,
            orderfield,
            finallatlng3,
            south,
            north,
            west,
            east,
            lhpStr,
            "13",
            defaultalt,
          );
          this.callApiForQuadrant(
            limit,
            orderfield,
            finallatlng4,
            south,
            north,
            west,
            east,
            lhpStr,
            "13",
            defaultalt,
          );
        }

        this.callApiForRightside(limit, orderfield, lhpStr, "14");
      } else {
        if (
          (this.polygonCleared || zoom_level === 14 || zoom_level === 15) &&
          this.previousZoomLevel !== zoom_level
        ) {
          // Clear polygon when switching to zoom_level >= 14
          this.clearpoly();
          this.polygonCleared = false; // Reset flag
        }
        this.previousZoomLevel = zoom_level;

        // Use shouldUseStaticData (already calculated above) instead of checking flags again
        if (shouldUseStaticData) {
          // Use static data for initial render on mobile only
          const result = {
            data: {
              getnhmapneighborboundries: MapResultData?.data?.getnhmapneighborboundries || []
            }
          };

          // Render the static data using existing logic
          this.renderBoundries(result, lhpStr, zoom_level);

          // Mark initial load as complete
          this.isInitialLoad = false;
        } else {
          // Desktop/tablet or user has interacted - use GraphQL API
          this.callApiForQuadrant(
            limit,
            orderfield,
            rightlanglat,
            south,
            north,
            west,
            east,
            lhpStr,
            zoom_level,
            defaultalt,
          );
        }
        this.callApiForRightside(limit, orderfield, lhpStr, "14");
      }
    }
    //}
  };

  callApiForQuadrant(
    limit,
    orderfield,
    finallatlng,
    south,
    north,
    west,
    east,
    lhpStr,
    zoom_level,
    defaultalt,
  ) {

    // Check actual screen width at mount time
    const windowWidth = typeof window !== 'undefined' ? window.innerWidth : 1920;
    const shouldUseStaticData = windowWidth <= 768 && !this.hasUserInteracted;

    if (!shouldUseStaticData) {
      // Desktop or tablet: use API immediately
      this.hasUserInteracted = true;
    }

    // let propsnew = this.props;
    let getdata;

    // if (
    //   defaultalt === "37.63394653644841" ||
    //   defaultalt === "37.634490308266784"
    // ) {
    //   console.log('inside the if first static data load ');
    //   const result = defaultData;
    //   this.renderBoundries(result, lhpStr, zoom_level);
    // } 
    // else 
    if (shouldUseStaticData) {

      const result = MapResultData;
      this.renderBoundries(result, lhpStr, zoom_level);
    } else {
      if (lhpStr === "personal") {
        getdata = {
          start: this.state.limit,
          limit: limit,
          orderBy: orderfield,
          order: finallatlng,
          fields: [
            {
              name: "latitude",
              value: south,
              operator: ">",
            },
            {
              name: "latitude",
              value: north,
              operator: "<",
            },
            {
              name: "longitude",
              value: west,
              operator: ">",
            },
            {
              name: "longitude",
              value: east,
              operator: "<",
            },
          ],
          userid: "",
          userdata: localStorage.getItem("globaluserid"),
          schools:
            (this.props.schoolbar_val === 0 ? 50 : this.props.schoolbar_val) /
            10,
          safety:
            (this.props.crimebar_val === 0 ? 50 : this.props.crimebar_val) / 10,
          walkability:
            (this.props.walkbar_val === 0 ? 50 : this.props.walkbar_val) / 10,
          publicspaces:
            (this.props.townbar_val === 0 ? 50 : this.props.townbar_val) / 10,
          curbAppeal:
            (this.props.curbbar_val === 0 ? 50 : this.props.curbbar_val) / 10,
          valueindex: this.props.valuebar_val / 10,
          minprice: this.props.pricemin_val,
          maxprice: this.props.pricemax_val,
          current_tab: lhpStr === "price" ? "medianprice" : lhpStr,
          zoomLevel: zoom_level,
          device: this.state.isMobile ? "mobile" : "desktop",
        };
        //this.saveneighbordata();
      } else if (lhpStr !== "personal") {
        getdata = {
          start: this.state.limit,
          limit: limit,
          orderBy: orderfield,
          order: finallatlng,
          fields: [
            {
              name: "latitude",
              value: south,
              operator: ">",
            },
            {
              name: "latitude",
              value: north,
              operator: "<",
            },
            {
              name: "longitude",
              value: west,
              operator: ">",
            },
            {
              name: "longitude",
              value: east,
              operator: "<",
            },
          ],
          userid: "",
          userdata: localStorage.getItem("globaluserid"),
          schools: this.props.schoolbar_val / 10,
          safety: this.props.crimebar_val / 10,
          walkability: this.props.walkbar_val / 10,
          publicspaces: this.props.townbar_val / 10,
          curbAppeal: this.props.curbbar_val / 10,
          valueindex: this.props.valuebar_val / 10,
          minprice: this.props.pricemin_val,
          maxprice: this.props.pricemax_val,
          current_tab: lhpStr === "price" ? "medianprice" : lhpStr,
          zoomLevel: zoom_level,
          device: this.state.isMobile ? "mobile" : "desktop",
        };
        // this.saveneighbordata();
      }
      getnhmapneighborboundrieslist(getdata)
        .then((result) => {
          this.renderBoundries(result, lhpStr, zoom_level);
        })
        .catch((error) => {
          console.error(error);
          //this.props.handletab(false);
          this.setState({ loaderdispaly: "none" });
        });
    }
  }

  renderBoundries = (result, lhpStr, zoom_level) => {    
    let boundries_data = [];
    if (lhpStr === "school" || lhpStr === "all") {
    } else {
      this.clearschoolMarkers();
    }
    let neighborhood_names = [];

    if (lhpStr === "personal") {
      let neighborhood = result.data.getnhmapneighborboundries;

      function comparePersonalNpi(a, b) {
        let comparison = 0;
        if (a.personalNpi > b.personalNpi) {
          comparison = -1;
        } else if (a.personalNpi < b.personalNpi) {
          comparison = 1;
        }
        return comparison;
      }

      neighborhood.sort(comparePersonalNpi);
      boundries_data = neighborhood;
    }

    /* NEW PERSONAL CALCULATION WRAP */

    if (
      result.data.getnhmapneighborboundries.length > 0 &&
      lhpStr !== "personal"
    ) {
      this.fetchid = [];
      this.npiscore = [];
      this.personalscore = [];
      this.valuescore = [];
      this.schoolscore = [];
      this.primaryschool = [];
      this.crimescore = [];
      this.walkabilityscore = [];
      this.communityscore = [];
      this.curbscore = [];
      this.othersscore = [];

      boundries_data = result.data.getnhmapneighborboundries;
    }
    if (boundries_data.length > 0) {
      //this.bound_changed_new(getdata, lhpStr, boundries_data);
      let that = this;
      let bermudaTriangle;

      this.map.state.map.addListener("click", function (event) {
        //that.clearcitypolysingle();
        that.clearcitypolyhover();
      });
      this.map.state.map.addListener("mouseout", function (event) {
        //if (that.nbermudaTrianglesingle.length > 0) {
        that.clearpolysingle();
        that.clearhoveredmarkers();
        that.clearcitypolyhover();
        if (that.state.searchednh.length === 0) {
          that.setState({ selectedNeighborhood: [] });
        } else {
          that.setState({ selectedNeighborhood: that.state.searchednh });
        }
      });
      this.map.state.map.addListener("mousemove", function (event) {
        //if (that.nbermudaTrianglesingle.length > 0) {
        that.clearpolysingle();
        that.clearhoveredmarkers();
        if (that.state.searchednh.length === 0) {
          that.setState({ selectedNeighborhood: [] });
        } else {
          that.setState({ selectedNeighborhood: that.state.searchednh });
        }
      });
      this.boundarydatas.push(...boundries_data);
      boundries_data.map((item, index) => {
        let displaykey = process.env.NEXT_PUBLIC_DISPLAY_DATA;
        if (item != undefined && item.geometry_cords) {
          if (!this.polygon_points.includes(item.id)) {
            this.polygon_points.push(item.id);
            let averagescore =
              (item.primaryschoolscore +
                item.middleschoolscore +
                item.highschoolscore) /
              3;
            let finalavgscore = (averagescore / 10).toFixed(1);

            this.n_id = item.id;

            this.fetchid.push(item.id);

            let boundry_data = JSON.parse("[" + item.geometry_cords + "]");
            // this.map.state.map.data.add({
            //   geometry: new google.maps.Data.Polygon([boundry_data])
            // });
            bermudaTriangle = new google.maps.Polygon({
              paths: boundry_data,
              strokeColor:
                item.savedneighborhoodbyuser === "1"
                  ? "#c02e26"
                  : item.summary != null && item.summary != ""
                    ? "rgb(27, 87, 165,0.7)"
                    : "#fff",
              strokeWeight:
                item.savedneighborhoodbyuser === "1"
                  ? 4
                  : item.summary != null && item.summary != ""
                    ? 2
                    : 1,
              fillOpacity:
                zoom_level < 14 ? 0.75 : zoom_level === 14 ? 0.45 : 0.25,
              zIndex:
                item.savedneighborhoodbyuser === "1" ||
                (item.summary != null && item.summary != "")
                  ? 3
                  : 2,
              id: item.id,
              name: item.name,
              walkscore: item.walkability,
              map: this.map.state.map,
            });
            if (item[displaykey] === 1) {
              if (lhpStr === "npi") {
                bermudaTriangle.setOptions({
                  fillColor: get_npi_color(Math.round(item.npi)),
                  //fillOpacity: zoom_level > 14 ? 0.25 : 0.75,
                });
              }

              if (lhpStr === "personal") {
                bermudaTriangle.setOptions({
                  fillColor: get_npi_color(item.personalNpi),
                });
              }

              if (lhpStr === "value") {
                bermudaTriangle.setOptions({
                  fillColor: get_nvi_color(item.value),
                  fillOpacity:
                    zoom_level < 14 ? 0.75 : zoom_level === 14 ? 0.45 : 0.25,
                });
              }

              if (lhpStr === "price") {
                bermudaTriangle.setOptions({
                  fillColor: get_price_color(Math.round(item.medianprice)),
                  fillOpacity:
                    zoom_level < 14 ? 0.75 : zoom_level === 14 ? 0.45 : 0.25,
                });
              }

              if (lhpStr === "school") {
                bermudaTriangle.setOptions({
                  fillColor: "#F9FADF",
                  fillOpacity: 0.0,
                  /* strokeColor: '#8B0000'*/
                });
              }
              if (lhpStr === "all") {
                if (item.school && parseFloat(item.school) > 0) {
                  bermudaTriangle.setOptions({
                    fillColor: get_school_color(item.school),
                  });
                } else {
                  bermudaTriangle.setOptions({
                    fillColor: "#F9FADF",
                    fillOpacity: 0.0,
                    /* strokeColor: '#8B0000'*/
                  });
                }
              }

              if (lhpStr === "crime") {
                bermudaTriangle.setOptions({
                  fillColor: get_crime_color(item.crime),
                });
              }
              if (lhpStr === "walkability") {
                bermudaTriangle.setOptions({
                  fillColor: get_walk_color(item.walkability),
                });
              }
              if (lhpStr === "dom") {
                bermudaTriangle.setOptions({
                  fillColor: get_dom_color(item.dom),
                  fillOpacity:
                    zoom_level < 14 ? 0.75 : zoom_level === 14 ? 0.45 : 0.25,
                });
              }
              if (lhpStr === "appreciation") {
                bermudaTriangle.setOptions({
                  fillColor: get_appreciation_color(item.appreciation),
                  fillOpacity:
                    zoom_level < 14 ? 0.75 : zoom_level === 14 ? 0.45 : 0.25,
                });
              }

              if (lhpStr === "publicspaces") {
                bermudaTriangle.setOptions({
                  fillColor: get_all_amenties_color(item.publicspaces),
                  fillOpacity:
                    zoom_level < 14 ? 0.75 : zoom_level === 14 ? 0.45 : 0.25,
                });
              }
              if (lhpStr === "curb") {
                bermudaTriangle.setOptions({
                  fillColor: get_all_amenties_color(item.curb),
                  fillOpacity:
                    zoom_level < 14 ? 0.75 : zoom_level === 14 ? 0.45 : 0.25,
                });
              }
              if (lhpStr === "others") {
                bermudaTriangle.setOptions({
                  fillColor: get_all_amenties_color(item.others),
                  fillOpacity:
                    zoom_level < 14 ? 0.75 : zoom_level === 14 ? 0.45 : 0.25,
                });
              }
              if (lhpStr === "amenities") {
                if (item.amenities > 0) {
                  bermudaTriangle.setOptions({
                    fillColor: get_all_amenties_color(item.amenities),
                    fillOpacity:
                      zoom_level < 14 ? 0.75 : zoom_level === 14 ? 0.45 : 0.25,
                  });
                } else {
                  bermudaTriangle.setOptions({
                    fillColor: get_walk_color(item.walkability),
                  });
                }
              }
            } else {
              bermudaTriangle.setOptions({
                fillColor: "#fff",
                fillOpacity: 0.0,
              });
            }

            let propsnew = this.props;
            let that = this;
            google.maps.event.addListener(
              bermudaTriangle,
              "mouseover",
              function (event) {
                that.clearpolysingle();
                that.clearhoveredmarkers();
                !that.state.isClickable &&
                  that.sethoveredmarker(
                    item.latitude,
                    item.longitude,
                    item.nhfullname,
                  );

                //that.clearcitypolysingle();
                if (lhpStr === "school") {
                  this.setOptions({
                    strokeWeight: 4,
                    opacity: 0,
                    zIndex: 4,
                    strokeColor:
                      item.savedneighborhoodbyuser === "1"
                        ? "#c02e26"
                        : "#c02e26",
                    // item.savedneighborhoodbyuser === "1"
                    //   ? "#c02e26"
                    //   : item.summary != null && item.summary != ""
                    //   ? "rgb(27, 87, 165,0.7)"
                    //   : "#c02e26",
                  });
                } else {
                  this.setOptions({
                    strokeWeight: 4,
                    opacity: 0,
                    zIndex: 4,
                    strokeColor:
                      item.savedneighborhoodbyuser === "1"
                        ? "#c02e26"
                        : "#c02e26",
                  });
                }
                let nhid = this.id;
                let single_nh_arr = [];
                let single_nh = boundries_data.find((o) => o.id === nhid);
                single_nh_arr.push(single_nh);
                if (single_nh_arr.length > 0) {
                  // setsingle();
                  // function setsingle() {
                  //   propsnew.singleNeighbor(single_nh_arr);
                  // }
                  // document.getElementById(
                  //   "single_main_top"
                  // ).style.height = "auto";
                  // document.getElementById(
                  //   "single_main_top"
                  // ).style.display = "block";
                  // document.getElementById(
                  //   "single_main_top"
                  // ).style.overflow = "auto";
                  //that.drawPolygon(single_nh_arr);
                  that.setState({
                    selectedNeighborhood: single_nh_arr,
                  });
                  var element = document.getElementById("single_main_top");
                  if (element) {
                    element.classList.add("open");
                    // setTimeout(function () {
                    //   element.scrollIntoView({ behavior: "smooth" });
                    // }, 500);
                  }
                }
              },
            );

            google.maps.event.addListener(
              bermudaTriangle,
              "mouseout",
              function (event) {
                if (lhpStr === "school") {
                  this.setOptions({
                    strokeWeight:
                      item.savedneighborhoodbyuser === "1"
                        ? 4
                        : item.summary != null && item.summary != ""
                          ? 2
                          : 1,
                    opacity: 0,
                    zIndex:
                      item.savedneighborhoodbyuser === "1" ||
                      (item.summary != null && item.summary != "")
                        ? 3
                        : 2,
                    strokeColor:
                      item.savedneighborhoodbyuser === "1"
                        ? "#c02e26"
                        : item.summary != null && item.summary != ""
                          ? "rgb(27, 87, 165,0.7)"
                          : "#FFFFFF",
                  });
                } else {
                  this.setOptions({
                    strokeWeight:
                      item.savedneighborhoodbyuser === "1"
                        ? 4
                        : item.summary != null && item.summary != ""
                          ? 2
                          : 1,
                    opacity: 0,
                    zIndex:
                      item.savedneighborhoodbyuser === "1" ||
                      (item.summary != null && item.summary != "")
                        ? 3
                        : 2,
                    strokeColor:
                      item.savedneighborhoodbyuser === "1"
                        ? "#c02e26"
                        : item.summary != null && item.summary != ""
                          ? "rgb(27, 87, 165,0.7)"
                          : "#FFFFFF",
                  });
                }

                that.clearpolysingle();
                // that.clearcitypolysingle();
                // propsnew.singleNeighbor([]);
                // that.clearpolysingle();
                // that.clearcitypolysingle();
                // document.getElementById(
                //   "single_main_top"
                // ).style.display = "none";
              },
            );
            if (item[displaykey] === 1) {
              google.maps.event.addListener(
                bermudaTriangle,
                "click",
                function (event) {
                  that.clearcitypolysingle();

                  let currenttab = propsnew.checkRhptab();
                  let ids = this.id;
                  if (currenttab === 1 && !that.state.isClickable) {
                    window.open(`/Neighborhood/${item.nhfullname}`, "_blank");
                  } else {
                    propsnew.singleClick();
                  }

                  let single_nh_arr = [];
                  let single_nh = boundries_data.find((o) => o.id === ids);
                  single_nh_arr.push(single_nh);
                  if (single_nh_arr.length > 0) {
                    setsingle();
                    function setsingle() {
                      propsnew.singleNeighbor(single_nh_arr);
                    }

                    that.setState(
                      {
                        selectedNeighborhood: single_nh_arr,
                        selectednhid: ids,
                        searchednh: single_nh_arr,
                      },
                      () => {
                        that.clearpolysingle();
                      },
                    );
                    that.drawPolygon(single_nh_arr);
                    var element = document.getElementById("single_main_top");
                    if (element) {
                      element.classList.add("open");
                      setTimeout(function () {
                        element.scrollIntoView({
                          behavior: "smooth",
                        });
                      }, 500);
                    }
                  }

                  //Router.push('/DetailsNh');
                },

                // function (event) {
                //   let nhid = this.id;
                //   let single_nh_arr = [];
                //   let single_nh = boundries_data.find(
                //     (o) => o.id === nhid
                //   );
                //   single_nh_arr.push(single_nh);
                //   setsingle();
                //   function setsingle() {
                //     propsnew.singleNeighbor(single_nh_arr);
                //   }
                //   that.clearpolysingle();
                //   that.clearcitypolysingle();
                //   that.drawPolygon(single_nh_arr);
                //   that.setState({
                //     selectedNeighborhood: single_nh_arr,
                //   });
                //   setTimeout(function () {
                //     if (
                //       document.getElementById("single_main_top") !==
                //       null
                //     ) {
                //       document
                //         .getElementById("single_main_top")
                //         .scrollIntoView();
                //     }
                //   }, 500);
                // }
              );

              google.maps.event.addListener(
                bermudaTriangle,
                "dblclick",
                function (event) {
                  that.clearcitypolysingle();
                  let ids = this.id;
                  let currenttab = propsnew.checkRhptab();
                  if (currenttab === 1) {
                    //window.open(`/Neighborhood/?id=${ids}`, "_blank");
                  }
                  //Router.push('/DetailsNh');
                },
              );
            }
            // var infowindow = new google.maps.InfoWindow({
            //   size: new google.maps.Size(150, 50),
            // });

            this.nbermudaTriangle.push(bermudaTriangle);
            this.setState({
              fetchneighbor: this.boundarydatas,
            });
          }
        }
      });

      // var endTime = performance.now();
      // var elapsed3 = new Date().getTime();
    } else {
      this.setState({
        fetchhome: [],
      });
      this.setState({ loaderdispaly: "none" });
      this.setState({
        fetchneighbor: [],
      });
      this.props.neighbors([], "nh");
    }
    let that = this;

    // setTimeout(function () {
    //   that.props.neighbors(boundries_data);
    // }, 100);
    // if (lhpStr != "school") {
    //   this.get_homes(lhpStr); //call home function
    // }

    if (result.data.getnhmapneighborboundries.length > 0) {
      let filtercitydata = [];

      let resultdata = result.data.getnhmapneighborboundries;
      for (var i = 0; i < resultdata.length; i++) {
        neighborhood_names.push(resultdata[i].name);
        if (resultdata[i].postalcity_name == this.state.singlecityname) {
          filtercitydata.push(resultdata[i]);
        }
      }
      if (this.state.singlecityname !== "") {
        this.props.singleCity(filtercitydata);
      }
      this.setState({ neighborhood_names: neighborhood_names });
    }

    //get saved city
    this.get_saved_cities();
    this.saveneighbordata();
    //this.props.handletab(false);
    this.setState({ loaderdispaly: "none" });
    if (lhpStr === "school" || lhpStr === "all") {
    } else {
      this.clearschoolMarkers();
    }
  };
  callApiForRightside(limit, orderfield, lhpStr, zoom_level) {
    let currenttab = this.props.checkRhptab();

    const centerlat = parseFloat(this.map.state.map.getCenter().lat());
    const centerlang = parseFloat(this.map.state.map.getCenter().lng());
    const geocoder = new window.google.maps.Geocoder();

    const location = {
      lat: centerlat,
      lng: centerlang,
    };

    geocoder.geocode({ location: location }, (results, status) => {
      if (status === "OK") {
        if (results[0]) {
          let city = "";
          let state = "";
          let county = "";
          const addressComponents = results[0].address_components;

          addressComponents.forEach((component) => {
            if (component.types.includes("locality")) {
              city = component.long_name;
            } else if (
              component.types.includes("administrative_area_level_1")
            ) {
              state = component.short_name;
            } else if (
              component.types.includes("administrative_area_level_2")
            ) {
              county = component.long_name.replace(/ County$/, "").trim();
            }

            if (city != "") {
              const fullCityName = city + ", " + state;

              this.getCitybaseData(
                city,
                limit,
                orderfield,
                lhpStr,
                zoom_level,
                fullCityName,
              );
            }
            if (county != "") {
              const fullCountyname = county.replace(/\s+/g, "-");
              this.getCityTabData(
                limit,
                orderfield,
                lhpStr,
                zoom_level,
                county,
                fullCountyname,
              );
            }
          });
        }
      }
    });
  }
  getCityTabData = (
    limit,
    orderfield,
    lhpStr,
    zoom_level,
    county,
    fullCountyname,
  ) => {
    let bounds = null;
    if (this.map && this.map.state && this.map.state.map && typeof this.map.state.map.getBounds === 'function') {
      try {
        bounds = this.map.state.map.getBounds();
      } catch (error) {
        console.error('Error getting map bounds:', error);
      }
    }
    this.props.handletab(true);
    if (bounds) {
      // let north = bounds.getNorthEast().lat();
      // let east = bounds.getNorthEast().lng();
      // let south = bounds.getSouthWest().lat();
      // let west = bounds.getSouthWest().lng();
      // let northEast;
      // let northWest;
      // let southEast;
      // let southWest;

      // let logindata = JSON.parse(localStorage.getItem("auth_query"));

      // localStorage.setItem(
      //   "searchlatuser",
      //   this.map.state.map.getCenter().lat()
      // );
      // localStorage.setItem(
      //   "searchlanguser",
      //   this.map.state.map.getCenter().lng()
      // );
      // localStorage.setItem("searchzoomuser", zoom_level);

      // northEast = new google.maps.LatLng(north, east);
      // northWest = new google.maps.LatLng(north, west);
      // southEast = new google.maps.LatLng(south, east);
      // southWest = new google.maps.LatLng(south, west);

      // var finallatlng =
      //   "(" +
      //   northWest.lat().toFixed(6) +
      //   " " +
      //   northWest.lng().toFixed(6) +
      //   "," +
      //   southWest.lat().toFixed(6) +
      //   " " +
      //   southWest.lng().toFixed(6) +
      //   "," +
      //   southEast.lat().toFixed(6) +
      //   " " +
      //   southEast.lng().toFixed(6) +
      //   "," +
      //   northEast.lat().toFixed(6) +
      //   " " +
      //   northEast.lng().toFixed(6) +
      //   "," +
      //   northWest.lat().toFixed(6) +
      //   " " +
      //   northWest.lng().toFixed(6) +
      //   ")";

      // let propsnew = this.props;

      let getdata;
      let boundries_data = [];
      if (lhpStr === "personal") {
        getdata = {
          start: 0,
          limit: 15,
          orderBy: getOrderofCity(orderfield),
          order:
            lhpStr === "medianprice" ||
            lhpStr === "value" ||
            lhpStr === "appreciation"
              ? "ASC"
              : "DESC",
          fields: [
            {
              name: "county_name",
              value: county,
              operator: "=",
            },
            {
              name: "postalcity_name",
              value: "",
              operator: "!=",
            },
          ],
          userId: "cityranking",
        };
        //this.saveneighbordata();
      } else if (lhpStr !== "personal") {
        getdata = {
          start: 0,
          limit: 15,
          orderBy: getOrderofCity(orderfield),
          order:
            lhpStr === "medianprice" ||
            lhpStr === "value" ||
            lhpStr === "appreciation"
              ? "ASC"
              : "DESC",
          fields: [
            {
              name: "county_name",
              value: county,
              operator: "=",
            },
            {
              name: "postalcity_name",
              value: "",
              operator: "!=",
            },
          ],
          userId: "cityranking",
        };
        // this.saveneighbordata();
      }
      getDetailsNhboundrieslist(getdata)
        .then((result) => {
          let that = this;
          if (lhpStr === "personal") {
            let neighborhood = result.data.getDetailsNhBoundries;

            function comparePersonalNpi(a, b) {
              let comparison = 0;
              if (a.personalNpi > b.personalNpi) {
                comparison = -1;
              } else if (a.personalNpi < b.personalNpi) {
                comparison = 1;
              }
              return comparison;
            }

            neighborhood.sort(comparePersonalNpi);
            // this.props.neighbors(neighborhood);
            boundries_data = neighborhood;
            if (boundries_data.length > 0) {
              this.props.centercountyname(county, fullCountyname);
            }
          }

          /* NEW PERSONAL CALCULATION WRAP */

          if (
            result.data.getDetailsNhBoundries.length > 0 &&
            lhpStr !== "personal"
          ) {
            boundries_data = result.data.getDetailsNhBoundries;
          }

          setTimeout(function () {
            that.props.neighbors(boundries_data, "city");
            that.props.centercountyname(county, fullCountyname);
            // that.setState({ fetchneighborright: boundries_data });
            // that.props.handletab(false);
          }, 100);
          // if (lhpStr != "school") {
          //   this.get_homes(lhpStr); //call home function
          // }
          setTimeout(function () {
            that.props.handletab(false);
          }, 500);
        })

        .catch((error) => {
          this.props.neighbors([], "city");
          this.props.handletab(false);
        });
    }
  };
  getCitybaseData = (
    city,
    limit,
    orderfield,
    lhpStr,
    zoom_level,
    fullCityName,
  ) => {
    let getdata;
    let boundries_data = [];
    if (lhpStr === "personal") {
      getdata = {
        start: 0,
        limit: 15,
        orderBy: orderfield,
        order: "postalcity_name",
        fields: [
          {
            name: "postalcity_name",
            value: city,
            operator: "=",
          },
        ],
        userid: "",
        userdata: localStorage.getItem("globaluserid"),
        schools:
          (this.props.schoolbar_val === 0 ? 50 : this.props.schoolbar_val) / 10,
        safety:
          (this.props.crimebar_val === 0 ? 50 : this.props.crimebar_val) / 10,
        walkability:
          (this.props.walkbar_val === 0 ? 50 : this.props.walkbar_val) / 10,
        publicspaces:
          (this.props.townbar_val === 0 ? 50 : this.props.townbar_val) / 10,
        curbAppeal:
          (this.props.curbbar_val === 0 ? 50 : this.props.curbbar_val) / 10,
        valueindex: this.props.valuebar_val / 10,
        minprice: this.props.pricemin_val,
        maxprice: this.props.pricemax_val,
        current_tab: "citybasedata",
        zoomLevel: zoom_level,
      };
      //this.saveneighbordata();
    } else if (lhpStr !== "personal") {
      getdata = {
        start: 0,
        limit: 15,
        orderBy: orderfield,
        order: "postalcity_name",
        fields: [
          {
            name: "postalcity_name",
            value: city,
            operator: "=",
          },
        ],
        userid: "",
        userdata: localStorage.getItem("globaluserid"),
        schools: this.props.schoolbar_val / 10,
        safety: this.props.crimebar_val / 10,
        walkability: this.props.walkbar_val / 10,
        publicspaces: this.props.townbar_val / 10,
        curbAppeal: this.props.curbbar_val / 10,
        valueindex: this.props.valuebar_val / 10,
        minprice: this.props.pricemin_val,
        maxprice: this.props.pricemax_val,
        current_tab: "citybasedata",
        zoomLevel: zoom_level,
      };
      // this.saveneighbordata();
    }
    getnhmapneighborboundrieslist(getdata)
      .then((result) => {
        let that = this;
        if (lhpStr === "personal") {
          let neighborhood = result.data.getnhmapneighborboundries;

          function comparePersonalNpi(a, b) {
            let comparison = 0;
            if (a.personalNpi > b.personalNpi) {
              comparison = -1;
            } else if (a.personalNpi < b.personalNpi) {
              comparison = 1;
            }
            return comparison;
          }

          neighborhood.sort(comparePersonalNpi);
          // this.props.neighbors(neighborhood);
          boundries_data = neighborhood;
          this.setState({ fetchneighborright: boundries_data });
          if (neighborhood && neighborhood.length > 0) {
            const postalcityfullname = neighborhood[0].cityfullname;
            this.props.centercityname(fullCityName, postalcityfullname);
          }
        }

        /* NEW PERSONAL CALCULATION WRAP */

        if (
          result.data.getnhmapneighborboundries.length > 0 &&
          lhpStr !== "personal"
        ) {
          boundries_data = result.data.getnhmapneighborboundries;
          this.setState({ fetchneighborright: boundries_data });
          if (boundries_data && boundries_data.length > 0) {
            const postalcityfullname = boundries_data[0].cityfullname;
            this.props.centercityname(fullCityName, postalcityfullname);
          }
        }

        setTimeout(function () {
          that.props.neighbors(boundries_data, "nh");
          // that.props.handletab(false);
        }, 100);
        // if (lhpStr != "school") {
        //   this.get_homes(lhpStr); //call home function
        // }
        setTimeout(function () {
          that.props.handletab(false);
        }, 500);
      })

      .catch((error) => {
        this.props.neighbors([], "nh");
        this.props.handletab(false);
      });
  };
  updateArrayObjects = (arr1, arr2) => {
    const arr1Map = new Map();
    arr1.forEach((item) => arr1Map.set(item.id, item));

    // Log initial state of input arrays

    // Iterate over arr2 and directly modify each item by reference
    arr2.forEach((item) => {
      const matchedItem = arr1Map.get(item.id);

      // Log matched items to see what's being processed

      if (matchedItem) {
        Object.keys(item).forEach((key) => {
          // Update if the value in arr2 is null or undefined; skip if it's already set
          if (item[key] === null || item[key] === undefined) {
            item[key] = matchedItem[key];
          }
        });
      }
    });
  };
  // renderPolygonsInChunks = (data, index, zoom_level, lhpStr) => {
  //   let boundries_data = data;
  //   const chunkSize = 25; // Set the size of each chunk
  //   const endIndex = index + chunkSize;
  //   const chunk = boundries_data.slice(index, endIndex); // Get the current chunk to process
  //   let bermudaTriangle;
  //   // Process each polygon in the current chunk
  //   chunk.forEach((item) => {
  //     if (item.geometry_cords) {
  //       let displaykey = process.env.NEXT_PUBLIC_DISPLAY_DATA;
  //       if (item != undefined && item.geometry_cords) {
  //         if (!this.polygon_points.includes(item.id)) {
  //           this.polygon_points.push(item.id);
  //           // let averagescore =
  //           //   (item.primaryschoolscore +
  //           //     item.middleschoolscore +
  //           //     item.highschoolscore) /
  //           //   3;
  //           // let finalavgscore = (averagescore / 10).toFixed(1);

  //           this.n_id = item.id;

  //           this.fetchid.push(item.id);

  //           let boundry_data = JSON.parse("[" + item.geometry_cords + "]");
  //           // this.map.state.map.data.add({
  //           //   geometry: new google.maps.Data.Polygon([boundry_data])
  //           // });
  //           bermudaTriangle = new google.maps.Polygon({
  //             paths: boundry_data,
  //             strokeColor:
  //               item.savedneighborhoodbyuser === "1"
  //                 ? "#238528"
  //                 : item.summary != null && item.summary != ""
  //                 ? "rgb(27, 87, 165,0.7)"
  //                 : "#fff",
  //             strokeWeight:
  //               item.savedneighborhoodbyuser === "1"
  //                 ? 4
  //                 : item.summary != null && item.summary != ""
  //                 ? 2
  //                 : 1,
  //             fillOpacity: zoom_level > 14 ? 0.25 : 0.75,
  //             zIndex:
  //               item.savedneighborhoodbyuser === "1" ||
  //               (item.summary != null && item.summary != "")
  //                 ? 3
  //                 : 2,
  //             id: item.id,
  //             name: item.name,
  //             walkscore: item.walkability,
  //             map: this.map.state.map,
  //           });
  //           if (item[displaykey] === 1) {
  //             if (lhpStr === "npi") {
  //               bermudaTriangle.setOptions({
  //                 fillColor: get_npi_color(Math.round(item.npi)),
  //                 //fillOpacity: zoom_level > 14 ? 0.25 : 0.75,
  //               });
  //             }

  //             if (lhpStr === "personal") {
  //               bermudaTriangle.setOptions({
  //                 fillColor: get_npi_color(item.personalNpi),
  //               });
  //             }

  //             if (lhpStr === "value") {
  //               bermudaTriangle.setOptions({
  //                 fillColor: get_nvi_color(item.value),
  //                 fillOpacity:
  //                   get_nvi_color(item.value) === "#FFFFFF"
  //                     ? 0.0
  //                     : zoom_level > 14
  //                     ? 0.25
  //                     : 0.75,
  //               });
  //             }

  //             if (lhpStr === "price") {
  //               bermudaTriangle.setOptions({
  //                 fillColor: get_price_color(Math.round(item.medianprice)),
  //                 fillOpacity:
  //                   get_price_color(Math.round(item.medianprice)) === "#FFFFFF"
  //                     ? 0.0
  //                     : zoom_level > 14
  //                     ? 0.25
  //                     : 0.75,
  //               });
  //             }

  //             if (lhpStr === "school") {
  //               bermudaTriangle.setOptions({
  //                 fillColor: "#fff",
  //                 fillOpacity: 0.0,
  //                 /* strokeColor: '#8B0000'*/
  //               });
  //             }
  //             if (lhpStr === "all") {
  //               if (item.school && parseFloat(item.school) > 0) {
  //                 bermudaTriangle.setOptions({
  //                   fillColor: get_school_color(item.school),
  //                 });
  //               } else {
  //                 bermudaTriangle.setOptions({
  //                   fillColor: "#fff",
  //                   fillOpacity: 0.0,
  //                   /* strokeColor: '#8B0000'*/
  //                 });
  //               }
  //             }

  //             if (lhpStr === "crime") {
  //               bermudaTriangle.setOptions({
  //                 fillColor: get_crime_color(item.crime),
  //               });
  //             }
  //             if (lhpStr === "walkability") {
  //               bermudaTriangle.setOptions({
  //                 fillColor: get_walk_color(item.walkability),
  //               });
  //             }
  //             if (lhpStr === "dom") {
  //               bermudaTriangle.setOptions({
  //                 fillColor: get_dom_color(item.dom),
  //                 fillOpacity:
  //                   get_dom_color(Math.round(item.dom)) === "#FFFFFF"
  //                     ? 0.0
  //                     : zoom_level > 14
  //                     ? 0.25
  //                     : 0.75,
  //               });
  //             }
  //             if (lhpStr === "appreciation") {
  //               bermudaTriangle.setOptions({
  //                 fillColor: get_appreciation_color(item.appreciation),
  //                 fillOpacity:
  //                   get_appreciation_color(Math.round(item.appreciation)) ===
  //                   "#FFFFFF"
  //                     ? 0.0
  //                     : zoom_level > 14
  //                     ? 0.25
  //                     : 0.75,
  //               });
  //             }

  //             if (lhpStr === "publicspaces") {
  //               bermudaTriangle.setOptions({
  //                 fillColor: get_all_amenties_color(item.publicspaces),
  //                 fillOpacity:
  //                   get_all_amenties_color(Math.round(item.publicspaces)) ===
  //                   "#FFFFFF"
  //                     ? 0.0
  //                     : zoom_level > 14
  //                     ? 0.25
  //                     : 0.75,
  //               });
  //             }
  //             if (lhpStr === "curb") {
  //               bermudaTriangle.setOptions({
  //                 fillColor: get_all_amenties_color(item.curb),
  //                 fillOpacity:
  //                   get_all_amenties_color(Math.round(item.curb)) === "#FFFFFF"
  //                     ? 0.0
  //                     : zoom_level > 14
  //                     ? 0.25
  //                     : 0.75,
  //               });
  //             }
  //             if (lhpStr === "others") {
  //               bermudaTriangle.setOptions({
  //                 fillColor: get_all_amenties_color(item.others),
  //                 fillOpacity:
  //                   get_all_amenties_color(Math.round(item.others)) ===
  //                   "#FFFFFF"
  //                     ? 0.0
  //                     : zoom_level > 14
  //                     ? 0.25
  //                     : 0.75,
  //               });
  //             }
  //             if (lhpStr === "amenities") {
  //               if (item.amenities > 0) {
  //                 bermudaTriangle.setOptions({
  //                   fillColor: get_all_amenties_color(item.amenities),
  //                   fillOpacity:
  //                     get_all_amenties_color(Math.round(item.amenities)) ===
  //                     "#FFFFFF"
  //                       ? 0.0
  //                       : zoom_level > 14
  //                       ? 0.25
  //                       : 0.75,
  //                 });
  //               } else {
  //                 bermudaTriangle.setOptions({
  //                   fillColor: get_walk_color(item.walkability),
  //                 });
  //               }
  //             }
  //           } else {
  //             bermudaTriangle.setOptions({
  //               fillColor: "#fff",
  //               fillOpacity: 0.0,
  //             });
  //           }

  //           let propsnew = this.props;
  //           let that = this;
  //           google.maps.event.addListener(
  //             bermudaTriangle,
  //             "mouseover",
  //             function (event) {
  //               that.clearpolysingle();
  //               that.clearhoveredmarkers();
  //               !that.state.isMobile &&
  //                 that.sethoveredmarker(
  //                   item.latitude,
  //                   item.longitude,
  //                   item.nhfullname
  //                 );

  //               //that.clearcitypolysingle();
  //               if (lhpStr === "school") {
  //                 this.setOptions({
  //                   strokeWeight: 4,
  //                   opacity: 0,
  //                   zIndex: 4,
  //                   strokeColor:
  //                     item.savedneighborhoodbyuser === "1"
  //                       ? "#238528"
  //                       : "#c02e26",
  //                   // item.savedneighborhoodbyuser === "1"
  //                   //   ? "#c02e26"
  //                   //   : item.summary != null && item.summary != ""
  //                   //   ? "rgb(27, 87, 165,0.7)"
  //                   //   : "#c02e26",
  //                 });
  //               } else {
  //                 this.setOptions({
  //                   strokeWeight: 4,
  //                   opacity: 0,
  //                   zIndex: 4,
  //                   strokeColor:
  //                     item.savedneighborhoodbyuser === "1"
  //                       ? "#238528"
  //                       : "#c02e26",
  //                 });
  //               }
  //               let nhid = this.id;
  //               let single_nh_arr = [];
  //               let single_nh = boundries_data.find((o) => o.id === nhid);
  //               single_nh_arr.push(single_nh);

  //               if (single_nh_arr.length > 0) {
  //                 setsingle();
  //                 function setsingle() {
  //                   propsnew.singleNeighbor(single_nh_arr);
  //                 }
  //                 // document.getElementById(
  //                 //   "single_main_top"
  //                 // ).style.height = "auto";
  //                 // document.getElementById(
  //                 //   "single_main_top"
  //                 // ).style.display = "block";
  //                 // document.getElementById(
  //                 //   "single_main_top"
  //                 // ).style.overflow = "auto";
  //                 //that.drawPolygon(single_nh_arr);
  //                 that.setState({
  //                   selectedNeighborhood: single_nh_arr,
  //                 });
  //                 var element = document.getElementById("single_main_top");
  //                 if (element) {
  //                   element.classList.add("open");
  //                   // setTimeout(function () {
  //                   //   element.scrollIntoView({ behavior: "smooth" });
  //                   // }, 500);
  //                 }
  //               }
  //             }
  //           );

  //           google.maps.event.addListener(
  //             bermudaTriangle,
  //             "mouseout",
  //             function (event) {
  //               if (lhpStr === "school") {
  //                 this.setOptions({
  //                   strokeWeight:
  //                     item.savedneighborhoodbyuser === "1"
  //                       ? 4
  //                       : item.summary != null && item.summary != ""
  //                       ? 2
  //                       : 1,
  //                   opacity: 0,
  //                   zIndex:
  //                     item.savedneighborhoodbyuser === "1" ||
  //                     (item.summary != null && item.summary != "")
  //                       ? 3
  //                       : 2,
  //                   strokeColor:
  //                     item.savedneighborhoodbyuser === "1"
  //                       ? "#238528"
  //                       : item.summary != null && item.summary != ""
  //                       ? "rgb(27, 87, 165,0.7)"
  //                       : "#FFFFFF",
  //                 });
  //               } else {
  //                 this.setOptions({
  //                   strokeWeight:
  //                     item.savedneighborhoodbyuser === "1"
  //                       ? 4
  //                       : item.summary != null && item.summary != ""
  //                       ? 2
  //                       : 1,
  //                   opacity: 0,
  //                   zIndex:
  //                     item.savedneighborhoodbyuser === "1" ||
  //                     (item.summary != null && item.summary != "")
  //                       ? 3
  //                       : 2,
  //                   strokeColor:
  //                     item.savedneighborhoodbyuser === "1"
  //                       ? "#238528"
  //                       : item.summary != null && item.summary != ""
  //                       ? "rgb(27, 87, 165,0.7)"
  //                       : "#FFFFFF",
  //                 });
  //               }

  //               // that.clearpolysingle();
  //               // that.clearcitypolysingle();
  //               // propsnew.singleNeighbor([]);
  //               // that.clearpolysingle();
  //               // that.clearcitypolysingle();
  //               // document.getElementById(
  //               //   "single_main_top"
  //               // ).style.display = "none";
  //             }
  //           );
  //           if (item[displaykey] === 1) {
  //             google.maps.event.addListener(
  //               bermudaTriangle,
  //               "click",
  //               function (event) {
  //                 that.clearcitypolysingle();

  //                 let currenttab = propsnew.checkRhptab();
  //                 let ids = this.id;
  //                 if (currenttab === 1 && !that.state.isMobile) {
  //                   window.open(`/Neighborhood/${item.nhfullname}`, "_blank");
  //                 } else {
  //                   propsnew.singleClick();
  //                 }

  //                 let single_nh_arr = [];
  //                 let single_nh = boundries_data.find((o) => o.id === ids);
  //                 single_nh_arr.push(single_nh);
  //                 if (single_nh_arr.length > 0) {
  //                   setsingle();
  //                   function setsingle() {
  //                     propsnew.singleNeighbor(single_nh_arr);
  //                   }

  //                   that.setState(
  //                     {
  //                       selectedNeighborhood: single_nh_arr,
  //                       selectednhid: ids,
  //                       searchednh: single_nh_arr,
  //                     },
  //                     () => {
  //                       that.clearpolysingle();
  //                     }
  //                   );
  //                   that.drawPolygon(single_nh_arr);
  //                   var element = document.getElementById("single_main_top");
  //                   if (element) {
  //                     element.classList.add("open");
  //                     setTimeout(function () {
  //                       element.scrollIntoView({
  //                         behavior: "smooth",
  //                       });
  //                     }, 500);
  //                   }
  //                 }

  //                 //Router.push('/DetailsNh');
  //               }

  //               // function (event) {
  //               //   let nhid = this.id;
  //               //   let single_nh_arr = [];
  //               //   let single_nh = boundries_data.find(
  //               //     (o) => o.id === nhid
  //               //   );
  //               //   single_nh_arr.push(single_nh);
  //               //   setsingle();
  //               //   function setsingle() {
  //               //     propsnew.singleNeighbor(single_nh_arr);
  //               //   }
  //               //   that.clearpolysingle();
  //               //   that.clearcitypolysingle();
  //               //   that.drawPolygon(single_nh_arr);
  //               //   that.setState({
  //               //     selectedNeighborhood: single_nh_arr,
  //               //   });
  //               //   setTimeout(function () {
  //               //     if (
  //               //       document.getElementById("single_main_top") !==
  //               //       null
  //               //     ) {
  //               //       document
  //               //         .getElementById("single_main_top")
  //               //         .scrollIntoView();
  //               //     }
  //               //   }, 500);
  //               // }
  //             );

  //             google.maps.event.addListener(
  //               bermudaTriangle,
  //               "dblclick",
  //               function (event) {
  //                 that.clearcitypolysingle();
  //                 let ids = this.id;
  //                 let currenttab = propsnew.checkRhptab();
  //                 if (currenttab === 1) {
  //                   //window.open(`/Neighborhood/?id=${ids}`, "_blank");
  //                 }
  //                 //Router.push('/DetailsNh');
  //               }
  //             );
  //           }
  //           var infowindow = new google.maps.InfoWindow({
  //             size: new google.maps.Size(150, 50),
  //           });

  //           this.nbermudaTriangle.push(bermudaTriangle);
  //         }
  //       }
  //     }
  //   });

  //   if (endIndex < data.length) {
  //     // Schedule next chunk
  //     setTimeout(
  //       () => this.renderPolygonsInChunks(data, endIndex, zoom_level, lhpStr),
  //       0
  //     );
  //   } else {
  //     this.setState({ loaderdispaly: "none" });
  //     // Finalization code if needed after all chunks are processed
  //   }
  // };

  get_saved_cities = () => {
    this.savedcity = [];
    const getdatas = {
      start: 0,
      limit: 100,
      orderBy: "id",
      order: "ASC",
      fields: [
        {
          name: "userId",
          value: localStorage.getItem("globaluserid"),
          operator: "=",
        },
        {
          name: "savedStatus",
          value: 1,
          operator: "=",
        },
      ],
    };

    getAllsavedncitybyuserList(getdatas)
      .then((result) => {
        this.props.savedcity(this.savedcity);
        result.data.getsavedcitybyuser &&
          result.data.getsavedcitybyuser.map((item2, index2) => {
            this.savedcity.push(item2);
            this.props.savedcity(this.savedcity);
            // setTimeout(() => {
            //   this.check_city_click(
            //     item2.postalcity_name,
            //     item2.state_name,
            //     "save"
            //   );
            // }, 200);
          });
        this.props.savedcity(this.savedcity);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  onseefulllistclick = () => {
    const centerlat = parseFloat(this.map.state.map.getCenter().lat());
    const centerlang = parseFloat(this.map.state.map.getCenter().lng());
    const geocoder = new window.google.maps.Geocoder();

    const location = {
      lat: centerlat,
      lng: centerlang,
    };
    geocoder.geocode({ location: location }, (results, status) => {
      if (status === "OK") {
        if (results[0]) {
          const addressComponents = results[0].address_components;
          let city = "";
          let state = "";

          addressComponents.forEach((component) => {
            if (component.types.includes("locality")) {
              city = component.long_name;
            } else if (
              component.types.includes("administrative_area_level_1")
            ) {
              state = component.short_name;
            }
          });

          if (city && state) {
            const win = window.open(
              `/Nhranking/best-overall/${formattedCityName(city)}-${state}`,
              "_blank",
            );
            if (!win) {
              alert("Please allow pop-ups for this website.");
            }
          } else {
            alert("No city found. Please drag the map and try again");
          }
        } else {
          alert("Something went wrong. Please drag the map and try again");
        }
      } else {
        console.error("Geocoder failed due to: " + status);
      }
    });
  };

  // Helper method to safely get the map instance
  getMapInstance = () => {
    if (this.map && this.map.state && this.map.state.map) {
      return this.map.state.map;
    }
    return null;
  };

  bounds_in_view_port = () => {
    let boundsInViewport = true;
    if (
      this.map &&
      this.map.state &&
      this.map.state.map != null &&
      this.map.state.map.getBounds &&
      typeof this.map.state.map.getBounds === 'function'
    ) {
      try {
        const mapBounds = this.map.state.map.getBounds();
        const { north, south, east, west } = this.bounds || {};

        // Validate bounds values
        if (!north || !south || !east || !west) {
          console.warn('Invalid bounds values');
          return true;
        }

        const rectangleBounds = new google.maps.LatLngBounds(
          new google.maps.LatLng(south, west),
          new google.maps.LatLng(north, east),
        );

        if (mapBounds && rectangleBounds && mapBounds.intersects) {
          boundsInViewport = mapBounds.intersects(rectangleBounds);
        }
      } catch (error) {
        console.error('Error checking bounds:', error);
        return true;
      }
    }
    return boundsInViewport;
  };

  render() {
    return (
      this.props.addressInfo != undefined && (
        <div>
          <Grid>
            <Grid.Row style={{ padding: 0 }}>
              <Grid.Column id="map" style={{ paddingLeft: 0, paddingRight: 0 }}>
                <div>
                  <GoogleMapExample
                    ref={(c) => {
                      this.map = c;
                    }}
                    //zoom={this.props.zoom}
                    data={this}
                    onClick={this.handleClick}
                    onDragEnd={this.onDragChanged}
                    onZoomChanged={this.onZoomChanged}
                    containerElement={
                      <div
                        style={{
                          height: this.props.addressInfo.state.mapHeight,
                        }}
                      />
                    }
                    mapElement={<div style={{ height: "100%" }} />}
                  />
                  {this.props.addressInfo.state.mapHeight > 10 && (
                    <Button
                      className="map-filter-home"
                      onClick={() => this.props.addressInfo.filterHome()}
                      style={{
                        position: "absolute",
                        right: 70,
                        bottom: 6,
                        height: "32px",
                        padding: "0 15px 0",
                      }}
                    >
                      Filter Homes
                    </Button>
                  )}
                  {this.props.addressInfo.state.mapHeight > 0 && (
                    <div
                      className={
                        this.state.isMobile
                          ? this.props.singleneighbordata.length !== 0
                            ? "legend_main_after"
                            : "legend_main"
                          : "legend_main"
                      }
                    >
                      <div className="nh_by">
                        {/* <span className="nh_by_main">Neighborhood by:</span> */}
                        <div className="nh_by_sub_txt">
                          {this.state.selectedtab}
                        </div>
                      </div>

                      <div className="legend_bar">
                        <div className="legend_img">
                          <img
                            src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/color_legend.png`}
                            alt="color schema"
                            title="color schema"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {this.state.is_display_zoom_msg && (
                    <p className="zoom_msg">Zoom in to see neighborhoods</p>
                  )}
                  {!this.bounds_in_view_port() && (
                    <div className="alert_popup">
                      <div className="popup_box">
                        <span className="popup_txt large_pop_text">
                          Houseberry will expand here soon!
                        </span>
                        <span className="popup_txt">
                          View in the{" "}
                          <span
                            className="txt_link"
                            onClick={() =>
                              this.refreshMap("San Francisco, CA, USA", true)
                            }
                          >
                            Bay Area
                          </span>{" "}
                          today
                        </span>
                      </div>
                    </div>
                  )}
                </div>

                <div
                  id="loadingDiv"
                  className="loading"
                  style={{ display: this.state.loaderdispaly }}
                >
                  <img
                    src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/loading.gif`}
                    alt="Loading"
                    title="Loader"
                  />
                </div>
                <div
                  className="school_popup school_main_popup"
                  id="school_right_popup"
                  style={{ display: this.state.popupdisplay }}
                >
                  {/* {this.state.isMobile && ( */}
                  <div
                    className={
                      !this.state.isMobile
                        ? `school-data-close-desktop school-data-close`
                        : `school-data-close`
                    }
                  >
                    <VscChromeClose
                      onClick={() => this.setState({ popupdisplay: "none" })}
                      size={this.state.isMobile ? 18 : 25}
                    />
                  </div>
                  {/* )} */}
                  <div className="left_part">
                    {" "}
                    <div className="school_name">
                      {" "}
                      {this.state.schoolgreatschoolurl !== "" &&
                      this.state.schoolgreatschoolurl !== null ? (
                        <a
                          href={this.state.schoolgreatschoolurl}
                          target="_blank"
                        >
                          <strong>{this.state.schoolpopupname}</strong>
                        </a>
                      ) : (
                        <strong>{this.state.schoolpopupname}</strong>
                      )}
                    </div>{" "}
                    <div className="school_data">
                      {" "}
                      <div className="school_level">
                        {this.state.schoolpopuptype}
                      </div>{" "}
                      <div className="school_grade">
                        Grades: {this.state.schoolpopupgrade || "-"}
                      </div>{" "}
                      <div className="school_student">
                        No of students: {this.state.schoolstudent || "-"}
                      </div>{" "}
                      <div className="school_teacher">
                        Student/Teacher: {this.state.schoolstudentratio || "-"}
                      </div>{" "}
                      {this.state.schoolwebsite == "No Data" ||
                      this.state.schoolwebsite == "NoData" ? (
                        <div
                          className="school_website"
                          style={{ visibility: "hidden", minHeight: "36px" }}
                        >
                          Webiste:{" "}
                        </div>
                      ) : (
                        <div
                          className="school_website"
                          style={{ minHeight: "36px" }}
                        >
                          Webiste:{" "}
                          {this.state.schoolwebsite ? (
                            <a
                              href={this.state.schoolwebsite}
                              target="_blank"
                              title="Click here to go school"
                            >
                              {this.state.schoolwebsite}
                            </a>
                          ) : (
                            "-"
                          )}
                        </div>
                      )}
                    </div>{" "}
                  </div>{" "}
                  <div className="right_part">
                    {" "}
                    <div className="rating_txt_popup">Rating</div>{" "}
                    {/* <div className="rating_num_popup">
                      {this.state.schoolpopuprating+"/10" || "-"}
                    </div>{" "} */}
                    <div class="label__rating_popup">
                      <a
                        href={this.state.schoolgreatschoolurl}
                        // class={`rs-gs-rating circle-rating--large circle-rating--blue ${
                        //   this.state.schoolpopuprating <= 0
                        //     ? "circle-rating--0"
                        //     : this.state.schoolpopuprating > 6
                        //     ? "circle-rating--9"
                        //     : "circle-rating--5"
                        // }`}
                        className="rs-gs-rating circle-rating--large circle-rating--blue"
                        target="_blank"
                      >
                        {this.state.schoolpopuprating
                          ? Number(
                              ((this.state.schoolpopuprating / 10) * 5).toFixed(
                                2,
                              ),
                            ).toFixed(1)
                          : "NA"}
                        {this.state.schoolpopuprating && (
                          <span class="denominator">/5</span>
                        )}
                      </a>
                    </div>
                  </div>{" "}
                  <div className="school-popup">
                    <div className="great-school">
                      <p className="data_provided">
                        {/* Data Provided by{" "}
                        <a
                          href="https://www.greatschools.org"
                          target="_blank"
                          rel="nofollow"
                          title="Great School.org"
                        >
                          GreatSchools.org{" "}
                        </a>
                        &copy; 2023 All Rights Reserved */}
                        Houseberry School Score Data from CA Dept. of Education
                      </p>
                      {/* <a
                        href="https://www.greatschools.org"
                        rel="nofollow"
                        target="_blank"
                        title="Great School.org"
                      >
                        <img
                          width="50px"
                          src={
                            process.env.NEXT_PUBLIC_CDN_ID +
                            "static/images/great-school-white.png"
                          }
                          title="school"
                          alt="school icon"
                        />
                      </a> */}
                    </div>
                  </div>
                </div>
                {!this.state.isMobile &&
                  this.state.selectedNeighborhood &&
                  this.state.selectedNeighborhood.length > 0 &&
                  this.state.selectedNeighborhood.map((item, index) => {
                    if (item && item !== undefined) {
                      let npiscore = 0;
                      let otherscore = 0;
                      let curbscore = 0;
                      let communityscore = 0;
                      let valuescore = 0;
                      let personalscore = 0;
                      let crimescore = 0;
                      let schoolscore = 0;
                      let walkabilityscore = 0;
                      let townctrscore = 0;
                      let publicscore = 0;
                      let walkablesteetscore = 0;
                      let amenitiesscore = 0;
                      let valuedata = 0;
                      let displayname = "Overall score";
                      let displayvalue = 0;

                      npiscore = item.npi;
                      if (item.npi) {
                        npiscore = Number(
                          ((item.npi / 100) * 5).toFixed(2),
                        ).toFixed(1);
                      } else {
                        npiscore = 0;
                      }
                      schoolscore = item.school;
                      schoolscore = Number(
                        ((schoolscore / 10) * 5).toFixed(2),
                      ).toFixed(1);

                      //OTHERS SCORE
                      if (item.others <= 0.9) {
                        otherscore = item.others;
                      } else {
                        otherscore = item.others;
                      }

                      //CURB SCORE
                      if (item.curb) {
                        curbscore = item.curb;
                      } else {
                        curbscore = "-";
                      }

                      //COMMUNITY SCORE
                      if (item.publicspaces <= 0.9) {
                        communityscore = item.publicspaces;
                      } else {
                        communityscore = item.publicspaces;
                      }

                      //VALUE SCORE
                      // if(item.value <= 0.9){
                      //   valuescore = item.value*10
                      // }else{
                      //   valuescore = item.value
                      // }

                      if (item.value) {
                        valuescore = parseInt(item.value);
                        valuedata = parseInt(item.value);
                        valuescore = "$" + humanFormat(valuescore);
                        valuescore = valuescore.replace(/-?\d+(\.\d+)?/g, (n) =>
                          Number(n).toFixed(0),
                        );
                        valuescore = valuescore.replace("-", "");
                        // valuescore = Number(
                        //   ((valuescore / 100) * 5).toFixed(2)
                        // ).toFixed(1);
                      } else {
                        valuescore = "-";
                        valuedata = "-";
                      }

                      //PERSONALSCORE

                      if (item.personalNpi != "" || item.personalNpi != 0) {
                        personalscore = item.personalNpi;
                        personalscore = Number(
                          ((item.personalNpi / 100) * 5).toFixed(2),
                        ).toFixed(1);
                      } else {
                        personalscore = "-";
                      }

                      crimescore = item.crime;
                      crimescore = Number(
                        ((crimescore / 10) * 5).toFixed(2),
                      ).toFixed(1);

                      walkabilityscore = item.walkability;
                      walkabilityscore = Number(
                        ((walkabilityscore / 10) * 5).toFixed(2),
                      ).toFixed(1);

                      if (item.walkability > 0) {
                        townctrscore = Number(
                          ((item.walkability / 10) * 5).toFixed(2),
                        ).toFixed(1);
                      } else {
                        townctrscore = "-";
                      }

                      if (item.publicspaces > 0) {
                        publicscore = item.publicspaces;
                      } else {
                        publicscore = "-";
                      }

                      if (item.others > 0) {
                        walkablesteetscore = item.others;
                      } else {
                        walkablesteetscore = "-";
                      }
                      if (item.amenities > 0) {
                        amenitiesscore = item.amenities;
                      } else if (item.walkability > 0) {
                        amenitiesscore = Number(
                          ((item.walkability / 10) * 5).toFixed(2),
                        ).toFixed(1);
                      } else {
                        amenitiesscore = "-";
                      }

                      // else {
                      //   amenitiesscore = "-";
                      // }

                      let final_summary_index = "summary_" + item.id + index;

                      let final_summary = "";
                      if (item.summary && item.summary !== null) {
                        final_summary = item.summary;
                      } else if (item.nhsummary && item.nhsummary.length > 0) {
                        final_summary = item.nhsummary[0].summary;
                      }
                      let thumbanail = "";
                      if (item.imageurl && item.imageurl !== null) {
                        thumbanail = item.imageurl;
                      } else if (
                        item.neighborhoodImages &&
                        item.neighborhoodImages.length > 0 &&
                        item.neighborhoodImages[0].imageurl
                      ) {
                        thumbanail = item.neighborhoodImages[0].imageurl;
                      }
                      // if (item.thumbnailurl && item.thumbnailurl !== null) {
                      //   thumbanail = item.thumbnailurl;
                      // } else if (
                      //   item.neighborhoodImages &&
                      //   item.neighborhoodImages.length > 0 &&
                      //   item.neighborhoodImages[0].thumbnailurl
                      // ) {
                      //   thumbanail = item.neighborhoodImages[0].thumbnailurl;
                      // }
                      let displaykey = process.env.NEXT_PUBLIC_DISPLAY_DATA;

                      if (this.state.selectedtab === "Overall Score") {
                        displayname = "Overall Score";
                        displayvalue = npiscore + "/5";
                      } else if (this.state.selectedtab === "Personal") {
                        displayname = "Personal Score";
                        displayvalue = personalscore;
                      } else if (this.state.selectedtab === "School") {
                        displayname = "School Score";
                        displayvalue = schoolscore + "/5";
                      } else if (
                        this.state.selectedtab === "Elementary School"
                      ) {
                        displayname = "Elem. Score";
                        displayvalue =
                          Number(
                            ((item.primaryschoolscore / 10) * 5).toFixed(2),
                          ).toFixed(1) + "/5";
                      } else if (this.state.selectedtab === "Middle School") {
                        displayname = "Middle Score";
                        displayvalue =
                          Number(
                            ((item.middleschoolscore / 10) * 5).toFixed(2),
                          ).toFixed(1) + "/5";
                      } else if (this.state.selectedtab === "High School") {
                        displayname = "HS Score";
                        displayvalue =
                          Number(
                            ((item.highschoolscore / 10) * 5).toFixed(2),
                          ).toFixed(1) + "/5";
                      } else if (this.state.selectedtab === "Safety") {
                        displayname = "Safety Score";
                        displayvalue = crimescore + "/5";
                      } else if (this.state.selectedtab === "Amenities") {
                        displayname = "Amenities";
                        displayvalue = amenitiesscore + "/5";
                      } else if (this.state.selectedtab === "Near Merchants") {
                        displayname = "Near Mer.";
                        displayvalue = walkabilityscore + "/5";
                      } else if (this.state.selectedtab === "Public Spaces") {
                        displayname = "Public Spaces";
                        displayvalue = publicscore + "/5";
                      } else if (this.state.selectedtab === "Curb Appeal") {
                        displayname = "Curb Appeal";
                        displayvalue = curbscore + "/5";
                      } else if (this.state.selectedtab === "Price") {
                        displayname = "Price";
                        if (item.medianprice > 0) {
                          displayvalue =
                            "$" + Math.round(item.medianprice).toLocaleString();
                        } else {
                          displayvalue = "-";
                        }
                      } else if (this.state.selectedtab === "Value") {
                        displayname = "Value";
                        displayvalue = valuescore;
                        if (valuedata > 0) {
                          displayname = "Overval.";
                        } else if (valuedata < 0) {
                          displayname = "Underval.";
                        } else {
                          displayname = "Value";
                        }
                      } else if (this.state.selectedtab === "Appreciation") {
                        displayname = "Appreciation";
                        if (item.appreciation !== 0) {
                          displayvalue = Math.round(item.appreciation) + "%";
                        } else {
                          displayvalue = "-";
                        }
                      }
                      const nhname = item.label.split(",");
                      return (
                        <div
                          className="nh_popup home_popup_map"
                          style={{
                            pointerEvents:
                              this.state.searchednh.length > 0
                                ? "auto"
                                : "none", // Ensure the popup doesn't block events
                            zIndex: 5,
                          }}
                        >
                          <div
                            className={
                              !this.state.isMobile
                                ? `school-data-close-desktop school-data-close`
                                : `school-data-close`
                            }
                            style={{
                              pointerEvents: "auto", // Enable events for the close button
                            }}
                          >
                            <VscChromeClose
                              onClick={() =>
                                this.setState(
                                  { selectedNeighborhood: [] },
                                  () => {
                                    this.oncloseclearpolysingle();
                                  },
                                )
                              }
                            />
                          </div>
                          <Item
                            key={index}
                            style={{ margin: "0px 0px 0px 0px" }}
                          >
                            <Item.Content>
                              <Item.Description>
                                <div
                                  className="ui fluid image"
                                  style={{ height: "230px" }}
                                >
                                  {thumbanail != "" ? (
                                    <a
                                      href={`/Neighborhood/${item.nhfullname}`}
                                      className="nh_imgs"
                                      target="_blank"
                                    >
                                      <Item.Image
                                        className="nhpannel_img"
                                        src={thumbanail}
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src =
                                            process.env.NEXT_PUBLIC_CDN_ID +
                                            "static/images/defaultnhmap.jpg";
                                        }}
                                      />
                                    </a>
                                  ) : (
                                    <a
                                      href={`/Neighborhood/${item.nhfullname}`}
                                      className="nh_imgs"
                                      target="_blank"
                                    >
                                      <Item.Image
                                        className="nhpannel_img"
                                        src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/defaultnhmap.jpg`}
                                      />
                                    </a>
                                  )}
                                  <div
                                    style={{
                                      position: "absolute",
                                      bottom: "0px",
                                      width: "100%",
                                      height: "auto",
                                      color: "white",
                                    }}
                                  >
                                    <Link
                                      href={`/Neighborhood/${item.nhfullname}`}
                                      target="_blank"
                                      style={{ color: "#FFF" }}
                                    >
                                      {/* <a
                                        target="_blank"
                                        style={{ color: "#FFF" }}
                                      > */}
                                      <Grid
                                        style={{ padding: 10 }}
                                        className="nh_popup_bg"
                                      >
                                        <Grid.Column
                                          width={16}
                                          style={{
                                            textAlign: "right",
                                          }}
                                        >
                                          <Grid.Row>
                                            <span className="display_txt">
                                              <strong>
                                                {displayname}: {displayvalue}
                                              </strong>
                                            </span>
                                          </Grid.Row>
                                        </Grid.Column>
                                        <Grid.Column width={16}>
                                          <Grid.Row>
                                            <span className="home_price_main">
                                              <strong>{item.name}</strong>
                                            </span>
                                            <span className="popupCityname">
                                              {nhname[1] + ", " + nhname[2]}
                                            </span>
                                          </Grid.Row>
                                        </Grid.Column>
                                      </Grid>
                                      <Grid
                                        style={{ padding: 10 }}
                                        className="nh_popup_bg nh_popup_bg_btm"
                                      >
                                        <Grid.Column width={16}>
                                          <Grid.Row>
                                            <span className="nh_popup_description">
                                              {final_summary != "" ? (
                                                <>
                                                  {final_summary.length > 54 ? (
                                                    <>
                                                      {customdecodeURIComponent(
                                                        final_summary.substring(
                                                          0,
                                                          85,
                                                        ),
                                                      )}
                                                      <span
                                                        className="summarylessmore"
                                                        // onClick={(e) =>
                                                        //   this.handlesinglesummaryClick(
                                                        //     e,
                                                        //     final_summary_index
                                                        //   )
                                                        // }
                                                      >
                                                        {" "}
                                                        ...
                                                      </span>
                                                    </>
                                                  ) : (
                                                    ""
                                                  )}
                                                </>
                                              ) : (
                                                ""
                                              )}
                                            </span>
                                          </Grid.Row>
                                        </Grid.Column>
                                      </Grid>
                                      {/* </a> */}
                                    </Link>
                                  </div>
                                </div>
                              </Item.Description>
                            </Item.Content>
                          </Item>
                          {/* <div className="stackable" key={index} id="">
                            {item[displaykey] === 1 ? (
                              <Item
                                key={index}
                                style={{ position: "relative" }}
                              >
                                {thumbanail != "" ? (
                                  <a
                                    href={"/Neighborhood/?id=" + item.id}
                                    className="nh_imgs"
                                    target="_blank"
                                  >
                                    <Item.Image
                                      className="nhpannel_img"
                                      src={thumbanail}
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src =
                                          process.env.NEXT_PUBLIC_CDN_ID +
                                          "static/images/defaultnhmap.jpg";
                                      }}
                                    />
                                  </a>
                                ) : (
                                  <a
                                    href={"/Neighborhood/?id=" + item.id}
                                    className="nh_imgs"
                                    target="_blank"
                                  >
                                    <Item.Image
                                      className="nhpannel_img"
                                      src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/defaultnhmap.jpg`}
                                    />
                                  </a>
                                )}
                                <Item.Content className="right_content_top">
                                  {!this.state.single_display ? (
                                    <Icon
                                      name="minus circle"
                                      size="small"
                                      onClick={this.handlesingleiconClick}
                                    />
                                  ) : (
                                    <Icon
                                      name="plus circle"
                                      size="small"
                                      onClick={this.handlesingleiconClick}
                                    />
                                  )}
                                  <a
                                    href={"/Neighborhood/?id=" + item.id}
                                    style={{ cursor: "pointer" }}
                                    target="_blank"
                                  >
                                    <Item.Header className="nhpannel_head">
                                      {item.name}
                                    </Item.Header>
                                  </a>

                                  <Item.Description>
                                    {!this.state.single_display ? (
                                      <>
                                        <p className="nhpannel_npi">
                                          <span className="select_score">
                                            Overall
                                          </span>{" "}
                                          : <span>{npiscore}</span>
                                        </p>
                                        <p className="nhpannel_npi">
                                          <span className="select_score">
                                            Value
                                          </span>{" "}
                                          : <span>{valuescore}</span>
                                          {valuedata > 0 ? (
                                            <span className="overval">
                                              Overvalued
                                            </span>
                                          ) : valuedata < 0 ? (
                                            <span className="underval">
                                              Undervalued
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </p>
                                        <p className="nhpannel_npi">
                                          <span className="select_score">
                                            School
                                          </span>{" "}
                                          : <span>{schoolscore}</span>
                                        </p>

                                        <p className="nhpannel_npi">
                                          <span className="select_score">
                                            Safety
                                          </span>{" "}
                                          : <span>{crimescore}</span>
                                        </p>

                                        <p className="nhpannel_npi">
                                          <span className="select_score">
                                            Amenities
                                          </span>{" "}
                                          : <span>{amenitiesscore}</span>
                                        </p>

                                        <p className="nhpannel_npi">
                                          <span className="select_score">
                                            Near Merchants
                                          </span>{" "}
                                          : <span>{townctrscore}</span>
                                        </p>

                                        <p className="nhpannel_npi">
                                          <span className="select_score">
                                            Public Spaces
                                          </span>{" "}
                                          : <span>{publicscore}</span>
                                        </p>

                                        <p className="nhpannel_npi">
                                          <span className="select_score">
                                            Curb Appeal
                                          </span>{" "}
                                          : <span>{curbscore}</span>
                                        </p>

                                        <p className="nhpannel_npi">
                                          <span className="select_score">
                                            Personal
                                          </span>{" "}
                                          : <span>{personalscore}</span>
                                        </p>
                                      </>
                                    ) : (
                                      <>
                                        <p className="nhpannel_npi">
                                          <span className="select_score">
                                            Overall
                                          </span>{" "}
                                          : <span>{npiscore}</span>
                                        </p>
                                      </>
                                    )}

                                    {this.state.summarydisplay ? (
                                      <>
                                        <p className="slected_desc">
                                          {final_summary}
                                          <span
                                            className="summarylessmore"
                                            onClick={(e) =>
                                              this.handlesinglesummaryClick(
                                                e,
                                                final_summary_index
                                              )
                                            }
                                          >
                                            {" "}
                                            ...Less
                                          </span>
                                        </p>
                                      </>
                                    ) : (
                                      <>
                                        {final_summary != "" ? (
                                          <>
                                            {final_summary.length > 54 ? (
                                              <p className="slected_desc">
                                                {final_summary
                                                  .split(" ")
                                                  .splice(0, 12)
                                                  .join(" ")}
                                                <span
                                                  className="summarylessmore"
                                                  onClick={(e) =>
                                                    this.handlesinglesummaryClick(
                                                      e,
                                                      final_summary_index
                                                    )
                                                  }
                                                >
                                                  {" "}
                                                  ...
                                                </span>
                                              </p>
                                            ) : (
                                              <p className="slected_desc">
                                                {final_summary}
                                              </p>
                                            )}
                                          </>
                                        ) : (
                                          <p className="slected_desc">
                                            
                                          </p>
                                        )}
                                      </>
                                    )}

                                  
                                  </Item.Description>
                                </Item.Content>
                                <div
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    width: "100%",
                                    height: "auto",
                                  }}
                                >
                                  <>
                                    {" "}
                                    {this.props.heart[item.id] ? (
                                      <span
                                        onClick={(e) =>
                                          this.props.save(
                                            item.id,
                                            item,
                                            "select"
                                          )
                                        }
                                      >
                                        <Icon
                                          size="big"
                                          name="heart"
                                          // color="#c02e26"
                                          style={{
                                            color: "#c02e26",
                                            position: "absolute",
                                            top: "8px",
                                            left: "2px",
                                            fontSize: "18px",
                                            cursor: "pointer",
                                          }}
                                        />
                                      </span>
                                    ) : (
                                      <span
                                        onClick={(e) =>
                                          this.props.save(
                                            item.id,
                                            item,
                                            "select"
                                          )
                                        }
                                      >
                                        <Icon
                                          size="big"
                                          name="heart outline"
                                          style={{
                                            color: "white",
                                            position: "absolute",
                                            top: "8px",
                                            left: "2px",
                                            fontSize: "18px",
                                            cursor: "pointer",
                                          }}
                                        />
                                      </span>
                                    )}
                                  </>
                                </div>
                              </Item>
                            ) : (
                              <Item
                                key={(Date.now() + item.id + index).toString()}
                                style={{ position: "relative" }}
                              >
                                <Link>
                                  <a
                                    style={{
                                      cursor: "pointer",
                                      marginRight: 20,
                                    }}
                                    target="_blank"
                                  >
                                    <Item.Image
                                      className="nhpannel_img"
                                      src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/defaultnhmap.jpg`}
                                    />
                                  </a>
                                </Link>
                                <Item.Content className="right_content_top">
                                  <Link>
                                    <a
                                      // href={"/Neighborhood/?id=" + nhid}
                                      style={{ cursor: "pointer" }}
                                      target="_blank"
                                    >
                                      <Item.Header className="nhpannel_head">
                                        {item.name !== undefined
                                          ? item.name
                                          : "Not available"}
                                      </Item.Header>
                                    </a>
                                  </Link>
                                  <Item.Description className="nhmap_item-desc">
                                    <p>Coming soon</p>
                                  </Item.Description>
                                </Item.Content>
                              </Item>
                            )}
                          </div> */}
                        </div>
                      );
                    }
                  })}
                {Array.isArray(this.state.singlehome) &&
                  this.state.singlehome.length !== 0 &&
                  this.state.singlehome.map((item, index) => {
                    if (index === 0) {
                      let finaladd;
                      let finaladdsec;
                      let bathtotal;
                      let price;
                      let media;
                      let zipcode;
                      if (item.MlsStatus === "Sold") {
                        if (Number.isInteger(item.ClosePrice)) {
                          price = "$" + humanFormat(item.ClosePrice);
                        } else {
                          price = item.ClosePrice;
                        }
                      } else {
                        if (Number.isInteger(item.ListPrice)) {
                          price = "$" + humanFormat(item.ListPrice);
                        } else {
                          price = item.ListPrice;
                        }
                      }
                      if (item.UnparsedAddress) {
                        finaladd =
                          this.formatStreetName(item.UnparsedAddress) +
                          ", " +
                          item.City.replace(/([a-z])([A-Z])/g, "$1 $2") +
                          ", " +
                          item.StateOrProvince;
                        // +
                        // ", " +
                        // item.PostalCode;

                        //zipcode = item.PostalCode;
                      }
                      if (item.BathroomsHalf) {
                        bathtotal =
                          item.BathroomsFull + item.BathroomsHalf * 0.5;
                      } else {
                        bathtotal = item.BathroomsFull;
                      }
                      if (item.SourceId) {
                        if (item.ThumbnailUrl) {
                          media = item.ThumbnailUrl;
                        } else {
                          media =
                            process.env.NEXT_PUBLIC_CDN_ID +
                            "static/images/homedefault.jpg";
                        }
                      } else {
                        if (item.Media && item.Media.length > 0) {
                          media = item.Media[0].MediaURL;
                        } else {
                          media =
                            process.env.NEXT_PUBLIC_CDN_ID +
                            "static/images/homedefault.jpg";
                        }
                      }
                      return (
                        <div
                          class="school_popup home_popup_map"
                          id="school_right_popup"
                        >
                          <div
                            className={
                              !this.state.isMobile
                                ? `school-data-close-desktop school-data-close`
                                : `school-data-close`
                            }
                          >
                            <VscChromeClose
                              onClick={() => this.setState({ singlehome: [] })}
                            />
                          </div>
                          <Item
                            key={index}
                            style={{ margin: "0px 0px 0px 0px" }}
                          >
                            <Item.Content>
                              <Item.Description>
                                <div
                                  className="ui fluid image"
                                  style={{ height: "230px" }}
                                >
                                  <Link
                                    href={
                                      "/DetailsListing/?id=" +
                                      item.ListingKeyNumeric
                                    }
                                    target="_blank"
                                    style={{
                                      cursor: "pointor",
                                      height: "inherit",
                                    }}
                                  >
                                    {/* <a
                                      style={{
                                        cursor: "pointor",
                                        height: "inherit",
                                      }}
                                      target="_blank"
                                    > */}
                                    <Image
                                      style={{ height: "inherit" }}
                                      src={media}
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src =
                                          process.env.NEXT_PUBLIC_CDN_ID +
                                          "static/images/homedefault.jpg";
                                      }}
                                      title=""
                                      alt=""
                                    />
                                    {/* </a> */}
                                  </Link>
                                  <div
                                    style={{
                                      position: "absolute",
                                      bottom: 0,
                                      width: "100%",
                                      height: "auto",
                                      color: "white",
                                      background: "rgba(55, 55, 54, 0.8)",
                                    }}
                                  >
                                    <Link
                                      href={
                                        "/DetailsListing/?id=" +
                                        item.ListingKeyNumeric
                                      }
                                      target="_blank"
                                      style={{ color: "#FFF" }}
                                    >
                                      {/* <a
                                        target="_blank"
                                        style={{ color: "#FFF" }}
                                      > */}
                                      <Grid style={{ padding: 10 }}>
                                        <Grid.Column
                                          width={8}
                                          style={{
                                            paddingTop: "5px",
                                            paddingBottom: "5px",
                                            paddingRight: "0px",
                                          }}
                                        >
                                          <Grid.Row>
                                            <span className="home_price_main">
                                              <strong>{price}</strong>
                                            </span>
                                          </Grid.Row>
                                          <Grid.Row
                                            style={{
                                              fontSize: "13px",
                                              lineHeight: "14px",
                                            }}
                                          >
                                            {finaladd}
                                            <br />
                                            {finaladdsec}
                                          </Grid.Row>
                                          {/*<Grid.Row>{item.address.city}, {item.address.state} {item.address.zip}</Grid.Row>*/}
                                        </Grid.Column>
                                        <Grid.Column
                                          width={8}
                                          style={{
                                            paddingTop: "5px",
                                            paddingBottom: "5px",
                                          }}
                                        >
                                          <Grid
                                            divided
                                            style={{
                                              padding: 10,
                                              textAlign: "center",
                                            }}
                                          >
                                            <Grid.Column width={5}>
                                              <Grid.Row>
                                                {item.BedroomsTotal !==
                                                undefined
                                                  ? item.BedroomsTotal
                                                  : "-"}
                                              </Grid.Row>
                                              <Grid.Row>Beds</Grid.Row>
                                            </Grid.Column>
                                            <Grid.Column width={5}>
                                              <Grid.Row>
                                                {bathtotal ? bathtotal : "-"}
                                              </Grid.Row>
                                              <Grid.Row>Baths</Grid.Row>
                                            </Grid.Column>
                                            <Grid.Column width={6}>
                                              <Grid.Row>
                                                {item.LivingArea !== undefined
                                                  ? item.LivingArea
                                                  : "-"}
                                              </Grid.Row>
                                              <Grid.Row>sq.ft.</Grid.Row>
                                            </Grid.Column>
                                          </Grid>
                                        </Grid.Column>
                                      </Grid>
                                      {/* </a> */}
                                    </Link>
                                  </div>
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      width: "100%",
                                      height: "auto",
                                    }}
                                  >
                                    <Grid style={{ padding: 10 }}>
                                      <Grid.Column width={9}>
                                        {/*<Grid.Row style={{backgroundColor: 'green', textAlign: 'center', color: 'white'}}>Open SUN 1PM to*/}
                                        {/*4 PM</Grid.Row>*/}
                                      </Grid.Column>
                                      <Grid.Column floated="right" width={3}>
                                        <Grid.Row></Grid.Row>
                                      </Grid.Column>
                                    </Grid>
                                  </div>
                                </div>
                              </Item.Description>
                            </Item.Content>
                          </Item>
                        </div>
                      );
                    }
                  })}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      )
    );
  }
}

Map.propTypes = {
  addressInfo: PropTypes.any.isRequired,
};

export default Map;
